import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './LeadDetails.css';
import {
    X, Phone, Mail, MapPin, Calendar, Clock, ChevronDown, ChevronRight,
    MoreVertical, Pencil, Trash2, Plus, MessageCircle, Info, Check, Filter,
    ArrowRight, User, Globe, Share2, Download, Eye, Play, Paperclip, Send, Smartphone, ChevronLeft, ChevronUp, Camera, Search, MoreHorizontal, GitBranch, MessageSquare, Mic, Users, UserPlus, PhoneCall, LayoutGrid, Video, Copy, RotateCcw, Link
} from 'lucide-react';
import Alert from '../../../../common/Alerts/Alert';
import { Clock as ClockIcon } from 'lucide-react';
import API_ENDPOINTS, { BASES } from '../../../../config/apiEndpoints';
import Enquiryoperations from './Enquiryoperations';
import EnquiryActionOperation from '../EnquiryActionOperation';
import LeadActionOperation from '../../../../common/LeadActionOperation/LeadActionOperation';
import Loader from '../../../../components/Loader/Loader';
import { getSession } from '../../../../getSession';
import CallWidget from '../../../../components/common/CallWidget/CallWidget';
import usePermissions from '../../../Master_Settings/usePermissions';
import { bindSourceMediumCampaign } from '../../../../utils/lead';

const LeadDetails = ({ leadId, onBack, isopen, saveEditToken, maskObject = val => val, isHiddenField = () => false }) => {
    const followupDateRef = useRef(null);
    const tagInputRef = useRef(null);
    const [tagInput, setTagInput] = useState('');
    const isLead = String(isopen).toLowerCase() === 'false' || isopen === false;

    const { permissions } = usePermissions('PAG10002');
    const crmOperationPerms = React.useMemo(() => {
        if (!permissions || !Array.isArray(permissions)) return null;
        return permissions.find(p => p.ModuleCode?.includes('PAG10002')) || {};
    }, [permissions]);

    const [basicInfo, setBasicInfo] = useState({});
    const [scoreCard, setScoreCard] = useState({});
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hoverScoreRec, setHoverScoreRec] = useState(null);
    const [isScorecardLoading, setIsScorecardLoading] = useState(false);
    const [showActivities, setShowActivities] = useState(true);
    const [hoveredLeadId, setHoveredLeadId] = useState(null);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const scorecardTimerRef = useRef(null);

    // Tab states
    const [activeTab, setActiveTab] = useState('Activities');
    const [customFieldsList, setCustomFieldsList] = useState([]);
    const [alert, setAlert] = useState({ show: false, type: 'success', title: '', message: '' });
    const [loadingFields, setLoadingFields] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [showMoreBasic, setShowMoreBasic] = useState(false); // Can keep for other purposes or remove
    const [showMoreDetails, setShowMoreDetails] = useState(false);
    const [isFullDetailsOpen, setIsFullDetailsOpen] = useState(false);

    // History data states
    const [chatLogs, setChatLogs] = useState([]);
    const [waChatLogs, setWaChatLogs] = useState([]);
    const [callLogs, setCallLogs] = useState([]);
    const [pastMeetings, setPastMeetings] = useState([]);
    const [upcomingMeetings, setUpcomingMeetings] = useState([]);
    const [taskHistory, setTaskHistory] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [notes, setNotes] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [followupDetails, setFollowupDetails] = useState([]);
    const [pipelineHistory, setPipelineHistory] = useState([]);
    const [webforms, setWebforms] = useState([]);
    const [meetingSubTab, setMeetingSubTab] = useState('Upcoming');
    const [openMenuId, setOpenMenuId] = useState(null);

    // Loading states for tabs
    const [isLogLoading, setIsLogLoading] = useState(false);
    const [isWebformLoading, setIsWebformLoading] = useState(false);
    const [isTaskHistoryLoading, setIsTaskHistoryLoading] = useState(false);
    const [isApptHistoryLoading, setIsApptHistoryLoading] = useState(false);
    const [isNotesLoading, setIsNotesLoading] = useState(false);
    const [isDocsLoading, setIsDocsLoading] = useState(false);
    const [isFollowupLoading, setIsFollowupLoading] = useState(false);
    const [isPipelineLoading, setIsPipelineLoading] = useState(false);
    const [physicalAppointments, setPhysicalAppointments] = useState([]);
    const [isPhysicalApptLoading, setIsPhysicalApptLoading] = useState(false);

    // New API data states
    const [enquiryDetailData, setEnquiryDetailData] = useState([]);
    const [customDetailMoreData, setCustomDetailMoreData] = useState([]);
    const [isEnquiryDetailLoading, setIsEnquiryDetailLoading] = useState(false);
    const [isCustomMoreLoading, setIsCustomMoreLoading] = useState(false);
    // Sidebar Form states
    const [activeSidebarAction, setActiveSidebarAction] = useState(null); // 'Centralized', 'AddFollowup', etc.
    const [centralizedMode, setCentralizedMode] = useState(null); // 'followup', 'mail', etc.

    // Local Followup States
    const [localFollowupData, setLocalFollowupData] = useState({
        Status: '1290',
        AssignedTo: localStorage.getItem('userId') || '34594',
        Date: new Date().toISOString().split('T')[0],
        Time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        Remarks: '',
        Products: '',
        IsReAssign: false
    });
    const [followupStatuses, setFollowupStatuses] = useState([]);
    const [assignedToOptions, setAssignedToOptions] = useState([]);
    const [isLocalDataLoading, setIsLocalDataLoading] = useState(false);
    const [selectedLocalProducts, setSelectedLocalProducts] = useState([]);
    const [selectedEditProducts, setSelectedEditProducts] = useState([]);
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [suggestedProducts, setSuggestedProducts] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);

    // Merge UI states
    const [isMergeUIOpen, setIsMergeUIOpen] = useState(false);
    const [selectedMergeLead, setSelectedMergeLead] = useState(null);
    const [mergeLeads, setMergeLeads] = useState([]);
    const [mergeFieldSelections, setMergeFieldSelections] = useState({});
    const [mergeForm, setMergeForm] = useState({});
    const [conflictLeads, setConflictLeads] = useState([]);
    const [selectedConflictId, setSelectedConflictId] = useState('');
    const [isMerging, setIsMerging] = useState(false);
    const [mergeStep, setMergeStep] = useState('merge'); // 'merge' or 'followup'
    const [isScheduleCallOpen, setIsScheduleCallOpen] = useState(false);
    const [isCallWidgetOpen, setIsCallWidgetOpen] = useState(false);
    const [callWidgetData, setCallWidgetData] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editForm, setEditForm] = useState({
        PersonName: '',
        Company: '',
        Mobile1: '',
        Email1: '',
        Country: '',
        State: '',
        City: '',
        CountryId: '',
        StateId: '',
        CityId: '',
        Source: '',
        Medium: '',
        Campaign: '',
        ResiAddress: '',
        OfficeAddress: '',
        Remarks: ''
    });
    const [profileFile, setProfileFile] = useState(null);
    const [customFieldsData, setCustomFieldsData] = useState({});
    const [countries, setCountries] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [isLocationLoading, setIsLocationLoading] = useState(false);
    const [dynamicCountries, setDynamicCountries] = useState([]);
    const [selectedDialCode, setSelectedDialCode] = useState('+91');
    const [selectedFlag, setSelectedFlag] = useState('https://flagcdn.com/w320/in.png');
    const [showDialCodeList, setShowDialCodeList] = useState(false);
    const [dialSearchTerm, setDialSearchTerm] = useState('');
    const [mobiles, setMobiles] = useState([{ number: '', dialCode: '+91', flag: 'https://flagcdn.com/w320/in.png', showDropdown: false }]);
    const [emails, setEmails] = useState(['']);
    const [courseOptions, setCourseOptions] = useState([]);
    const [courseDependency, setCourseDependency] = useState([]);
    const [sourceOptions, setSourceOptions] = useState([]);
    const [mediumOptions, setMediumOptions] = useState([]);
    const [campaignOptions, setCampaignOptions] = useState([]);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    // Field management helpers (Sync with AddEnquiryForm)
    const addMobileField = () => { if (mobiles.length < 3) setMobiles([...mobiles, { number: '', dialCode: '+91', flag: 'https://flagcdn.com/w320/in.png', showDropdown: false }]); };
    const addEmailField = () => { if (emails.length < 3) setEmails([...emails, '']); };
    const updateMobile = (index, key, value) => { const newMobiles = [...mobiles]; newMobiles[index][key] = value; setMobiles(newMobiles); };
    const updateEmail = (index, value) => { const newEmails = [...emails]; newEmails[index] = value; setEmails(newEmails); };
    const removeMobileField = (index) => { if (mobiles.length > 1 && index > 0) setMobiles(mobiles.filter((_, i) => i !== index)); };
    const removeEmailField = (index) => { if (emails.length > 1 && index > 0) setEmails(emails.filter((_, i) => i !== index)); };
    const toggleMobileDropdown = (index, state) => { const newMobiles = [...mobiles]; newMobiles.forEach((m, i) => { if (i !== index) m.showDropdown = false; }); newMobiles[index].showDropdown = state !== undefined ? state : !newMobiles[index].showDropdown; setMobiles(newMobiles); };

    // Add Lead Form States
    const [addLeadForm, setAddLeadForm] = useState({
        PersonName: '',
        Company: '',
        Mobile1: '',
        Email1: '',
        Country: '',
        State: '',
        City: '',
        Source: '',
        Medium: '',
        Campaign: '',
        ResiAddress: '',
        OfficeAddress: '',
        Remarks: '',
        PinCode: '0',
        EnquiryTags: ''
    });
    const [addLeadCustomFields, setAddLeadCustomFields] = useState({});
    const [isAdvancedAddLead, setIsAdvancedAddLead] = useState(false);
    const [profileFileAdd, setProfileFileAdd] = useState(null);
    const [profilePreviewAdd, setProfilePreviewAdd] = useState(null);
    const [isSavingAddLead, setIsSavingAddLead] = useState(false);

    // --- Communication Panel States ---
    const [smsData, setSmsData] = useState({ senderId: '', message: '', templateId: '0', isUnicode: false, chooseNumbers: [] });
    const [mailData, setMailData] = useState({ account: '', from: '', replyTo: '', to: [], subject: '', body: '', templateId: '0', mailMode: 'compose' });
    const [voiceData, setVoiceData] = useState({ route: 'trans', appFlow: '', dnid: '', chooseNumbers: [] });
    const [meetingData, setMeetingData] = useState({ subject: '', type: '', date: new Date().toISOString().split('T')[0], time: '', duration: '30', description: '', collaborators: [], owner: localStorage.getItem('userId') || '34594' });
    const [appointmentData, setAppointmentData] = useState({ title: '', type: '', startDate: new Date().toISOString().split('T')[0], startTime: '', endDate: new Date().toISOString().split('T')[0], endTime: '', where: '', remarks: '', collaborators: [], owner: localStorage.getItem('userId') || '34594' });
    const [activitySearchTerm, setActivitySearchTerm] = useState('');

    // New Meeting Form States (Refined)
    const [meetingForm, setMeetingForm] = useState({
        TemplateId: '',
        MeetingName: '',
        StartDateTime: new Date(),
        EndDateTime: new Date(new Date().getTime() + 60 * 60000), // Default 1 hour
        Timezone: 'India Standard Time',
        IsRecurring: false,
        RepeatType: 'daily',
        RepeatEvery: '1',
        EndsOnType: 'never',
        EndsOnDate: null,
        EndsAfterTimes: '10',
        HostId: localStorage.getItem('userId') || '34594',
        AddCoHost: false,
        CoHostId: '',
        Participants: [],
        allowrec: true,
        autorec: false,
        sendrec: false,
        dsblmicusers: false,
        dsblpblcchat: false,
        dsblprvtcht: false,
        muteonstart: false,
        alwhstclscmra: false,
        alwhstunmute: false,
        webcamonlyfohost: false,
        audiojoin: false,
        invitebymail: false,
        invitemailsubject: '',
        invitemailtext: '',
        remindbymail: false,
        remindmailsubject: '',
        remindmailtext: '',
        sendchat: false,
        showSection_recording: false,
        showSection_audio: false,
        showSection_chat: false,
        showSection_invite: false,
        showSection_reminder: false
    });
    const [meetingSettings, setMeetingSettings] = useState([]);
    const [hostOptions, setHostOptions] = useState([]);
    const [coHostOptions, setCoHostOptions] = useState([]);
    const [coHostSearch, setCoHostSearch] = useState('');
    const [participantSearch, setParticipantSearch] = useState('');

    useEffect(() => {
        fetchSourceOptions();
        fetchMediumOptions();
        fetchCampaignOptions();
        fetchFields();
        fetchUsersList();
    }, []);

    const [participantOptions, setParticipantOptions] = useState([]);
    const [isMeetingSubmitting, setIsMeetingSubmitting] = useState(false);
    const [templateDetails, setTemplateDetails] = useState(null);
    const [hostSearch, setHostSearch] = useState('');
    // Consolidation of constants and environment variables
    const { tokenId: SESSION_TOKEN_ALT, TokenId: TOKEN_ID, userId: LOGGED_USER_ID, parentId: PARENT_ID } = getSession();
    const TOKEN = TOKEN_ID || localStorage.getItem('TokenId') || '-2295521862261168';

    const WCF_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const NEW_BASE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const SERVICE_AZURE_URL = (BASES.SERVICES_AZURE || '').replace(/\/$/, '');
    const NEW_ADDED_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const SERVICE_AZURE_URL_DEVE_1 = (process.env.REACT_APP_BACKEND_BASEURL_FOR_DEVELOPMENT_STAGE1 || '').replace(/\/$/, '');
    const API_BASE1 = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const LOCAL_BASE_URL = "http://localhost:62194/";
    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');


    // API URLs 
    const Get_Enquiry_Data = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.ENQUIRY_DETAILS_LIST}`;
    const Get_Meeting_Setting_List = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_MEETING_SETTING}`;
    const Get_Meeting_Host = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_MEETING_HOST}`;
    const Edit_Meeting_Setting = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.EDIT_MEETING_SETTING}`;
    const Insert_New_Task_Or_Appointment = `${WCF_BASE}${API_ENDPOINTS.TASKS.INSERT_NEW_TASK_OR_APPOINTMENT}`;

    const Custome_Data_More = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.CUSTOME_DATA_MORE}`;
    const Get_Country = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetCountry`;
    const Get_State = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetStateByCountry`;
    const Get_City_By_State = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetCityByState`;
    const Save_Enquiry_With_Location = `${SERVICE_AZURE_URL_DEVE_1}${API_ENDPOINTS.ENQUIRIES.SAVE_ENQUIRY_WITH_LOCATION}`;
    const Get_User_List = `${NEWV3_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;
    const Get_Lead_Confliction = `${API_BASE1}${API_ENDPOINTS.ENQUIRIES.GET_LEAD_CONFLICT}`;
    const GET_FOLLOWUP_LIST = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.FOLLOWUPSTATUS_LIST}`;
    const GET_USER_HIRERARCHY = `${NEW_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
    const PRODUCT_SUGGESTION = `${SERVICE_AZURE_URL}/${API_ENDPOINTS.APPOINTMENTS.PRODUCT_SUGGESTION_FOR_FOLLOWUP}`;
    const NEWV3_BASE_URL_INTERNAL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const Get_Course = `${NEWV3_BASE_URL_INTERNAL}${API_ENDPOINTS.FOLLOWUPS.GET_CENTER_OF_EDUCATION_EDIT}`;
    const Enquiry_ShowWData = `${API_BASE1}${API_ENDPOINTS.ENQUIRIES.ENQUIRY_DEATILS}`;
    const Get_Lead_Custom_Data = `${API_BASE1}${API_ENDPOINTS.ENQUIRIES.GET_LEAD_CUSTOM_DATA}`;
    const Save_Enquiry_Followup = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.SAVE_ADD_LEAD_OR_MERGE}`;
    const Delete_Enquiry_Details = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.DELETE_ENQUIRY_DETAILS}`;
    const Merge_To_Lead = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.MERGE_TO_LEAD}`;
    const Update_Enquiry = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.ENQUIRIES.SAVE_ENQUIRY_WITH_LOCATION}`;
    const Get_Lead_Details = `${WCF_BASE}${API_ENDPOINTS.COMMON.GET_LEAD_DETAILS_WITH_CUSTOM}`;
    const Get_Lead_Details_New = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.GET_LEAD_DETAILS_NEW}`;
    const Get_Activity_New = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_ENQIURY_ACTIVITY}`;


    // --- Communication Options ---
    const [senderIdOptions, setSenderIdOptions] = useState([]);
    const [emailAccountOptions, setEmailAccountOptions] = useState([]);
    const [fromEmailOptions, setFromEmailOptions] = useState([]);
    const [smsTemplates, setSmsTemplates] = useState([]);
    const [mailTemplates, setMailTemplates] = useState([]);
    const [isCommLoading, setIsCommLoading] = useState(false);

    const getAvatarContent = (name, mobile) => {
        if (name && name !== '-' && name.trim().length > 0) {
            const parts = name.trim().split(/\s+/);
            if (parts.length >= 2) {
                return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
            } else if (parts.length === 1) {
                return parts[0].substring(0, 2).toUpperCase();
            }
        }
        if (mobile && mobile !== '-' && mobile.trim().length > 0) {
            const digits = mobile.replace(/\D/g, '');
            if (digits.length >= 2) {
                return digits.substring(0, 2);
            }
        }
        return <User size={40} color="#cbd5e0" />;
    };

    const MERGE_FIELDS = React.useMemo(() => {
        const baseFields = [
            { label: 'Person Name', key: 'PersonName' },
            { label: 'Company', key: 'Company' },
            { label: 'Mobile', key: 'Mobile' },
            { label: 'Mobile 1', key: 'Mobile1' },
            { label: 'Mobile 2', key: 'Mobile2' },
            { label: 'Email', key: 'Email' },
            { label: 'Email 1', key: 'Email1' },
            { label: 'Email 2', key: 'Email2' },
            { label: 'Country', key: 'Country' },
            { label: 'State', key: 'State' },
            { label: 'City', key: 'City' },
            { label: 'Source', key: 'Source' },
            { label: 'Medium', key: 'Medium' },
            { label: 'Campaign', key: 'Campaign' },
            { label: 'Resi. Address', key: 'ResiAddress' },
            { label: 'Office Address', key: 'OfficeAddress' }
        ];

        const dynamicFields = customFieldsList.map(f => ({
            label: f.label,
            key: String(f.key), // Stores the numeric ID to send to the backend
            dataKey: f.label.replace(/\s+/g, '_') // Maps to the API response key
        }));

        return [...baseFields, ...dynamicFields];
    }, [customFieldsList]);

    const handleSelectAll = (source) => {
        const newForm = { ...mergeForm };
        const newSelections = { ...mergeFieldSelections };
        MERGE_FIELDS.forEach(f => {
            const val = source === 'enquiry' ? getEnquiryFieldValue(f.key) : (selectedMergeLead?.[f.key] || selectedMergeLead?.[f.dataKey] || '-');
            newForm[f.key] = (val === '-' || !val) ? '' : val;
            newSelections[f.key] = source;
        });
        setMergeForm(newForm);
        setMergeFieldSelections(newSelections);
    };

    useEffect(() => {
        if (isMergeUIOpen) {
            const targetId = basicInfo?.EnquiryId || leadId;
            console.log("Merge UI Opened. Triggering conflict fetch for:", targetId);
            if (targetId) {
                fetchLeadConflicts(targetId);
            }

            // Re-initialize form with enquiry data
            const initialForm = {};
            const initialSelections = {};
            MERGE_FIELDS.forEach(f => {
                const val = getEnquiryFieldValue(f.key);
                initialSelections[f.key] = 'enquiry';
                initialForm[f.key] = (val === '-' || !val) ? '' : val;
            });
            setMergeFieldSelections(initialSelections);
            setMergeForm(initialForm);
        }
    }, [isMergeUIOpen, MERGE_FIELDS]);

    useEffect(() => {
        if (activeSidebarAction === 'AddFollowup') {
            fetchLocalFollowupData();
        }
    }, [activeSidebarAction]);

    const getEnquiryFieldValue = (key) => {
        if (!key) return '';
        const lowerKey = String(key).toLowerCase();

        // Handle standard mapping keys with basicInfo (populated from new API)
        if (key === 'CreatedOn' || lowerKey === 'createdon' || lowerKey === 'created_on' || lowerKey === 'created date') return basicInfo?.CreatedOn || '';
        if (key === 'Source' || lowerKey === 'source' || lowerKey === 'sourcename') return basicInfo?.SourceName || '';
        if (key === 'Medium' || lowerKey === 'medium' || lowerKey === 'mediumname') return basicInfo?.MediumName || '';
        if (key === 'Campaign' || lowerKey === 'campaign' || lowerKey === 'campaignname') return basicInfo?.CampaignName || '';
        if (key === 'CreatedBy' || lowerKey === 'createdby' || lowerKey === 'created_by' || lowerKey === 'user_login') return basicInfo?.CreatedByName || '';
        if (key === 'ResiAddress' || lowerKey === 'resiaddress' || lowerKey === 'resi. address') return basicInfo?.ResidentialAddress || '';
        if (key === 'OfficeAddress' || lowerKey === 'officeaddress' || lowerKey === 'office address') return basicInfo?.OfficeAddress || '';
        if (key === 'Remarks' || lowerKey === 'remarks' || lowerKey === 'initialremarks') return basicInfo?.Remarks || '';
        if (key === 'LastUpdated' || lowerKey === 'lastupdated' || lowerKey === 'last updated') return basicInfo?.ModifiedOn || '';
        if (key === 'Mobile' || lowerKey === 'mobile') return basicInfo?.MobileNo || '';
        if (key === 'Email' || lowerKey === 'email') return basicInfo?.EmailID || '';
        if (key === 'State' || lowerKey === 'state') return basicInfo?.State || basicInfo?.StateName || '';
        if (key === 'AssignedTo' || lowerKey === 'assignedto' || lowerKey === 'assigned to') return basicInfo?.assigneduser || '';

        // Check customFieldsData by exact key (ID or Name)
        if (customFieldsData[key] && customFieldsData[key] !== 'N/A' && customFieldsData[key] !== '0') return customFieldsData[key];

        // Fallback: Check if the key corresponds to a label in MERGE_FIELDS
        const fieldDef = MERGE_FIELDS.find(f => String(f.key).toLowerCase() === lowerKey || String(f.label).toLowerCase() === lowerKey);
        const label = fieldDef ? fieldDef.label : key;

        const possibleKeys = [label, label.toLowerCase(), label.replace(/\s+/g, ''), label.replace(/\s+/g, '_'), label.replace(/\s+/g, ' ')];
        for (const pk of possibleKeys) {
            if (customFieldsData[pk] && customFieldsData[pk] !== 'N/A' && customFieldsData[pk] !== '0') return customFieldsData[pk];
            if (basicInfo[pk] && basicInfo[pk] !== 'N/A' && basicInfo[pk] !== '0') return basicInfo[pk];
        }

        return customFieldsData[key] || '';
    };

    const handleEnterEdit = async () => {
        setIsEditing(true);

        let currentCountries = countries;
        if (!currentCountries || currentCountries.length === 0) {
            try {
                const response = await fetch(Get_Country, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: {} })
                });
                if (response.ok) {
                    const result = await response.json();
                    currentCountries = result.d || result.Details || [];
                    setCountries(currentCountries);
                }
            } catch (e) { console.error("Error fetching countries:", e); }
        }

        const mappedCountryId = getMappedId(basicInfo.Country, currentCountries);
        const mappedSource = getMappedId(basicInfo.SourceID || basicInfo.SourceName, sourceOptions);
        const mappedMedium = getMappedId(basicInfo.MediumID || basicInfo.MediumName, mediumOptions);
        const mappedCampaign = getMappedId(basicInfo.CampaignID || basicInfo.CampaignName, campaignOptions);

        let sId = '';
        let cId = '';

        if (mappedCountryId && mappedCountryId !== '0') {
            try {
                setIsLocationLoading(true);
                const response = await fetch(Get_State, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(mappedCountryId.toString(), 10) } })
                });
                if (response.ok) {
                    const result = await response.json();
                    const stateData = result.d || result.Details || [];
                    setStatesList(stateData);
                    sId = getMappedId(basicInfo.StateName || basicInfo.State, stateData);

                    if (sId && sId !== '0') {
                        const cityRes = await fetch(Get_City_By_State, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(sId.toString(), 10) } })
                        });
                        if (cityRes.ok) {
                            const cityResult = await cityRes.json();
                            const cityData = cityResult.d || cityResult.Details || [];
                            setCitiesList(cityData);
                            cId = getMappedId(basicInfo.City, cityData);
                        }
                    }
                }
            } catch (e) { console.error("Error loading location details:", e); }
            finally { setIsLocationLoading(false); }
        }

        setEditForm({
            PersonName: basicInfo.PersonName || '',
            Company: basicInfo.CompanyName || '',
            Mobile1: basicInfo.MobileNo || basicInfo.MobileNo1 || '',
            Email1: basicInfo.EmailID || basicInfo.EmailID1 || '',
            Country: basicInfo.Country || '',
            State: basicInfo.StateName || basicInfo.State || '',
            City: basicInfo.City || '',
            CountryId: mappedCountryId === '0' ? '' : mappedCountryId,
            StateId: sId === '0' ? '' : sId,
            CityId: cId === '0' ? '' : cId,
            Source: mappedSource === '0' ? '' : mappedSource,
            Medium: mappedMedium === '0' ? '' : mappedMedium,
            Campaign: mappedCampaign === '0' ? '' : mappedCampaign,
            ResiAddress: basicInfo.Residentialaddress || basicInfo.ResiAddress || basicInfo.resi_address || '',
            OfficeAddress: basicInfo.Officeaddress || basicInfo.office_address || basicInfo.officeaddress || '',
            Remarks: basicInfo.Initialremarks || basicInfo.Remarks || '',
            PinCode: basicInfo.Pincode || basicInfo.PinCode || basicInfo.pincode || '0',
            EnquiryTags: basicInfo.EnquiryTags || basicInfo.enquiry_tags || ''
        });

        // Initialize mobiles array from lead contact data with de-duplication
        const initialMobiles = [];
        const contactPhones = [
            { number: basicInfo.MobileNo || basicInfo.MobileNo1, dial: basicInfo.CountryCode1 || basicInfo.CountryCode || basicInfo.Countrycode },
            { number: basicInfo.MobileNo2, dial: basicInfo.CountryCode2 || basicInfo.CountryCode || basicInfo.Countrycode },
            { number: basicInfo.MobileNo3, dial: basicInfo.CountryCode3 || basicInfo.CountryCode || basicInfo.Countrycode }
        ];

        const seenMobiles = new Set();

        contactPhones.forEach(cp => {
            if (cp.number) {
                const trimmedNum = String(cp.number).trim();
                if (trimmedNum && trimmedNum !== "N/A" && trimmedNum !== "0" && trimmedNum !== "null") {
                    // Remove existing dial code from number if it's there
                    let cleanNum = trimmedNum;
                    let dCode = cp.dial ? (cp.dial.startsWith('+') ? cp.dial : `+${cp.dial}`) : '+91';

                    if (cleanNum.includes(' ')) {
                        const parts = cleanNum.split(' ');
                        dCode = parts[0];
                        cleanNum = parts.slice(1).join('');
                    } else if (cleanNum.startsWith('+')) {
                        // Try to match dial code from dynamicCountries
                        const matched = dynamicCountries.find(c => cleanNum.startsWith(c.dialCode));
                        if (matched) {
                            dCode = matched.dialCode;
                            cleanNum = cleanNum.replace(matched.dialCode, '');
                        }
                    }

                    const digits = cleanNum.replace(/\D/g, '');
                    if (digits && !seenMobiles.has(digits)) {
                        seenMobiles.add(digits);
                        const country = dynamicCountries.find(c => c.dialCode === dCode) || { flag: 'https://flagcdn.com/w320/in.png' };
                        initialMobiles.push({ number: cleanNum, dialCode: dCode, flag: country.flag, showDropdown: false });
                    }
                }
            }
        });

        if (initialMobiles.length === 0) {
            initialMobiles.push({ number: '', dialCode: '+91', flag: 'https://flagcdn.com/w320/in.png', showDropdown: false });
        }
        setMobiles(initialMobiles);

        // Initialize emails array with de-duplication
        const initialEmails = [];
        const seenEmails = new Set();
        [basicInfo.EmailID || basicInfo.EmailID1, basicInfo.EmailID2, basicInfo.EmailID3].forEach(email => {
            if (email && email !== "N/A" && email !== "0" && email.trim() !== "") {
                const normalizedEmail = email.trim().toLowerCase();
                if (!seenEmails.has(normalizedEmail)) {
                    seenEmails.add(normalizedEmail);
                    initialEmails.push(email.trim());
                }
            }
        });

        if (initialEmails.length === 0) {
            initialEmails.push('');
        }
        setEmails(initialEmails);

        const initialCustomFields = {};
        let editProds = [];
        customFieldsList.forEach(field => {
            const fieldId = field.key;
            let val = customFieldsData[fieldId] || basicInfo[fieldId] || '';

            if (!val || val === "N/A" || val === "0") {
                const label = field.label || '';
                const possibleKeys = [label, label.replace(/\s+/g, '_'), label.replace(/\s+/g, '')];
                for (const pk of possibleKeys) {
                    if (basicInfo[pk] && basicInfo[pk] !== "N/A" && basicInfo[pk] !== "0") {
                        val = basicInfo[pk];
                        break;
                    }
                }
            }

            initialCustomFields[fieldId] = val;

            // Initialize products if field ID is 8780
            if (fieldId === '8780' && initialCustomFields[fieldId]) {
                editProds = initialCustomFields[fieldId].split(/[#|]/).filter(p => p).map(p => ({ Value: p, Text: p }));
            }
        });
        setCustomFieldsData(initialCustomFields);
        setSelectedEditProducts(editProds);

        fetchCountries(); // Fetch initial countries list
        fetchDynamicCountries(); // Fetch flags and dial codes
        fetchSourceOptions();
        fetchMediumOptions();
        fetchCampaignOptions();
    };

    const handleCountryChange = (e) => {
        const countryId = e.target.value;
        const countryName = countries.find(c => String(c.Id) === countryId)?.Value || '';
        setEditForm(prev => ({
            ...prev,
            Country: countryName,
            CountryId: countryId,
            State: '',
            StateId: '',
            City: '',
            CityId: ''
        }));
        setStatesList([]);
        setCitiesList([]);
        if (countryId) fetchStates(countryId);
    };

    const handleStateChange = (e) => {
        const stateId = e.target.value;
        const stateName = statesList.find(s => String(s.Id) === stateId)?.Value || '';
        setEditForm(prev => ({
            ...prev,
            State: stateName,
            StateId: stateId,
            City: '',
            CityId: ''
        }));
        setCitiesList([]);
        if (stateId) fetchCities(stateId);
    };

    const handleCityChange = (e) => {
        const cityId = e.target.value;
        const cityName = citiesList.find(c => String(c.Id) === cityId)?.Value || '';
        setEditForm(prev => ({ ...prev, City: cityName, CityId: cityId }));
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setProfileFile(null);
        setCustomFieldsData({});
    };

    const formatDateToBackend = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        if (isNaN(d.getTime())) return "";
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };

    const formatDateToBackendShort = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        if (isNaN(d.getTime())) return String(date || "");
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateForDisplay = (dateStr) => {
        if (!dateStr || dateStr === '-') return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return `${String(d.getDate()).padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()}`;
    };

    const formatActivityDate = (dateStr) => {
        if (!dateStr || dateStr === "N/A" || dateStr === "null" || dateStr === "0") return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = date.getDate();
        const m = months[date.getMonth()];
        const y = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;

        return `${d}-${m}-${y} ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    const getMappedId = (currentVal, options) => {
        const v = currentVal?.toString() || "";
        if (!v || v === "0") return "0";
        // If it looks like a numeric ID, return it directly
        if (/^\d+$/.test(v)) return v;
        // Otherwise find by name (Text)
        const found = options.find(opt =>
            String(opt.Text || opt.Value || opt.Name || "").toLowerCase() === v.toLowerCase() ||
            String(opt.SrcmedCampName || "").toLowerCase() === v.toLowerCase()
        );
        return String(found?.Code || found?.SrcmedCampID || found?.Id || found?.Value || v);
    };

    const handleUpdateEdit = async () => {
        try {
            setIsSaving(true);
            const { parentId } = getSession();

            // Lookup IDs if we have names in the state
            const sourceId = getMappedId(editForm.Source, sourceOptions);
            const mediumId = getMappedId(editForm.Medium, mediumOptions);
            const campaignId = getMappedId(editForm.Campaign, campaignOptions);

            // Validation for dynamic mandatory fields
            for (const field of customFieldsList) {
                if (field.isMandatory) {
                    const val = customFieldsData[field.key];
                    if (!val || val === '' || val === '0' || (Array.isArray(val) && val.length === 0)) {
                        setAlert({
                            show: true,
                            type: 'error',
                            title: 'Required Field',
                            message: `Please fill the mandatory field: ${field.label}`
                        });
                        setIsSaving(false);
                        return;
                    }
                }
            }

            // Map custom fields to their IDs for lstCustomField
            const lstCustomField = customFieldsList.map(item => {
                let val = customFieldsData[item.key] || "";

                // If Product field (8780), join selected edit products
                if (String(item.key) === '8780') {
                    val = selectedEditProducts.map(p => p.Text || p.Value).join('#');
                }

                // If date type, format it to DD-MMM-YYYY
                if (item.type === 'date' && val) {
                    val = formatDateToBackendShort(val);
                }

                const valLower = String(val).toLowerCase();
                // Match AddEnquiryForm mapping: 7692 (Adult), 11919 (Education), 10546 (Gender)
                if (item.key === '7692' || item.key === '11919' || item.key === '10546') {
                    if (valLower === "yes" || valLower === "true" || valLower === "male") val = "1";
                    else if (valLower === "no" || valLower === "false" || valLower === "female") val = "0";
                    // Handle checkbox boolean
                    if (val === true) val = "1";
                    if (val === false) val = "0";
                }

                return {
                    FieldId: Number(item.key),
                    FieldValue: String(val)
                };
            });

            const enquiryDetails = {
                EnquiryId: Number(leadId),
                PersonName: editForm.PersonName,
                CompanyName: editForm.Company,
                // Mobile fields
                MobileNo1: mobiles[0]?.number ? `${mobiles[0].dialCode} ${mobiles[0].number}` : "",
                CountryCode1: mobiles[0]?.dialCode ? mobiles[0].dialCode.replace('+', '') : "",
                MobileNo2: mobiles[1]?.number ? `${mobiles[1].dialCode} ${mobiles[1].number}` : "",
                CountryCode2: mobiles[1]?.dialCode ? mobiles[1].dialCode.replace('+', '') : "",
                MobileNo3: mobiles[2]?.number ? `${mobiles[2].dialCode} ${mobiles[2].number}` : "",
                CountryCode3: mobiles[2]?.dialCode ? mobiles[2].dialCode.replace('+', '') : "",
                // Email fields
                EmailId1: (emails[0] === "N/A" || !emails[0]) ? "" : emails[0],
                EmailId2: (emails[1] === "N/A" || !emails[1]) ? "" : emails[1],
                EmailId3: (emails[2] === "N/A" || !emails[2]) ? "" : emails[2],
                City: editForm.City,
                State: editForm.State,
                CountryName: editForm.Country,
                ResidentialAddress: editForm.ResiAddress,
                OfficeAddress: editForm.OfficeAddress,
                Pincode: Number(editForm.PinCode) || 0,
                SourceName: String(sourceId || "0"),
                Medium: String(mediumId || "0"),
                Campaign: String(campaignId || "0"),
                InitialRemarks: editForm.Remarks,
                ParentId: Number(parentId),
                CreatedBy: Number(parentId),
                WhereLatitude: "",
                WhereLongitude: "",
                EnquiryTags: editForm.EnquiryTags || "",
                lstCustomField: lstCustomField
            };

            const payload = {
                Token: saveEditToken || TOKEN,
                Details: JSON.stringify(enquiryDetails)
            };

            const response = await fetch(Update_Enquiry, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1) {
                    setAlert({ show: true, type: 'success', title: 'Success', message: result.Details || 'Record Updated Successfully' });
                    setIsEditing(false);
                    fetchInitialData(); // Refresh data after save
                } else {
                    setAlert({ show: true, type: 'error', title: 'Error', message: result.Message || 'Failed to update record.' });
                }
            } else {
                setAlert({ show: true, type: 'error', title: 'Error', message: 'Failed to connect to server.' });
            }
        } catch (error) {
            console.error("Error updating enquiry:", error);
            setAlert({ show: true, type: 'error', title: 'Error', message: 'An error occurred while saving.' });
        } finally {
            setIsSaving(false);
        }
    };

    const handleDelete = async () => {
        try {
            setIsSaving(true);
            const { TokenId } = getSession();

            const payload = {
                Token: TOKEN,
                Details: {
                    EnquiryID: Number(leadId)
                }
            };

            const response = await fetch(Delete_Enquiry_Details, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setShowDeleteConfirm(false);
                setAlert({
                    show: true,
                    type: 'success',
                    title: 'Deleted',
                    message: 'Lead Deleted Successfully'
                });
                // Redirect or update UI after a short delay
                setTimeout(() => {
                    onBack();
                }, 2000);
            } else {
                setAlert({
                    show: true,
                    type: 'error',
                    title: 'Error',
                    message: 'Failed to delete lead.'
                });
            }
        } catch (error) {
            console.error("Error deleting lead:", error);
            setAlert({
                show: true,
                type: 'error',
                title: 'Error',
                message: 'An error occurred while deleting.'
            });
        } finally {
            setIsSaving(false);
        }
    };


    // API endpoints URLs
    const Get_Chat_log = `${SERVICE_AZURE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_CHAT_LOGS}`;
    const Get_call_logs = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_CALL_LOGS}`;
    const Get_Past_meeting_bind = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_BIND_PAST_MEETING}`;
    const Get_Upcoming_meeting_bind = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_BIND_UPCOMING_MEETING}`;
    const For_Wa_Chat_CONID = `${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_CON_ID}`;
    const GetWa_chat = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_W_CHAT}`;

    const SCORECARD_URL = `${NEWV3_BASE_URL_INTERNAL}${API_ENDPOINTS.FOLLOWUPS.SCORE_CARD_DETAILS}`;
    const GetLeadDetailByLeadId = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;
    const For_Document = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_DOCUMENT_DETAILS_FOR_LEADVIEW}`;
    const Get_LeadDetails_Activities = `${SERVICE_AZURE_URL}${API_ENDPOINTS.TASKS.GET_ACIVITIES_FOR_DETAILS_EDIT}`;
    const GetEnquiryActivity = `${WCF_BASE}${API_ENDPOINTS.ENQUIRIES.GET_ENQUIRY_ACTIVITY}`;
    const Get_Physical_Appointment_List = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_PHYSICAL_APPOINTMENT_LIST}`;
    const webformDetails = `${NEW_ADDED_BASE_URL}/UserCRM/GetWebformDetailsByLeadId`;

    const Get_Call_Schedule_Action = `${SERVICE_AZURE_URL}/${API_ENDPOINTS.ENQUIRIES.GET_SCHEDULE_CALL_ACTION}`;
    const Get_Mobile_Number = `${SERVICE_AZURE_URL}/${API_ENDPOINTS.ENQUIRIES.GET_MOBILE_NUMBER}`;


    //const LOCAL_BASE_URL = (process.env.REACT_APP_LOCAL_DEVELOPMENT_URL || '').replace(/\/$/, '');



    // const Edit_Meeting_Setting = `${WCF_BASE}${API_ENDPOINTS.ENQUIRIES.EDIT_MEETING_SETTING}`;

    const handleMergeToLead = async (shouldFollowup = false) => {
        if (!shouldFollowup && !selectedConflictId) {
            setAlert({ show: true, type: 'error', title: 'Error', message: 'Please select a lead to merge with.' });
            return;
        }

        if (shouldFollowup) {
            setMergeStep('followup');
            fetchFollowupOptions();
            return;
        }

        setIsMerging(true);
        const { userId, parentId } = getSession();
        const finalUserId = userId || "34594";
        const finalParentId = parentId || "34594";

        try {
            const getCode = (val) => val?.startsWith('+') ? val.split(' ')[0] : '';
            const customFieldsArr = [];
            MERGE_FIELDS.forEach(f => {
                if (/^\d+$/.test(f.key)) {
                    customFieldsArr.push({
                        EnquiryID: Number(basicInfo?.EnquiryId || leadId),
                        LeadID: Number(selectedConflictId),
                        fieldID: Number(f.key),
                        fieldvalue: mergeForm[f.key] || ''
                    });
                }
            });

            const mergePayload = {
                Token: TOKEN,
                Details: {
                    EnquiryID: Number(basicInfo?.EnquiryId || leadId),
                    LeadID: Number(selectedConflictId),
                    ParentID: Number(finalParentId),
                    ModifiedBy: Number(finalUserId),
                    PersonName: mergeForm.PersonName || '',
                    CompanyName: mergeForm.Company || '',
                    MobileNo: mergeForm.Mobile || '',
                    MobileNo1: mergeForm.Mobile1 || '',
                    MobileNo2: mergeForm.Mobile2 || '',
                    CountryCode: getCode(mergeForm.Mobile),
                    CountryCode1: getCode(mergeForm.Mobile1),
                    CountryCode2: getCode(mergeForm.Mobile2),
                    EmailID: mergeForm.Email || '',
                    EmailID1: mergeForm.Email1 || '',
                    EmailID2: mergeForm.Email2 || '',
                    City: mergeForm.City || '',
                    State: mergeForm.State || '',
                    Country: mergeForm.Country || '',
                    PinCode: mergeForm.PinCode || '',
                    ResidentialAddress: mergeForm.ResiAddress || '',
                    OfficeAddress: mergeForm.OfficeAddress || '',
                    saveLeadCustomeFeilds: customFieldsArr
                }
            };

            const response = await fetch(Merge_To_Lead, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(mergePayload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1) {
                    setAlert({ show: true, type: 'success', title: 'Success', message: 'Enquiry merged successfully!' });
                    setIsMergeUIOpen(false);
                    fetchEnquiryDetailsData(leadId);
                } else {
                    setAlert({ show: true, type: 'error', title: 'Error', message: result.Message || 'Failed to merge enquiry.' });
                }
            }
        } catch (error) {
            console.error("Error in merge process:", error);
            setAlert({ show: true, type: 'error', title: 'Error', message: 'An error occurred during the merge.' });
        } finally {
            setIsMerging(false);
        }
    };

    const fetchFollowupOptions = async () => {
        setIsLocalDataLoading(true);
        const { parentId } = getSession();
        const finalParentId = parentId || "34594";
        try {
            const sRes = await fetch(GET_FOLLOWUP_LIST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(finalParentId) } })
            });
            if (sRes.ok) {
                const sResult = await sRes.json();
                const sDataRaw = sResult.Details || sResult.d || sResult.data || sResult;
                let rawStatuses = Array.isArray(sDataRaw) ? sDataRaw : [];
                if (sDataRaw && typeof sDataRaw === 'string') { try { rawStatuses = JSON.parse(sDataRaw); } catch (e) { } }
                const statuses = Array.isArray(rawStatuses) ? rawStatuses.map(s => {
                    // Be careful with 0 or empty strings
                    const val = [s.Value, s.Code, s.ID, s.id, s.StatusID, s.StatusId, s.followupstatusid, s.FollowUpStatusID]
                        .find(v => v !== undefined && v !== null && v !== '');
                    const txt = [s.Text, s.Name, s.StatusName, s.Status, s.followupstatus]
                        .find(t => t !== undefined && t !== null && t !== '');
                    return { Value: val !== undefined ? String(val) : '', Text: txt || 'Unknown Status' };
                }).filter(s => s.Value) : [];

                setFollowupStatuses(statuses);
                if (statuses.length > 0 && (!localFollowupData.Status || localFollowupData.Status === '1')) {
                    setLocalFollowupData(prev => ({ ...prev, Status: statuses[0].Value }));
                }
            }

            const aRes = await fetch(GET_USER_HIRERARCHY, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { UserId: Number(finalParentId) } })
            });
            if (aRes.ok) {
                const aData = await aRes.json();
                const rawUsers = aData.Details?.data || aData.Details || aData.d || [];
                let parsedUsers = Array.isArray(rawUsers) ? rawUsers : [];
                if (typeof rawUsers === 'string') { try { parsedUsers = JSON.parse(rawUsers); } catch (e) { } }
                const users = parsedUsers.map(u => {
                    const val = [u.Code, u.Value, u.UserID, u.userid, u.id, u.ID, u.UserId]
                        .find(v => v !== undefined && v !== null && v !== '');
                    const txt = [u.Text, u.UserName, u.name, u.Name, u.username]
                        .find(t => t !== undefined && t !== null && t !== '');
                    return { Value: val !== undefined ? String(val) : '', Text: txt || 'Unknown User' };
                }).filter(u => u.Value);

                setAssignedToOptions(users);
                if (users.length > 0 && !localFollowupData.AssignedTo) {
                    setLocalFollowupData(prev => ({ ...prev, AssignedTo: users[0].Value }));
                }
            }
        } catch (err) {
            console.error("Error fetching followup options:", err);
        } finally {
            setIsLocalDataLoading(false);
        }
    };

    const isNegativeStatus = () => {
        const currentStatus = followupStatuses.find(s => String(s.Value) === String(localFollowupData.Status));
        if (!currentStatus) return false;
        const text = currentStatus.Text.toLowerCase();
        const negativeKeywords = ['interested', 'reachable', 'dead', 'wrong', 'switch', 'hold', 'payment', 'sw off'];
        return negativeKeywords.some(keyword => text.includes(keyword));
    };

    const handleSaveMergeFollowup = async () => {
        if (!localFollowupData.Remarks) {
            setAlert({ show: true, type: 'error', title: 'Error', message: 'Please enter remarks.' });
            return;
        }

        setIsMerging(true);
        const { userId, parentId } = getSession();
        const finalUserId = userId || "34594";
        const finalParentId = parentId || "34594";
        const isNeg = isNegativeStatus();

        try {
            const parseNum = (val) => {
                const n = Number(val);
                return isNaN(n) ? 0 : n;
            };

            const followupPayload = {
                Token: saveEditToken || TOKEN,
                Details: {
                    FollowUpStatus: parseNum(localFollowupData.Status),
                    FollowUpDate: "",
                    FollowUpTime: isNeg ? "" : localFollowupData.Time,
                    AssignedTo: isNeg ? 0 : Number(localFollowupData.AssignedTo || 0),
                    Products: isNeg ? "" : selectedLocalProducts.map(p => `${p.Text || p.ProductName || 'Product'}#${p.Text || p.ProductName || 'Product'}`).join(','),
                    AmountPaid: 0,
                    IsReAssign: isNeg ? false : localFollowupData.IsReAssign,
                    FollowupRemarks: localFollowupData.Remarks,
                    EnquiryId: Number(basicInfo?.EnquiryId || leadId),
                    IsNotifyBySms: false,
                    IsNotifyByEmail: false,
                    UserId: Number(finalUserId)
                }
            };

            if (!isNeg) {
                // Format date to DD-MMM-YYYY for non-negative statuses
                const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                const d = new Date(localFollowupData.Date);
                if (!isNaN(d.getTime())) {
                    followupPayload.Details.FollowUpDate = `${String(d.getDate()).padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()}`;
                } else {
                    const today = new Date();
                    followupPayload.Details.FollowUpDate = `${String(today.getDate()).padStart(2, '0')}-${months[today.getMonth()]}-${today.getFullYear()}`;
                }
            } else {
                // For negative status, date might be empty or today, but usually empty if we don't want a next status
                followupPayload.Details.FollowUpDate = "";
            }

            const response = await fetch(Save_Enquiry_Followup, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(followupPayload)
            });

            if (response.ok) {
                const result = await response.json();
                const isSuccess = result.Status === 1 || result.d === "1" || result.Details === "1";

                if (isSuccess) {
                    setAlert({ show: true, type: 'success', title: 'Success', message: 'Saved successfully!' });
                    setIsMergeUIOpen(false);
                    setMergeStep('merge');
                    fetchEnquiryDetailsData(leadId);
                } else {
                    const msg = result.Message || (typeof result.d === 'string' && result.d !== '1' ? result.d : '') || (typeof result.Details === 'string' && result.Details !== '1' ? result.Details : '') || 'Failed to save.';
                    setAlert({ show: true, type: 'error', title: 'Error', message: msg });
                }
            }
        } catch (error) {
            console.error("Error in followup process:", error);
            setAlert({ show: true, type: 'error', title: 'Error', message: 'An error occurred during the process.' });
        } finally {
            setIsMerging(false);
        }
    };

    const productSearchTimerRef = useRef(null);
    const handleProductSearch = (term) => {
        setProductSearchTerm(term);
        if (term.length < 2) {
            setSuggestedProducts([]);
            setShowProductDropdown(false);
            if (productSearchTimerRef.current) clearTimeout(productSearchTimerRef.current);
            return;
        }

        if (productSearchTimerRef.current) clearTimeout(productSearchTimerRef.current);

        productSearchTimerRef.current = setTimeout(async () => {
            const { userId, parentId } = getSession();
            try {
                const res = await fetch(PRODUCT_SUGGESTION, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: TOKEN, Details: { UserId: Number(userId || parentId || "34594"), Term: term } })
                });
                if (res.ok) {
                    const data = await res.json();
                    const rawResults = data.Details || data.d || [];
                    const results = rawResults.map(p => ({
                        Value: p.Value || p.ProductID || p.id || p.ID || p.Code,
                        Text: p.Text || p.ProductName || p.name || p.Name
                    }));
                    setSuggestedProducts(results);
                    setShowProductDropdown(results.length > 0);
                }
            } catch (e) { console.error(e); }
        }, 500);
    };

    const handleProductSelect = (p, isEdit = false) => {
        const list = isEdit ? selectedEditProducts : selectedLocalProducts;
        const setList = isEdit ? setSelectedEditProducts : setSelectedLocalProducts;

        if (!list.find(item => item.Value === p.Value)) {
            setList([...list, p]);
        }
        setProductSearchTerm('');
        setShowProductDropdown(false);
    };

    const handleRemoveProduct = (val, isEdit = false) => {
        const list = isEdit ? selectedEditProducts : selectedLocalProducts;
        const setList = isEdit ? setSelectedEditProducts : setSelectedLocalProducts;
        setList(list.filter(p => p.Value !== val));
    };

    const handleOpenMergeUI = async () => {
        setIsMerging(true); // Re-using isMerging as a general loading state for this action
        const conflicts = await fetchLeadConflicts(leadId);
        setIsMerging(false);

        if (conflicts && conflicts.length > 0) {
            setMergeStep('merge');
            setIsMergeUIOpen(true);
            // Reset local followup data for the merge flow
            setLocalFollowupData({
                Status: '1',
                AssignedTo: getSession()?.userId || '34594',
                Date: new Date().toISOString().split('T')[0],
                Time: new Date().toTimeString().slice(0, 5),
                Remarks: '',
                IsReAssign: false
            });
            setSelectedLocalProducts([]);
        } else {
            // No conflicts, open Add Followup sidebar form instead of Add Lead
            setCentralizedMode('AddFollowup');
            setActiveSidebarAction('Centralized');
        }
    };

    const fetchLeadConflicts = async (enqid) => {
        const { parentId } = getSession();
        console.log("Fetching lead conflicts for enqid:", enqid);
        try {
            const response = await fetch(Get_Lead_Confliction, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { enqid: String(enqid), parentid: String(parentId || "34594") } })
            });
            if (response.ok) {
                const result = await response.json();
                console.log("Conflict results:", result);
                const leads = result.Details || [];
                setConflictLeads(leads);
                if (leads.length > 0) {
                    setSelectedConflictId(leads[0].Value);
                    fetchLeadCustomData(leads[0].Value);
                }
                return leads;
            } else {
                console.warn("Conflict API failed with status:", response.status);
                return [];
            }
        } catch (e) {
            console.error("Error fetching lead conflicts:", e);
            return [];
        }
    };

    const fetchLeadCustomData = async (leadId) => {
        const { userId, parentId } = getSession();
        try {
            const response = await fetch(Get_Lead_Details_New, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: TOKEN,
                    Details: JSON.stringify({
                        draw: 1,
                        StartNo: 0,
                        EndNo: 1,
                        UserId: Number(userId || LOGGED_USER_ID || "34594"),
                        ParentId: Number(parentId || PARENT_ID || "34594"),
                        FilterText: `ID=${leadId}`
                    })
                })
            });
            if (response.ok) {
                const result = await response.json();
                const leadData = result.Details?.data?.[0];
                if (leadData) {
                    const mappedLead = {
                        PersonName: leadData.PersonName || '-',
                        Company: leadData.CompanyName || '-',
                        Mobile: leadData.MobileNo || '-',
                        Mobile1: leadData.MobileNo2 || '-',
                        Mobile2: leadData.MobileNo3 || '-',
                        Email: leadData.EmailID || '-',
                        Email1: leadData.EmailID2 || '-',
                        Email2: leadData.EmailID3 || '-',
                        Country: leadData.Country || '-',
                        State: leadData.State || leadData.StateName || '-',
                        City: leadData.City || '-',
                        Source: leadData.SourceName || '-',
                        Medium: leadData.MediumName || '-',
                        Campaign: leadData.CampaignName || '-',
                        ResiAddress: leadData.ResidentialAddress || '-',
                        OfficeAddress: leadData.OfficeAddress || '-',
                        Remarks: leadData.Remarks || '-',
                        AssignedTo: leadData.assigneduser || 'N/A'
                    };

                    // Map custom fields from the JSON object if they exist
                    MERGE_FIELDS.forEach(f => {
                        if (!mappedLead[f.key]) {
                            mappedLead[f.key] = leadData[f.key] || leadData[f.dataKey] || leadData[f.label] || '-';
                        }
                    });

                    setSelectedMergeLead(mappedLead);
                }
            }
        } catch (e) {
            console.error("Error fetching lead custom data:", e);
        }
    };

    const fetchEnquiryDetailsData = async (id) => {
        try {
            setIsEnquiryDetailLoading(true);
            const response = await fetch(Enquiry_ShowWData, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: TOKEN,
                    Details: { enqid: id.toString() }
                })
            });
            if (response.ok) {
                const result = await response.json();
                setEnquiryDetailData(result.Details || []);
            }
        } catch (error) { console.error("Error fetching Enquiry_ShowWData:", error); }
        finally { setIsEnquiryDetailLoading(false); }
    };

    const fetchLeadDetailsWithCustom = async (id) => {
        try {
            setIsEnquiryDetailLoading(true);
            setIsCustomMoreLoading(true);
            const { userId, parentId } = getSession();

            const response = await fetch(Get_Lead_Details_New, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: TOKEN,
                    Details: JSON.stringify({
                        draw: 1,
                        StartNo: 0,
                        EndNo: 1,
                        UserId: Number(userId || LOGGED_USER_ID || "34594"),
                        ParentId: Number(parentId || PARENT_ID || "34594"),
                        FilterText: `ID=${id}`
                    })
                })
            });

            if (response.ok) {
                const result = await response.json();
                const leadData = result.Details?.data?.[0];
                if (leadData) {
                    setBasicInfo({
                        ...leadData,
                        PersonName: leadData.PersonName || '',
                        CompanyName: leadData.CompanyName || '',
                        MobileNo: leadData.MobileNo || '',
                        MobileNo2: leadData.MobileNo2 || '',
                        MobileNo3: leadData.MobileNo3 || '',
                        EmailID: leadData.EmailID || '',
                        EmailID2: leadData.EmailID2 || '',
                        EmailID3: leadData.EmailID3 || '',
                        AssignedTo: leadData.assigneduser || '',
                        State: leadData.State || leadData.StateName || '',
                        City: leadData.City || '',
                        Country: leadData.Country || '',
                        Remarks: leadData.Remarks || leadData.InitialRemarks || '',
                        LeadNo: leadData.LeadNo || leadData.EnquiryId || id
                    });
                    setEditForm(prev => ({
                        ...prev,
                        ...leadData,
                        PersonName: leadData.PersonName || '',
                        Company: leadData.CompanyName || '',
                        Mobile1: leadData.MobileNo || '',
                        Email1: leadData.EmailID || '',
                        Remarks: leadData.Remarks || leadData.InitialRemarks || ''
                    }));
                }
            }
        } catch (error) {
            console.error("Error fetching lead details with custom:", error);
        } finally {
            setIsEnquiryDetailLoading(false);
            setIsCustomMoreLoading(false);
        }
    };


    const fetchCountries = async () => {
        try {
            const response = await fetch(Get_Country, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: {} })
            });
            if (response.ok) {
                const result = await response.json();
                setCountries(result.d || result.Details || []);
            }
        } catch (e) { console.error("Error fetching countries:", e); }
    };

    const fetchStates = async (countryId) => {
        if (!countryId) return;
        try {
            setIsLocationLoading(true);
            const response = await fetch(Get_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(countryId.toString(), 10) } })
            });
            if (response.ok) {
                const result = await response.json();
                setStatesList(result.d || result.Details || []);
            }
        } catch (e) { console.error("Error fetching states:", e); }
        finally { setIsLocationLoading(false); }
    };

    const fetchCities = async (stateId) => {
        if (!stateId) return;
        try {
            setIsLocationLoading(true);
            const response = await fetch(Get_City_By_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(stateId.toString(), 10) } })
            });
            if (response.ok) {
                const result = await response.json();
                setCitiesList(result.d || result.Details || []);
            }
        } catch (e) { console.error("Error fetching cities:", e); }
        finally { setIsLocationLoading(false); }
    };

    const fetchDynamicCountries = async () => {
        try {
            const response = await fetch('https://raw.githubusercontent.com/mledoze/countries/master/countries.json');
            const data = await response.json();
            const list = data.map(item => {
                const root = item.idd?.root || "";
                const suffix = item.idd?.suffixes ? item.idd.suffixes[0] : "";
                return {
                    name: item.name.common,
                    dialCode: root + suffix,
                    flag: item.flags?.png || `https://flagcdn.com/w320/${(item.cca2 || '').toLowerCase()}.png`,
                    code: item.cca2
                };
            }).filter(c => c.dialCode).sort((a, b) => a.name.localeCompare(b.name));
            setDynamicCountries(list);
            return list;
        } catch (error) {
            console.error("Error fetching dynamic countries:", error);
            return [];
        }
    };

    const fetchCourseOptions = async () => {
        const { parentId } = getSession();
        const finalParentId = parentId || "34594";
        try {
            const response = await fetch(Get_Course, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: "-2295521862261168",
                    Details: { leadno: 42957, parentid: Number(finalParentId) || 34594 }
                })
            });
            if (response.ok) {
                const result = await response.json();
                const data = result.Details?.[0] || result.d?.[0] || result.Details || result.d || [];
                // If it's a single object instead of an array, wrap it
                const dataArray = Array.isArray(data) ? data : [data];
                if (dataArray.length > 0 && dataArray[0]?.DependencyJson) {
                    try {
                        const parsed = JSON.parse(dataArray[0].DependencyJson);
                        setCourseDependency(parsed);
                    } catch (e) { console.error("Error parsing DependencyJson:", e); }
                }
            }
        } catch (e) { console.error("Error fetching courses:", e); }
    };

    const fetchSourceOptions = async () => {
        const { parentId, TokenId, userId } = getSession();
        const finalParentId = parentId || "34594";
        const finalToken = TokenId || TOKEN;
        const payload = {
            Token: finalToken,
            Message: "",
            LoggedUserId: userId ?? 0,
            MAC_Address: "",
            IP_Address: "102.16.32.189",
            Details: { Type: 'SourceName', Parentid: Number(finalParentId) },
            BroadcastName: ""
        };
        try {
            const list = await bindSourceMediumCampaign(payload);
            setSourceOptions(list);
        } catch (e) { console.error("Error fetching sources:", e); }
    };

    const fetchMediumOptions = async () => {
        const { parentId, TokenId, userId } = getSession();
        const finalParentId = parentId || "34594";
        const finalToken = TokenId || TOKEN;
        const payload = {
            Token: finalToken,
            Message: "",
            LoggedUserId: userId ?? 0,
            MAC_Address: "",
            IP_Address: "102.16.32.189",
            Details: { Type: 'MediumName', Parentid: Number(finalParentId) },
            BroadcastName: ""
        };
        try {
            const list = await bindSourceMediumCampaign(payload);
            setMediumOptions(list);
        } catch (e) { console.error("Error fetching mediums:", e); }
    };

    const fetchCampaignOptions = async () => {
        const { parentId, TokenId, userId } = getSession();
        const finalParentId = parentId || "34594";
        const finalToken = TokenId || TOKEN;
        const payload = {
            Token: finalToken,
            Message: "",
            LoggedUserId: userId ?? 0,
            MAC_Address: "",
            IP_Address: "102.16.32.189",
            Details: { Type: 'CampaignName', Parentid: Number(finalParentId) },
            BroadcastName: ""
        };
        try {
            const list = await bindSourceMediumCampaign(payload);
            setCampaignOptions(list);
        } catch (e) { console.error("Error fetching campaigns:", e); }
    };

    const fetchFields = async () => {
        setLoadingFields(true);
        try {
            const { parentId } = getSession();
            const resolvedParentId = parentId || PARENT_ID || "34594";

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    ParentId: resolvedParentId,
                    Status: "Active"
                }
            };

            const response = await fetch(`${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.GET_CUSTOM_FIELDS}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1 && result.Details) {
                    const fields = result.Details.map(f => ({
                        label: f.fieldname,
                        key: String(f.field_ID),
                        type: f.datatype.toLowerCase(),
                        isMandatory: f.isMandatory,
                        choices: f.choices ? f.choices.split(',').map(c => c.trim()) : [],
                        sequence: f.sequence
                    })).sort((a, b) => a.sequence - b.sequence);
                    setCustomFieldsList(fields);
                }
            }
        } catch (error) {
            console.error("Error fetching dynamic fields:", error);
        } finally {
            setLoadingFields(false);
        }
    };

    const fetchUsersList = async () => {
        try {
            const uid = localStorage.getItem('userId') || '34594';
            const response = await fetch(Get_User_List, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } })
            });
            if (response.ok) {
                const res = await response.json();
                const rawUsers = res.Details?.data || res.Details || res.d || res;
                let parsed = Array.isArray(rawUsers) ? rawUsers : [];
                if (typeof rawUsers === 'string') { try { parsed = JSON.parse(rawUsers); } catch (e) { } }
                setAssignedToOptions(Array.isArray(parsed) ? parsed : []);
            }
        } catch (e) { console.error("Error fetching users list:", e); }
    };

    const fetchEnquiryActivities = async (id) => {
        if (!id) return;
        try {
            setIsLogLoading(true);
            const response = await fetch(Get_Activity_New, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: TOKEN,
                    Details: {
                        EnquiryID: Number(id),
                        Start: 0,
                        Limit: 10
                    }
                })
            });
            if (response.ok) {
                const result = await response.json();
                let list = (result.Details || result.d || []);

                // If it's a string, try to parse it (common in some legacy-style APIs)
                if (typeof list === 'string') {
                    try { list = JSON.parse(list); } catch (e) { list = []; }
                }

                setActivities(list);
            }
        } catch (error) {
            console.error("Error fetching activities:", error);
        } finally {
            setIsLogLoading(false);
        }
    };

    const handleAvatarChangeAdd = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 1024 * 1024) {
                setAlert({ show: true, type: 'error', title: 'Error', message: 'Image size should be less than 1MB' });
                return;
            }
            setProfileFileAdd(file);
            const reader = new FileReader();
            reader.onloadend = () => setProfilePreviewAdd(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const renderCustomField = (item, idx, isEdit = true) => {
        const fieldId = String(item.key);
        const val = customFieldsData[fieldId] !== undefined ? customFieldsData[fieldId] : "";
        const label = item.label;
        const type = item.type;
        const isMandatory = item.isMandatory;

        const fieldWrapperStyle = { display: 'block', marginBottom: '12px' };
        const labelStyle = { fontSize: '12px', color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' };
        const inputStyle = { width: '100%', padding: '10px 12px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px', outline: 'none' };

        // Priority 1: Checkbox Field (Toggles)
        if (type === "checkbox field" || fieldId === "11919") {
            const isChecked = val === "1" || val === "true" || val === true;
            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', color: '#475569' }}>
                        <div
                            onClick={() => {
                                if (isEdit) {
                                    setCustomFieldsData(prev => ({ ...prev, [fieldId]: !isChecked }));
                                }
                            }}
                            style={{
                                width: '40px',
                                height: '20px',
                                backgroundColor: isChecked ? '#10b981' : '#cbd5e1',
                                borderRadius: '10px',
                                position: 'relative',
                                transition: 'all 0.3s ease',
                                cursor: isEdit ? 'pointer' : 'default'
                            }}
                        >
                            <div style={{
                                width: '16px',
                                height: '16px',
                                backgroundColor: '#fff',
                                borderRadius: '50%',
                                position: 'absolute',
                                top: '2px',
                                left: isChecked ? '22px' : '2px',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }} />
                        </div>
                        {label} {isMandatory && <span style={{ color: '#ef4444' }}>*</span>}
                    </label>
                </div>
            );
        }

        // Dropdown Fields
        if (type === "dropdown" || item.choices?.length > 0) {
            // Specific Logic for Study Level (5291)
            if (fieldId === "5291") {
                const options = [...new Set(courseOptions.map(o => o.ParentValue))];
                return (
                    <div key={idx} style={fieldWrapperStyle}>
                        <label style={labelStyle}>{label} {isMandatory && <span style={{ color: '#ef4444' }}>*</span>} : </label>
                        <select
                            className="edit-select"
                            value={val}
                            onChange={(e) => {
                                const newVal = e.target.value;
                                setCustomFieldsData(prev => ({ ...prev, [fieldId]: newVal, ["5292"]: "" }));
                            }}
                            disabled={!isEdit}
                            style={inputStyle}
                        >
                            <option value="">--Select Option--</option>
                            <option value="Diploma">Diploma</option>
                            <option value="Gratuate">Gratuate</option>
                            <option value="Post Gratuate">Post Gratuate</option>
                            {options.map((opt, i) => !["Diploma", "Gratuate", "Post Gratuate"].includes(opt) && <option key={i} value={opt}>{opt}</option>)}
                        </select>
                    </div>
                );
            }

            // Specific Logic for Course (5292)
            if (fieldId === "5292") {
                const studyLevelVal = customFieldsData["5291"] || "";
                const filteredCourses = courseDependency.find(d => d.ParentValue === studyLevelVal)?.ChildValue || [];
                return (
                    <div key={idx} style={fieldWrapperStyle}>
                        <label style={labelStyle}>{label} {isMandatory && <span style={{ color: '#ef4444' }}>*</span>} : </label>
                        <select
                            className="edit-select"
                            value={val}
                            onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                            disabled={!isEdit || !studyLevelVal}
                            style={{ ...inputStyle, background: (!isEdit || !studyLevelVal) ? '#f9fafb' : '#fff' }}
                        >
                            <option value="">--Select Option--</option>
                            {filteredCourses.map((c, i) => <option key={i} value={c}>{c}</option>)}
                        </select>
                    </div>
                );
            }

            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label} {isMandatory && <span style={{ color: '#ef4444' }}>*</span>} : </label>
                    <select
                        className="edit-select"
                        value={val}
                        onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                        disabled={!isEdit}
                        style={inputStyle}
                    >
                        <option value="">--Select Option--</option>
                        {item.choices.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
                    </select>
                </div>
            );
        }

        // Radio Fields
        if (type === "radio button") {
            let options = item.choices || ["Yes", "No"];
            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label} {isMandatory && <span style={{ color: '#ef4444' }}>*</span>} : </label>
                    <div style={{ display: 'flex', gap: '15px', marginTop: '8px' }}>
                        {options.map(opt => (
                            <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', cursor: isEdit ? 'pointer' : 'default' }}>
                                <input
                                    type="radio"
                                    name={`radio_dyn_${fieldId}`}
                                    value={opt}
                                    checked={String(val).toLowerCase() === String(opt).toLowerCase()}
                                    onChange={(e) => isEdit && setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                                    disabled={!isEdit}
                                />
                                {opt}
                            </label>
                        ))}
                    </div>
                </div>
            );
        }

        // Product Multi-select (8780)
        if (fieldId === '8780') {
            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label} {isMandatory && <span style={{ color: '#ef4444' }}>*</span>} : </label>
                    <div className="field-input products-input" style={{ marginTop: '4px' }}>
                        <div className="products-chips" style={{ marginBottom: selectedEditProducts.length > 0 ? '10px' : '0' }}>
                            {selectedEditProducts.map(p => (
                                <span key={p.Value} className="product-chip">
                                    {p.Text}
                                    {isEdit && <button onClick={() => handleRemoveProduct(p.Value, true)}><X size={12} /></button>}
                                </span>
                            ))}
                        </div>
                        {isEdit && (
                            <input
                                type="text"
                                className="edit-input"
                                placeholder="Search products..."
                                value={productSearchTerm}
                                onChange={(e) => handleProductSearch(e.target.value)}
                                style={inputStyle}
                            />
                        )}
                    </div>
                </div>
            );
        }

        // Default: Text / Date
        return (
            <div key={idx} style={fieldWrapperStyle}>
                <label style={labelStyle}>{label} {isMandatory && <span style={{ color: '#ef4444' }}>*</span>} : </label>
                <input
                    type={type === 'date' ? 'date' : 'text'}
                    value={val}
                    onChange={(e) => isEdit && setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                    className="action-input"
                    placeholder={label}
                    readOnly={!isEdit}
                    style={inputStyle}
                />
            </div>
        );
    };

    const handleSaveAddLead = async () => {
        if (!addLeadForm.PersonName || !addLeadForm.Mobile1) {
            setAlert({ show: true, type: 'error', title: 'Error', message: 'Name and Mobile are required.' });
            return;
        }

        setIsSavingAddLead(true);
        try {
            const { userId, parentId } = getSession();

            // --- Mandatory Conflict Check ---
            const conflictResponse = await fetch(Get_Lead_Confliction, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: TOKEN,
                    Details: {
                        enqid: "0",
                        mobile: addLeadForm.Mobile1,
                        parentid: String(parentId || "34594")
                    }
                })
            });

            if (conflictResponse.ok) {
                const conflictResult = await conflictResponse.json();
                const conflicts = conflictResult.Details || [];
                if (conflicts.length > 0) {
                    setAlert({
                        show: true,
                        type: 'warning',
                        title: 'Conflict Detected',
                        message: 'A lead with this mobile number already exists. Please use Merge instead.'
                    });
                    setConflictLeads(conflicts);
                    setIsSavingAddLead(false);
                    return; // Stop creation
                }
            }


            const lstCustomField = customFieldsList.map(item => {
                let val = addLeadCustomFields[item.key] || "";
                const valLower = String(val).toLowerCase();
                if (item.key === '7692' || item.key === '11919' || item.key === '10546') {
                    if (valLower === "yes" || valLower === "true" || valLower === "male") val = "1";
                    else if (valLower === "no" || valLower === "false" || valLower === "female") val = "0";
                }
                return { FieldId: Number(item.key), FieldValue: String(val) };
            });

            const enquiryDetails = {
                EnquiryId: 0,
                PersonName: addLeadForm.PersonName,
                CompanyName: addLeadForm.Company || "",
                MobileNo1: addLeadForm.Mobile1,
                EmailId1: addLeadForm.Email1 || "",
                City: addLeadForm.City || "",
                State: addLeadForm.State || "",
                CountryName: addLeadForm.Country || "",
                ResidentialAddress: addLeadForm.ResiAddress || "",
                Pincode: Number(addLeadForm.PinCode) || 0,
                SourceName: String(addLeadForm.Source) || "",
                Medium: String(addLeadForm.Medium) || "",
                Campaign: String(addLeadForm.Campaign) || "",
                InitialRemarks: addLeadForm.Remarks || "",
                ParentId: Number(parentId || "34594"),
                CreatedBy: Number(userId || "34594"),
                lstCustomField: lstCustomField,
                Latitude: "0", Longitude: "0"
            };

            const payload = {
                Token: TOKEN,
                Details: JSON.stringify(enquiryDetails)
            };

            const response = await fetch(Save_Enquiry_With_Location, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1) {
                    setAlert({ show: true, type: 'success', title: 'Success', message: result.Details || 'Lead Added Successfully' });

                    // Reset States
                    setActiveSidebarAction(null);
                    setAddLeadForm({
                        PersonName: '', Company: '', Mobile1: '', Email1: '',
                        Country: '', State: '', City: '', Source: '', Medium: '', Campaign: '',
                        ResiAddress: '', OfficeAddress: '', Remarks: '', PinCode: '0', EnquiryTags: ''
                    });
                    setAddLeadCustomFields({});
                    setIsAdvancedAddLead(false);
                    setProfileFileAdd(null);
                    setProfilePreviewAdd(null);

                    // Refresh Activity History if possible (assuming leadId refers to a parent or current view context)
                    if (leadId) fetchEnquiryActivities(leadId);
                } else {
                    setAlert({ show: true, type: 'error', title: 'Error', message: result.Message || 'Failed to add lead.' });
                }
            } else {
                setAlert({ show: true, type: 'error', title: 'Error', message: 'Failed to connect to server.' });
            }

        } catch (error) {
            console.error("Error adding lead:", error);
            setAlert({ show: true, type: 'error', title: 'Error', message: 'An error occurred while saving.' });
        } finally {
            setIsSavingAddLead(false);
        }
    };

    const renderAddLeadCustomField = (item, idx) => renderCustomField(item, idx, true);

    const fetchCustomDataMore = async (id) => {
        try {
            setIsCustomMoreLoading(true);
            const SERVICE_AZURE_URL = (BASES.SERVICES_AZURE || '').replace(/\/$/, '');
            const Custome_Data_More_URL = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.CUSTOME_DATA_MORE}`;
            const { TokenId } = getSession();
            const url = `${Custome_Data_More_URL}?enqid=${id}&TimeZoneName=India Standard Time&Token=${TokenId || ''}`;
            const response = await fetch(url);
            if (response.ok) {
                const result = await response.json();
                const details = result.Details || [];
                setCustomDetailMoreData(details);

                // Automatically populate customFieldsData map for Merge UI and other views
                const fieldsMap = {};
                details.forEach(item => {
                    const textToParse = (item.Value && String(item.Value).includes('|')) ? item.Value : item.Text;
                    const parsed = parseCustomField(textToParse);
                    fieldsMap[item.Value] = parsed.value || '';
                });
                setCustomFieldsData(fieldsMap);
            }
        } catch (e) { console.error("Error fetching custom more data:", e); }
        finally { setIsCustomMoreLoading(false); }
    };

    const formatDisplayDate = (val) => {
        if (!val || val === '-' || val === 'N/A' || val === '0') return '-';
        try {
            const date = new Date(val);
            if (isNaN(date.getTime())) return val;
            const day = String(date.getDate()).padStart(2, '0');
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${day}-${months[date.getMonth()]}-${year} ${hours}:${minutes}:${seconds}`;
        } catch (e) {
            return val;
        }
    };

    const parseCustomField = (text) => {
        if (!text) return { label: '', value: '', type: '' };
        const parts = text.split('|');
        const label = parts[1] || parts[0] || '';
        let type = (parts[2] || '').replace(/^v/, '');

        // Force date type if label contains "date" or matches specific fields
        const lowerLabel = label.toLowerCase();
        if (lowerLabel.includes('date') || lowerLabel.includes('due_date')) {
            type = 'd';
        }

        return {
            label: label,
            value: (parts[0] || '').replace(/^v/, ''),
            type: type
        };
    };

    const fetchSearchLeads = async (term) => {
        if (!term || term.length < 2) return;
        try {
            const { parentId } = getSession();
            const response = await fetch(`${WCF_BASE}/Get_Lead_List_For_Search`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Status: "", Message: "", Token: TOKEN, Details: { ParentId: Number(parentId), SearchTerm: term } })
            });
            if (response.ok) {
                const data = await response.json();
                setMergeLeads(data.Details || []);
            }
        } catch (error) { console.error("Error searching leads:", error); }
    };

    const handleMergeFieldSelect = (key, source, value) => {
        setMergeFieldSelections(prev => ({ ...prev, [key]: source }));
        setMergeForm(prev => ({ ...prev, [key]: value }));
    };



    const safeParse = (data) => {
        if (!data) return null;
        if (typeof data === 'object') return data;
        try { return JSON.parse(data); } catch (e) { return data; }
    };

    const fetchChatLogs = async () => {
        try {
            setIsLogLoading(true);
            const response = await fetch(Get_Chat_log, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: TOKEN, Details: { LeadId: Number(leadId) } })
            });
            if (response.ok) {
                const result = await response.json();
                setChatLogs(result.Details || []);
            }
        } catch (error) { console.error("Error fetching chat logs:", error); }
        finally { setIsLogLoading(false); }
    };

    const isMinimalStatus = (text) => {
        if (!text) return false;
        const normalized = text.toLowerCase().replace(/[^a-z0-9]/g, '');
        const negatives = [
            'notinterested', 'deadlead', 'wrongnumber', 'notreachable',
            'notresponding', 'switchedoff', 'swoff', 'blackhole',
            'paymentreceived', 'deallead', 'notreachabl', 'notresponsing'
        ];
        return negatives.some(n => normalized.includes(n));
    };

    const fetchLocalFollowupData = async () => {
        try {
            setIsLocalDataLoading(true);
            const { parentId } = getSession();

            const [statusRes, userRes] = await Promise.all([
                fetch(GET_FOLLOWUP_LIST, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(parentId) } })
                }),
                fetch(GET_USER_HIRERARCHY, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: TOKEN, Details: { UserId: Number(parentId) } })
                })
            ]);

            if (statusRes.ok) {
                const res = await statusRes.json();
                const data = res.Details || res.d || res.data || res;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                setFollowupStatuses(Array.isArray(parsed) ? parsed : []);
            }
            if (userRes.ok) {
                const res = await userRes.json();
                const rawData = res.Details?.data || res.Details || res.d || [];
                let parsed = Array.isArray(rawData) ? rawData : [];
                if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch (e) { } }
                setAssignedToOptions(Array.isArray(parsed) ? parsed : []);
            }
        } catch (error) {
            console.error("Error fetching local followup data:", error);
        } finally {
            setIsLocalDataLoading(false);
        }
    };

    // Consolidating product handlers - handleLocalProductSearch/Select/Remove are replaced by unified handlers

    const handleSaveEnquiryFollowup = async () => {
        if (!localFollowupData.Status) {
            alert("Please select a status.");
            return;
        }

        const statusObj = followupStatuses.find(s => s.Value?.split(',')[0] === localFollowupData.Status || s.Id === localFollowupData.Status);
        const statusText = statusObj ? (statusObj.Text || statusObj.Name || "") : "";
        const isMinimal = isMinimalStatus(statusText);

        if (!isMinimal && (!localFollowupData.Date || !localFollowupData.Time)) {
            alert("Please select Next Status Date & Time.");
            return;
        }

        try {
            setIsSaving(true);
            const { parentId } = getSession();
            const uid = localStorage.getItem('userId') || parentId;

            // Format date for payload (e.g. "23-Apr-2026")
            const formatDate = (dateStr) => {
                if (!dateStr) return "";
                const d = new Date(dateStr);
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return `${d.getDate().toString().padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()}`;
            };

            const payload = {
                objEnquiryLeadFollowup_BO: {
                    FollowUpStatus: Number(localFollowupData.Status),
                    FollowUpDate: isMinimal ? "" : formatDate(localFollowupData.Date),
                    FollowUpTime: isMinimal ? "" : localFollowupData.Time,
                    AssignedTo: String(localFollowupData.AssignedTo || uid),
                    Products: selectedLocalProducts.map(p => p.Text || p.ProductName || p.Name).join('#') || "",
                    AmountPaid: "0",
                    IsReAssign: !!localFollowupData.IsReAssign,
                    FollowupRemarks: localFollowupData.Remarks || "No remarks",
                    EnquiryId: String(leadId),
                    IsNotifyBySms: false,
                    IsNotifyByEmail: false
                },
                ParentId: String(parentId),
                UserId: String(uid)
            };

            const response = await fetch(Save_Enquiry_Followup, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            const msg = result.Message || result.d || "";
            const isSuccessMsg = msg.toLowerCase().includes("success") || msg.toLowerCase().includes("lead already generate");

            if (response.ok && (result.Status === 1 || isSuccessMsg)) {
                setAlert({
                    show: true,
                    type: 'success',
                    title: 'Success',
                    message: msg || "Follow-up saved successfully!"
                });
                setActiveSidebarAction(null);
                fetchInitialData();
                fetchEnquiryActivities(leadId);
            } else {
                setAlert({
                    show: true,
                    type: 'error',
                    title: 'Error',
                    message: msg || "Failed to save follow-up."
                });
            }
        } catch (error) {
            console.error("Error saving followup:", error);
            setAlert({
                show: true,
                type: 'error',
                title: 'Error',
                message: "An error occurred while saving."
            });
        } finally {
            setIsSaving(false);
        }
    };

    const handleSidebarActionClick = (mode) => {
        setCentralizedMode(mode);

        // Safely extract values from basicInfo (API-driven real-time data)
        const mobile = basicInfo?.MobileNo || basicInfo?.mobileno || '-';
        const email = basicInfo?.EmailID || basicInfo?.emailid || '-';

        if (mode === 'sms' || mode === 'voice') {
            const numbers = mobile.split(',').map(n => n.trim()).filter(n => n && n !== '-');
            if (mode === 'sms') setSmsData(prev => ({ ...prev, chooseNumbers: numbers }));
            if (mode === 'voice') setVoiceData(prev => ({ ...prev, chooseNumbers: numbers.length > 0 ? [numbers[0]] : [] }));
            // fetchSenderIds(); // Ensure this is defined or handled by EnquiryActionOperation
        }

        if (mode === 'mail') {
            const emails = email.split(',').map(e => e.trim()).filter(e => e && e !== '-');
            setMailData(prev => ({ ...prev, to: emails }));
            // fetchMailAccounts(); // Ensure this is defined or handled by EnquiryActionOperation
        }


        if (mode === 'meeting' || mode === 'appointment') {
            fetchMeetingOptions();
        }

        if (mode === 'meeting') {
            setActiveSidebarAction('CreateMeeting');
            const initialMeetingForm = {
                TemplateId: '',
                MeetingName: '',
                StartDateTime: new Date(new Date().getTime() + 5 * 60000), // Default 5 mins later
                EndDateTime: new Date(new Date().getTime() + 65 * 60000), // Default 1 hour duration
                Timezone: 'India Standard Time',
                IsRecurring: false,
                RepeatType: 'daily',
                RepeatEvery: '1',
                EndsOnType: 'never',
                EndsOnDate: null,
                EndsAfterTimes: '10',
                HostId: LOGGED_USER_ID || '34594',
                AddCoHost: false,
                CoHostId: '',
                Participants: [],
                ismeeting: false,
                iswebinar: true,
                autorec: false, allowrec: true, sendrec: false, meetexpire: '5',
                BannerText: 'Meeting Notification', LogoutURL: 'https://kit19.com/MeetingEnd.aspx',
                webcamonlyfohost: false, alwhstunmute: false, audiojoin: false,
                muteonstart: false, dsblmicusers: false, alwhstclscmra: false,
                dsblprvtcht: false, dsblpblcchat: false, sendchat: false,
                authType: '0', invitebymail: false, invitemailsubject: '', invitemailtext: '',
                remindbymail: false, remindmailsubject: '', remindmailtext: '',
                showSection_recording: false, showSection_webcam: false, showSection_chat: false,
                showSection_invitation: false, showSection_reminder: false
            };
            setMeetingForm(initialMeetingForm);

            fetchMeetingSettings();
            fetchMeetingHosts();
            // Call fetchParticipants after a short delay or ensure initialMeetingForm is set
            setTimeout(() => {
                fetchParticipants('', true); // Trigger automatic mapping for current lead
            }, 100);
        } else if (mode === 'whatsapp') {
            setActiveSidebarAction('Centralized');
        } else {
            setActiveSidebarAction('Centralized');
        }
    };

    const formatForDateTimeLocal = (date) => {
        if (!date) return '';
        const offset = date.getTimezoneOffset();
        const adjustedDate = new Date(date.getTime() - (offset * 60 * 1000));
        return adjustedDate.toISOString().slice(0, 16);
    };

    const fetchTemplateDetails = async (settingId) => {
        if (!settingId) {
            setTemplateDetails(null);
            return;
        }
        try {
            const response = await fetch(Edit_Meeting_Setting, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ settingid: settingId, userId: LOGGED_USER_ID || '34594' })
            });
            const data = await response.json();
            if (data.d && data.d.length > 0) {
                const details = data.d[0];
                setTemplateDetails(details);
                // Map API fields to meeting form state
                setMeetingForm(prev => ({
                    ...prev,
                    // MeetingName: prev.MeetingName || details.templateName, // Removed as per request to keep name independent
                    autorec: details.autorec,
                    allowrec: details.allowrec,
                    sendrec: details.sendrec,
                    meetexpire: details.meetexpire,
                    BannerText: details.BannerText,
                    LogoutURL: details.LogoutURL,
                    webcamonlyfohost: details.webcamonlyfohost,
                    alwhstunmute: details.alwhstunmute,
                    audiojoin: details.audiojoin,
                    muteonstart: details.muteonstart,
                    dsblmicusers: details.dsblmicusers,
                    alwhstclscmra: details.alwhstclscmra,
                    dsblprvtcht: details.dsblprvtcht,
                    dsblpblcchat: details.dsblpblcchat,
                    sendchat: details.sendchat,
                    authType: details.authType,
                    invitebymail: details.invitebymail,
                    invitemailsubject: details.invitemailsubject,
                    invitemailtext: details.invitemailtext,
                    remindbymail: details.remindbymail,
                    remindmailsubject: details.remindmailsubject,
                    remindmailtext: details.remindmailtext,
                    // Auto expand sections when template is loaded
                    showSection_recording: true,
                    showSection_webcam: true,
                    showSection_chat: true,
                    showSection_invitation: !!details.invitebymail,
                    showSection_reminder: !!details.remindbymail
                }));
            }
        } catch (e) { console.error("Error fetching template details:", e); }
    };

    const generateBBBQueryString = (meetingName, meetingID, attendeePW, moderatorPW, welcomeText, maxParticipants, logoutURL, record, duration, callbackUrl) => {
        // Build the raw query string. Replace spaces with '+' as per legacy behavior.
        const formatParam = (str) => String(str || "").replace(/ /g, '+');
        return `name=${formatParam(meetingName)}&meetingID=${formatParam(meetingID)}&attendeePW=${formatParam(attendeePW)}&moderatorPW=${formatParam(moderatorPW)}&welcome=${formatParam(welcomeText)}&maxParticipants=${maxParticipants}&logoutURL=${formatParam(logoutURL)}&record=${record}&duration=${duration}&meta_endCallbackUrl=${formatParam(callbackUrl)}`;
    };

    const formatDateForAPI = (date) => {
        if (!date) return '';
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, '0')}-${months[d.getMonth()]}-${d.getFullYear()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    const handleSaveMeeting = async () => {
        if (!meetingForm.MeetingName) {
            setAlert({ show: true, type: 'error', title: 'Error', message: 'Please enter a meeting name.' });
            return;
        }

        // Date Validation
        const now = new Date();
        const start = new Date(meetingForm.StartDateTime);
        const end = new Date(meetingForm.EndDateTime);

        if (start < new Date(now.getTime() - 60000)) { // 1 min buffer
            setAlert({ show: true, type: 'error', title: 'Error', message: 'Meeting start time must be in the future.' });
            return;
        }
        if (end <= start) {
            setAlert({ show: true, type: 'error', title: 'Error', message: 'Meeting end time must be after the start time.' });
            return;
        }

        if (!meetingForm.HostId) {
            setAlert({ show: true, type: 'error', title: 'Error', message: 'Please select a host.' });
            return;
        }

        setIsMeetingSubmitting(true);
        try {
            // Use simpler IDs and fixed passwords like legacy code
            const meetingIDValue = "M" + Math.floor(Math.random() * 10000000);
            const attendeePW = "ap";
            const moderatorPW = "mp";
            const welcomeText = "Welcome to " + meetingForm.MeetingName;
            const logoutURL = meetingForm.LogoutURL || "https://kit19.com/MeetingEnd.aspx";
            const callbackUrl = "https://kit19.com/Callback.aspx";
            const duration = "0";

            // Step 1: Get Server Details (Generate Checksum & URL)
            const bbbQueryRaw = generateBBBQueryString(
                meetingForm.MeetingName,
                meetingIDValue,
                attendeePW,
                moderatorPW,
                welcomeText,
                "0",
                logoutURL,
                meetingForm.autorec ? "true" : "false",
                duration,
                callbackUrl
            );

            // Simple SHA1 using Web Crypto API
            const sha1 = async (str) => {
                const buffer = new TextEncoder().encode(str);
                const hash = await crypto.subtle.digest('SHA-1', buffer);
                return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('');
            };

            const serverResRaw = await fetch(`${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.CREATE_MEETING_SAVE}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: {} })
            });

            const serverData = await serverResRaw.json();
            const serverDetails = serverData.Details?.[0] || {};
            const serverBaseUrl = serverDetails.ServerURL || serverDetails.serverurl;
            const sharedSecret = serverDetails.SharedSecret || serverDetails.sharedsecret;

            if (!serverBaseUrl || !sharedSecret) {
                throw new Error("Failed to get server details for meeting.");
            }

            const createChecksum = await sha1("create" + bbbQueryRaw + sharedSecret);

            // Step 1.1: Get join checksums for links
            const modJoinQuery = `fullName=Moderator&meetingID=${meetingIDValue}&password=${moderatorPW}&redirect=true`;
            const attJoinQuery = `fullName=Attendee&meetingID=${meetingIDValue}&password=${attendeePW}&redirect=true`;

            const modChecksum = await sha1("join" + modJoinQuery + sharedSecret);
            const attChecksum = await sha1("join" + attJoinQuery + sharedSecret);

            // Build final links with "api/" path and checksums
            const fullBBBUrl = `${serverBaseUrl}api/create?${bbbQueryRaw}&checksum=${createChecksum}`;
            const joinModeratorLink = `${serverBaseUrl}api/join?${modJoinQuery}&checksum=${modChecksum}`;
            const joinAttendeeLink = `${serverBaseUrl}api/join?${attJoinQuery}&checksum=${attChecksum}`;

            // Step 2: Save Meeting Details to Database
            const hostDetails = hostOptions.find(h => String(h.EntityID || h.UserId || h.Id) === String(meetingForm.HostId)) || {};
            const hostUser = {
                Entitytype: "User",
                EntityId: String(meetingForm.HostId),
                EntityName: hostDetails.EntityName || hostDetails.UserName || hostDetails.Name || hostDetails.Text || "Host",
                EntityEmail: hostDetails.EntityEmail || hostDetails.Email || hostDetails.EmailID || "",
                EntityMobile: hostDetails.EntityMobile || hostDetails.Mobile || hostDetails.MobileNo || "",
                EntityRole: "host",
                joinlink: joinModeratorLink
            };

            const participantUsers = meetingForm.Participants.map(p => ({
                Entitytype: p.type || (isLead ? "Lead" : "Enquiry"),
                EntityId: String(p.id),
                EntityName: p.name,
                EntityEmail: p.email,
                EntityMobile: p.mobile,
                EntityRole: "participant",
                joinlink: joinAttendeeLink
            }));

            const meetUsersJson = JSON.stringify([hostUser, ...participantUsers]);

            const savePayload = {
                meetingSaveDetails: {
                    ID: 0,
                    meetname: meetingForm.MeetingName,
                    meetingid: meetingIDValue,
                    CreateMeetLink: fullBBBUrl,
                    JoinModeratorLink: joinModeratorLink,
                    JoinAttendeeLink: joinAttendeeLink,
                    meetstarttime: formatDateForAPI(meetingForm.StartDateTime),
                    meetendtime: formatDateForAPI(meetingForm.EndDateTime),
                    meetUsers: meetUsersJson,
                    Isrecurring: !!meetingForm.IsRecurring,
                    recuringtype: meetingForm.IsRecurring ? meetingForm.RepeatType : "",
                    RepeatDays: String(meetingForm.IsRecurring ? meetingForm.RepeatEvery : "0"),
                    RecurringEndByDate: meetingForm.IsRecurring && meetingForm.EndsOnType === 'date' ? formatDateForAPI(meetingForm.EndsOnDate) : "",
                    RecurringEndAfterTimes: Number(meetingForm.IsRecurring && meetingForm.EndsOnType === 'after' ? meetingForm.EndsAfterTimes : 0)
                },
                meetingSettingDetails: {
                    ismeeting: true,
                    iswebinar: false,
                    autorec: !!meetingForm.autorec,
                    allowrec: !!meetingForm.allowrec,
                    sendrec: !!meetingForm.sendrec,
                    maxparticipants: 0,
                    meetexpire: meetingForm.meetexpire || 5,
                    webcamonlyfohost: !!meetingForm.webcamonlyfohost,
                    alwhstunmute: !!meetingForm.alwhstunmute,
                    audiojoin: !!meetingForm.audiojoin,
                    muteonstart: !!meetingForm.muteonstart,
                    dsblmicusers: !!meetingForm.dsblmicusers,
                    alwhstclscmra: !!meetingForm.alwhstclscmra,
                    dsblprvtcht: !!meetingForm.dsblprvtcht,
                    dsblpblcchat: !!meetingForm.dsblpblcchat,
                    sendchat: !!meetingForm.sendchat,
                    authType: String(meetingForm.authType || "0"),
                    invitebymail: !!meetingForm.invitebymail,
                    invitemailsubject: meetingForm.invitemailsubject || "",
                    invitemailtext: meetingForm.invitemailtext || "",
                    remindbymail: !!meetingForm.remindbymail,
                    remindmailsubject: meetingForm.remindmailsubject || "",
                    remindmailtext: meetingForm.remindmailtext || "",
                    BannerText: meetingForm.BannerText || "Meeting Notification",
                    LogoutURL: logoutURL
                },
                userId: String(LOGGED_USER_ID || "34594")
            };

            const saveResponse = await fetch(`${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.SAVE_MEETING_DETAILS}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: savePayload })
            });

            const saveData = await saveResponse.json();
            const internalID = saveData.Details || saveData.d; // This is the database ID

            if (internalID && internalID !== "0" && !isNaN(internalID)) {
                // Step 3: Trigger Meeting on BBB Server
                const triggerResRaw = await fetch(`${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.CREATE_MEETING}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: TOKEN, Details: { Url: fullBBBUrl, MeetID: String(internalID) } })
                });

                const triggerData = await triggerResRaw.json();
                const triggerRes = triggerData.Details || triggerData.d || "";

                if (triggerRes === "FAILED") {
                    throw new Error("BBB Server initialization failed. Please check meeting settings.");
                }

                setAlert({ show: true, type: 'success', title: 'Success', message: 'Meeting Scheduled Successfully!' });
                setActiveSidebarAction(null);
                fetchInitialData();
                fetchEnquiryActivities(leadId);
            } else {
                throw new Error("Failed to save meeting details to database.");
            }

        } catch (error) {
            console.error("Error scheduling meeting:", error);
            setAlert({ show: true, type: 'error', title: 'Error', message: error.message || 'An error occurred while scheduling the meeting.' });
        } finally {
            setIsMeetingSubmitting(false);
        }
    };

    const fetchSenderIds = async () => {
        try {
            const response = await fetch(`${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_SENDER_IDFOR_SMS}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, UserId: getSession()?.userId })
            });
            const data = await response.json();
            if (data.d) setSenderIdOptions(JSON.parse(data.d));
        } catch (e) { console.error("Error fetching sender IDs:", e); }
    };

    const fetchMailAccounts = async () => {
        try {
            // Placeholder for real email account fetching logic
            setEmailAccountOptions([{ Value: '1', Text: 'Default System Mail' }]);
            setFromEmailOptions([{ Value: getSession()?.email || 'sales@kit19.com', Text: getSession()?.email || 'sales@kit19.com' }]);
        } catch (e) { console.error("Error fetching mail accounts:", e); }
    };

    const fetchMeetingSettings = async () => {
        try {
            const response = await fetch(Get_Meeting_Setting_List, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { ismeeting: 1, userId: Number(LOGGED_USER_ID || "34594") } })
            });
            const data = await response.json();
            let list = data?.Details || data?.d || data || [];
            if (typeof list === 'string') {
                try { list = JSON.parse(list); } catch (e) { console.error("Parse error", e); }
            }
            setMeetingSettings(Array.isArray(list) ? list : []);
        } catch (e) { console.error("Error fetching meeting settings:", e); }
    };

    const fetchMeetingHosts = async (searchText = '') => {
        try {
            const response = await fetch(Get_Meeting_Host, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { participanttype: "host", searchText: searchText, userId: Number(LOGGED_USER_ID || "34594") } })
            });
            const data = await response.json();
            let list = data?.d?.Details || data?.Details || data?.d || data?.Details || data || [];
            if (typeof list === 'string') {
                try { list = JSON.parse(list); } catch (e) { console.error("Parse error", e); }
            }
            if (list && !Array.isArray(list) && list.Details) list = list.Details;
            setHostOptions(Array.isArray(list) ? list : []);
        } catch (e) { console.error("Error fetching meeting hosts:", e); }
    };

    const fetchMeetingCoHosts = async (searchText = '') => {
        try {
            const response = await fetch(Get_Meeting_Host, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { participanttype: "users", searchText: searchText, userId: Number(LOGGED_USER_ID || "34594") } })
            });
            const data = await response.json();
            let list = data?.d?.Details || data?.Details || data?.d || data?.Details || data || [];
            if (typeof list === 'string') {
                try { list = JSON.parse(list); } catch (e) { console.error("Parse error", e); }
            }
            if (list && !Array.isArray(list) && list.Details) list = list.Details;
            setCoHostOptions(Array.isArray(list) ? list : []);
        } catch (e) { console.error("Error fetching meeting co-hosts:", e); }
    };

    const fetchParticipants = async (searchText = '', autoMapLead = false) => {
        try {
            const response = await fetch(Get_Meeting_Host, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { participanttype: "users", searchText: searchText || 'm', userId: Number(LOGGED_USER_ID || "34594") } })
            });
            const data = await response.json();
            let list = data?.d?.Details || data?.Details || data?.d || data?.Details || data || [];
            if (typeof list === 'string') {
                try { list = JSON.parse(list); } catch (e) { console.error("Parse error", e); }
            }
            if (list && !Array.isArray(list) && list.Details) list = list.Details;
            const finalParticipants = Array.isArray(list) ? list : [];
            setParticipantOptions(finalParticipants);

            if (autoMapLead) {
                const leadName = getEnquiryFieldValue('PersonName');
                const leadEmail = getEnquiryFieldValue('Email');
                const leadMobile = getEnquiryFieldValue('Mobile');

                // First try to find in fetched list
                const existing = finalParticipants.find(p => String(p.EntityID || p.UserId || p.Id || p.Value) === String(leadId));

                if (existing) {
                    addParticipant(existing);
                } else if (leadName && leadName !== '-') {
                    // Manually add current lead from basic info if not found in user list
                    addParticipant({
                        EntityID: leadId,
                        EntityName: leadName,
                        EntityEmail: (leadEmail === '-' || !leadEmail) ? "" : leadEmail,
                        EntityMobile: (leadMobile === '-' || !leadMobile) ? "" : leadMobile,
                        EntityType: isLead ? "Lead" : "Enquiry"
                    });
                }
            }
        } catch (e) { console.error("Error fetching participants:", e); }
    };

    const addParticipant = (u) => {
        const id = u.EntityID || u.UserId || u.UserID || u.Id;
        const name = u.EntityName || u.UserName || u.Name || u.User_Name || u.User_login || u.Text || "Unknown";
        const email = u.EntityEmail || u.Email || u.EmailID || "";
        const mobile = u.EntityMobile || u.Mobile || u.MobileNo || "";
        const type = u.Entitytype || u.EntityType || (u.UserId ? "User" : "Enquiry");

        if (!meetingForm.Participants.find(p => p.id === id)) {
            setMeetingForm(prev => ({
                ...prev,
                Participants: [...prev.Participants, {
                    id,
                    name,
                    email,
                    mobile,
                    type
                }]
            }));
        }
        setParticipantSearch('');
        setParticipantOptions([]);
    };

    const removeParticipant = (id) => {
        setMeetingForm(prev => ({
            ...prev,
            Participants: prev.Participants.filter(p => p.id !== id)
        }));
    };

    const fetchMeetingOptions = async () => {
        try {
            // Placeholder for fetching activity types/owners
            setAssignedToOptions([{ Value: getSession()?.userId, Text: getSession()?.userName || 'Me' }]);
        } catch (e) { console.error("Error fetching meeting options:", e); }
    };

    const handleSendLocalSms = async () => {
        if (smsData.chooseNumbers.length === 0) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Select at least one number' }); return; }
        if (!smsData.senderId || !smsData.message) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Fill required fields' }); return; }
        setIsCommLoading(true);
        try {
            const payload = {
                Token: TOKEN, LoggedUserId: getSession()?.userId,
                Details: {
                    LeadId: parseInt(leadId), AccountId: Number(getSession()?.userId),
                    SenderId: smsData.senderId, TemplateId: smsData.templateId,
                    Message: smsData.message, IsUnicode: smsData.isUnicode,
                    MobileNos: smsData.chooseNumbers.map(num => `91 ${num.replace(/\D/g, '').slice(-10)}`),
                    UserId: Number(getSession()?.userId)
                }
            };
            const response = await fetch(`${WCF_BASE}${API_ENDPOINTS.COMMON.NEW_SEND_SMS}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
            });
            if (response.ok) {
                setAlert({ show: true, type: 'success', title: 'Success', message: 'SMS sent successfully' });
                setActiveSidebarAction(null);
                fetchInitialData();
                fetchEnquiryActivities(leadId);
            }
            else { setAlert({ show: true, type: 'error', title: 'Error', message: 'Failed to send SMS' }); }
        } catch (e) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Network error' }); }
        finally { setIsCommLoading(false); }
    };

    const handleSendLocalMail = async () => {
        if (mailData.to.length === 0) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Select at least one email' }); return; }
        if (!mailData.subject || !mailData.body) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Fill required fields' }); return; }
        setIsCommLoading(true);
        try {
            const payload = {
                Token: TOKEN.toString(),
                Details: {
                    objSendMail: {
                        UserId: getSession()?.userId.toString(),
                        EnquiryLeadId: leadId.toString(),
                        Account: mailData.account || "1",
                        SenderName: "CRM",
                        EmailType: mailData.mailMode === 'template' ? "Template" : "Compose",
                        Email: mailData.to.join(','),
                        Subject: mailData.subject,
                        Message: mailData.body,
                        Template: mailData.templateId || "0",
                        EntityType: "Lead",
                        ReplyTo: mailData.replyTo || getSession()?.email || "",
                        FromMailID: mailData.from || getSession()?.email || ""
                    }
                }
            };
            const response = await fetch(`${WCF_BASE}${API_ENDPOINTS.COMMON.NEW_SEND_MAIL}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
            });
            if (response.ok) {
                setAlert({ show: true, type: 'success', title: 'Success', message: 'Email sent successfully' });
                setActiveSidebarAction(null);
                fetchInitialData();
                fetchEnquiryActivities(leadId);
            }
            else { setAlert({ show: true, type: 'error', title: 'Error', message: 'Failed to send Email' }); }
        } catch (e) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Network error' }); }
        finally { setIsCommLoading(false); }
    };

    const handleSendLocalVoice = async () => {
        const num = voiceData.chooseNumbers[0];
        if (!num) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Select a mobile number' }); return; }
        setIsCommLoading(true);
        try {
            const payload = {
                Token: TOKEN,
                Details: {
                    ParentId: Number(leadId),
                    SendVoice: {
                        MobileNo: num.replace(/\D/g, '').slice(-10),
                        Route: voiceData.route === 'trans' ? "2" : "1",
                        AppFlow: voiceData.appFlow || "1",
                        DnidNo: voiceData.dnid || "",
                        Duration: "30", EntityName: "Lead", EntityId: String(leadId)
                    }
                }
            };
            const response = await fetch(`${WCF_BASE}${API_ENDPOINTS.COMMON.ADD_VOICE}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
            });
            if (response.ok) {
                setAlert({ show: true, type: 'success', title: 'Success', message: 'Voice call initiated' });
                setActiveSidebarAction(null);
                fetchInitialData();
                fetchEnquiryActivities(leadId);
            }
            else { setAlert({ show: true, type: 'error', title: 'Error', message: 'Failed to send voice' }); }
        } catch (e) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Network error' }); }
        finally { setIsCommLoading(false); }
    };

    const handleSaveLocalMeeting = async () => {
        if (!meetingData.subject || !meetingData.date || !meetingData.time) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Fill required fields' }); return; }
        setIsCommLoading(true);
        try {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const d = new Date(`${meetingData.date}T${meetingData.time}`);
            const formattedEndDate = `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;

            const payload = {
                Token: TOKEN,
                Details: {
                    TimeZone: "India Standard Time",
                    insertUpdateTask: {
                        Id: 0, Title: meetingData.subject, Description: meetingData.description, Remarks: "",
                        Address: "", StartDate: "", EndDate: formattedEndDate,
                        AssignedTo: parseInt(meetingData.owner, 10),
                        BySMS: false, CollabratoerUserIds: meetingData.collaborators.join('#'),
                        IsActive: true, IsAppointment: false, IsEmail: false, IsSMS: false, IsTask: true,
                        LeadId: parseInt(leadId, 10), Status: "open", TaskId: 1, TaskType: "Meeting"
                    }
                }
            };
            const response = await fetch(`${WCF_BASE}${API_ENDPOINTS.TASKS.INSERT_NEW_TASK_OR_APPOINTMENT}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
            });
            if (response.ok) {
                setAlert({ show: true, type: 'success', title: 'Success', message: 'Meeting scheduled successfully' });
                setActiveSidebarAction(null);
                fetchInitialData();
                fetchEnquiryActivities(leadId);
            }
            else { setAlert({ show: true, type: 'error', title: 'Error', message: 'Failed to schedule meeting' }); }
        } catch (e) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Network error' }); }
        finally { setIsCommLoading(false); }
    };

    const handleSaveLocalAppointment = async () => {
        if (!appointmentData.title || !appointmentData.startDate || !appointmentData.startTime || !appointmentData.where) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Fill required fields' }); return; }
        setIsCommLoading(true);
        try {
            const payload = {
                Token: TOKEN,
                Details: {
                    PhysicalAppointment: {
                        Id: 0, LeadId: parseInt(leadId), Title: appointmentData.title, Remarks: appointmentData.remarks,
                        Address: appointmentData.where, StartDate: `${appointmentData.startDate} ${appointmentData.startTime}`,
                        EndDate: `${appointmentData.endDate} ${appointmentData.endTime}`,
                        AssignedTo: parseInt(appointmentData.owner), Status: "Open", CreatedBy: parseInt(getSession()?.userId)
                    }
                }
            };
            const response = await fetch(`${SERVICE_AZURE_URL}${API_ENDPOINTS.APPOINTMENTS.ADD_PHYSICAL_APPOINTMENT}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
            });
            if (response.ok) {
                setAlert({ show: true, type: 'success', title: 'Success', message: 'Appointment added successfully' });
                setActiveSidebarAction(null);
                fetchInitialData();
                fetchEnquiryActivities(leadId);
            }
            else { setAlert({ show: true, type: 'error', title: 'Error', message: 'Failed to add appointment' }); }
        } catch (e) { setAlert({ show: true, type: 'error', title: 'Error', message: 'Network error' }); }
        finally { setIsCommLoading(false); }
    };

    const renderCreateMeetingPanel = () => {
        const toggleSection = (sectionId) => {
            setMeetingForm(prev => ({
                ...prev,
                [`showSection_${sectionId}`]: !prev[`showSection_${sectionId}`]
            }));
        };

        const renderCollapsibleHeader = (title, sectionId) => (
            <div
                onClick={() => toggleSection(sectionId)}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px 0',
                    borderBottom: '1px solid #f1f5f9',
                    cursor: 'pointer',
                    marginTop: '10px'
                }}
            >
                <span style={{ fontSize: '14px', fontWeight: '700', color: '#334155' }}>{title}</span>
                {meetingForm[`showSection_${sectionId}`] ? (
                    <ChevronDown size={18} style={{ color: '#64748b' }} />
                ) : (
                    <ChevronRight size={18} style={{ color: '#64748b' }} />
                )}
            </div>
        );

        return (
            <div className="sidebar-form-container" style={{ padding: '0', background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <style>{`
                    .meeting-dropdown-list {
                        position: absolute;
                        top: 100%;
                        left: 0;
                        right: 0;
                        background: #fff;
                        border: 1px solid #e2e8f0;
                        border-radius: 8px;
                        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
                        z-index: 1000;
                        max-height: 250px;
                        overflow-y: auto;
                        margin-top: 4px;
                    }
                    .meeting-dropdown-item {
                        padding: 10px 15px;
                        font-size: 13px;
                        color: #334155;
                        cursor: pointer;
                        border-bottom: 1px solid #f8fafc;
                    }
                    .meeting-dropdown-item:hover {
                        background: #eff6ff;
                        color: #2563eb;
                    }
                    .meeting-section-box {
                        background: #fff;
                        padding: 15px;
                        border-radius: 8px;
                        border: 1px solid #f1f5f9;
                        margin-top: 10px;
                    }
                `}</style>
                <div className="action-card">
                    <div className="action-card-header" style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>Create Meeting</h3>
                        <X size={18} style={{ cursor: 'pointer', color: '#64748b' }} onClick={() => setActiveSidebarAction(null)} />
                    </div>
                    <div className="action-card-body" style={{ padding: '20px', maxHeight: 'calc(100vh - 180px)', overflowY: 'auto' }}>
                        <div className="action-form-grid">
                            {/* Meeting Template */}
                            <div className="action-form-row">
                                <label className="action-form-label">Meeting Template</label>
                                <select
                                    className="action-select"
                                    value={meetingForm.TemplateId}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setMeetingForm({ ...meetingForm, TemplateId: val });
                                        fetchTemplateDetails(val);
                                    }}
                                >
                                    <option value="">Select Meeting Settings</option>
                                    {meetingSettings.map(s => (
                                        <option key={s.SettingId} value={s.SettingId}>{s.SettingName} ({s.SettingType})</option>
                                    ))}
                                </select>
                            </div>

                            {/* Meeting Name - Moved below template as requested */}
                            <div className="action-form-row">
                                <label className="action-form-label">Meeting Name</label>
                                <input
                                    type="text"
                                    className="action-input"
                                    placeholder="Enter Meeting Name"
                                    value={meetingForm.MeetingName}
                                    onChange={(e) => setMeetingForm({ ...meetingForm, MeetingName: e.target.value })}
                                />
                            </div>

                            {/* Configuration Sections moved below Meeting Template as requested */}
                            {/* Recording Section */}
                            {renderCollapsibleHeader("Recording", "recording")}
                            {meetingForm.showSection_recording && (
                                <div className="meeting-section-box">
                                    {["autorec", "allowrec", "sendrec"].map(field => (
                                        <label key={field} className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '8px' }}>
                                            <input
                                                type="checkbox"
                                                checked={meetingForm[field]}
                                                onChange={(e) => setMeetingForm({ ...meetingForm, [field]: e.target.checked })}
                                            />
                                            <span style={{ fontSize: '13px' }}>{field === 'autorec' ? 'Auto Start Recording' : field === 'allowrec' ? 'Allow Start Stop Recording' : 'Send meeting recording to participants'}</span>
                                        </label>
                                    ))}
                                    <div className="action-form-row" style={{ marginTop: '10px' }}>
                                        <label className="action-form-label">Meeting Expire If No User Joined In Minutes</label>
                                        <input type="number" className="action-input" value={meetingForm.meetexpire} onChange={e => setMeetingForm({ ...meetingForm, meetexpire: e.target.value })} />
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Banner Text</label>
                                        <input type="text" className="action-input" value={meetingForm.BannerText} onChange={e => setMeetingForm({ ...meetingForm, BannerText: e.target.value })} />
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Logout URL</label>
                                        <input type="text" className="action-input" value={meetingForm.LogoutURL} onChange={e => setMeetingForm({ ...meetingForm, LogoutURL: e.target.value })} />
                                    </div>
                                </div>
                            )}

                            {/* Webcam & Audio Section */}
                            {renderCollapsibleHeader("Webcam & Audio", "audio")}
                            {meetingForm.showSection_audio && (
                                <div className="meeting-section-box">
                                    {[
                                        { key: "webcamonlyfohost", label: "Web cam Only for Host" },
                                        { key: "alwhstunmute", label: "Allow Host To Unmute Users" },
                                        { key: "audiojoin", label: "Audio Join-IN" },
                                        { key: "muteonstart", label: "Mute On Start" },
                                        { key: "dsblmicusers", label: "Disable mic for users" },
                                        { key: "alwhstclscmra", label: "Allow Host To Close Users Cameras" }
                                    ].map(item => (
                                        <label key={item.key} className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '8px' }}>
                                            <input
                                                type="checkbox"
                                                checked={meetingForm[item.key]}
                                                onChange={(e) => setMeetingForm({ ...meetingForm, [item.key]: e.target.checked })}
                                            />
                                            <span style={{ fontSize: '13px' }}>{item.label}</span>
                                        </label>
                                    ))}
                                </div>
                            )}

                            {/* Chat And Auth Setting */}
                            {renderCollapsibleHeader("Chat And Auth Setting", "chat")}
                            {meetingForm.showSection_chat && (
                                <div className="meeting-section-box">
                                    {[
                                        { key: "dsblprvtcht", label: "Disable private chat for users" },
                                        { key: "dsblpblcchat", label: "Disable public chat for users" },
                                        { key: "sendchat", label: "Send chat text to participants" }
                                    ].map(item => (
                                        <label key={item.key} className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '8px' }}>
                                            <input
                                                type="checkbox"
                                                checked={meetingForm[item.key]}
                                                onChange={(e) => setMeetingForm({ ...meetingForm, [item.key]: e.target.checked })}
                                            />
                                            <span style={{ fontSize: '13px' }}>{item.label}</span>
                                        </label>
                                    ))}
                                    <div className="action-form-row" style={{ marginTop: '10px' }}>
                                        <label className="action-form-label">Auth Form</label>
                                        <select className="action-select" value={meetingForm.authType} onChange={e => setMeetingForm({ ...meetingForm, authType: e.target.value })}>
                                            <option value="0">None</option>
                                        </select>
                                    </div>
                                </div>
                            )}

                            {/* Invitation Section */}
                            {renderCollapsibleHeader("Invitation", "invite")}
                            {meetingForm.showSection_invite && (
                                <div className="meeting-section-box">
                                    <label className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '10px' }}>
                                        <input
                                            type="checkbox"
                                            checked={meetingForm.invitebymail}
                                            onChange={(e) => setMeetingForm({ ...meetingForm, invitebymail: e.target.checked })}
                                        />
                                        <span style={{ fontSize: '13px', fontWeight: '600' }}>Participants by mail</span>
                                    </label>
                                    {meetingForm.invitebymail && (
                                        <div className="meeting-section-box" style={{ marginTop: '5px', borderTop: 'none' }}>
                                            <div className="action-form-row">
                                                <label className="action-form-label">Mail Subject</label>
                                                <input type="text" className="action-input" value={meetingForm.invitemailsubject} onChange={e => setMeetingForm({ ...meetingForm, invitemailsubject: e.target.value })} />
                                            </div>
                                            <div className="action-form-row">
                                                <label className="action-form-label">Mail Content</label>
                                                <textarea
                                                    className="action-textarea"
                                                    style={{ minHeight: '80px' }}
                                                    value={meetingForm.invitemailtext}
                                                    onChange={e => setMeetingForm({ ...meetingForm, invitemailtext: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Reminder Section */}
                            {renderCollapsibleHeader("Reminder", "reminder")}
                            {meetingForm.showSection_reminder && (
                                <div className="meeting-section-box">
                                    <label className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '10px' }}>
                                        <input
                                            type="checkbox"
                                            checked={meetingForm.remindbymail}
                                            onChange={(e) => setMeetingForm({ ...meetingForm, remindbymail: e.target.checked })}
                                        />
                                        <span style={{ fontSize: '13px', fontWeight: '600' }}>Remind by mail</span>
                                    </label>
                                    {meetingForm.remindbymail && (
                                        <div className="meeting-section-box" style={{ marginTop: '5px', borderTop: 'none' }}>
                                            <div className="action-form-row">
                                                <label className="action-form-label">Mail Subject</label>
                                                <input type="text" className="action-input" value={meetingForm.remindmailsubject} onChange={e => setMeetingForm({ ...meetingForm, remindmailsubject: e.target.value })} />
                                            </div>
                                            <div className="action-form-row">
                                                <label className="action-form-label">Mail Content</label>
                                                <textarea
                                                    className="action-textarea"
                                                    style={{ minHeight: '80px' }}
                                                    value={meetingForm.remindmailtext}
                                                    onChange={e => setMeetingForm({ ...meetingForm, remindmailtext: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}




                            {/* Start Date & Time */}
                            <div className="action-form-row">
                                <label className="action-form-label">Meeting starts on (local time)</label>
                                <input
                                    type="datetime-local"
                                    className="action-input"
                                    value={formatForDateTimeLocal(meetingForm.StartDateTime)}
                                    onChange={(e) => setMeetingForm({ ...meetingForm, StartDateTime: new Date(e.target.value) })}
                                />
                            </div>

                            {/* End Date & Time */}
                            <div className="action-form-row">
                                <label className="action-form-label">Meeting Ends on (local time)</label>
                                <input
                                    type="datetime-local"
                                    className="action-input"
                                    value={formatForDateTimeLocal(meetingForm.EndDateTime)}
                                    onChange={(e) => setMeetingForm({ ...meetingForm, EndDateTime: new Date(e.target.value) })}
                                />
                            </div>

                            {/* Timezone */}
                            <div className="action-form-row">
                                <label className="action-form-label">Timezone</label>
                                <select
                                    className="action-select"
                                    value={meetingForm.Timezone}
                                    onChange={(e) => setMeetingForm({ ...meetingForm, Timezone: e.target.value })}
                                >
                                    <option>( GMT +5:30 ) India Standard Time (Asia/Colombo)</option>
                                </select>
                            </div>

                            {/* Recurring Meeting */}
                            <div className="action-form-row">
                                <label className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: '10px 0' }}>
                                    <input
                                        type="checkbox"
                                        checked={meetingForm.IsRecurring}
                                        onChange={(e) => setMeetingForm({ ...meetingForm, IsRecurring: e.target.checked })}
                                    />
                                    <span style={{ fontSize: '13px', fontWeight: '600' }}>Recurring Meeting</span>
                                </label>
                            </div>

                            {meetingForm.IsRecurring && (
                                <div className="meeting-section-box">
                                    <div className="action-form-row">
                                        <label className="action-form-label">Repeat type</label>
                                        <select
                                            className="action-select"
                                            value={meetingForm.RepeatType}
                                            onChange={(e) => setMeetingForm({ ...meetingForm, RepeatType: e.target.value })}
                                        >
                                            <option value="">Select Repeat Type</option>
                                            <option value="Daily">Daily</option>
                                            <option value="Weekly">Weekly</option>
                                            <option value="Monthly">Monthly</option>
                                        </select>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Repeat every</label>
                                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '0 12px' }}>
                                            <input
                                                type="number"
                                                className="action-input"
                                                style={{ border: 'none', padding: '8px 0', width: '60px' }}
                                                value={meetingForm.RepeatEvery}
                                                onChange={(e) => setMeetingForm({ ...meetingForm, RepeatEvery: e.target.value })}
                                            />
                                            <span style={{ color: '#64748b', fontSize: '14px' }}>Days</span>
                                        </div>
                                    </div>
                                    <div className="action-form-row">
                                        <label className="action-form-label">Ends</label>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                <input
                                                    type="radio"
                                                    name="endsOn"
                                                    checked={meetingForm.EndsOnType === 'date'}
                                                    onChange={() => setMeetingForm({ ...meetingForm, EndsOnType: 'date' })}
                                                />
                                                On Select Date
                                            </label>
                                            {meetingForm.EndsOnType === 'date' && (
                                                <input
                                                    type="date"
                                                    className="action-input"
                                                    value={meetingForm.EndsOnDate.toISOString().split('T')[0]}
                                                    onChange={(e) => setMeetingForm({ ...meetingForm, EndsOnDate: new Date(e.target.value) })}
                                                />
                                            )}
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                <input
                                                    type="radio"
                                                    name="endsOn"
                                                    checked={meetingForm.EndsOnType === 'times'}
                                                    onChange={() => setMeetingForm({ ...meetingForm, EndsOnType: 'times' })}
                                                />
                                                After
                                            </label>
                                            {meetingForm.EndsOnType === 'times' && (
                                                <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '0 12px' }}>
                                                    <input
                                                        type="number"
                                                        className="action-input"
                                                        style={{ border: 'none', padding: '8px 0', width: '60px' }}
                                                        value={meetingForm.EndsAfterTimes}
                                                        onChange={(e) => setMeetingForm({ ...meetingForm, EndsAfterTimes: e.target.value })}
                                                    />
                                                    <span style={{ color: '#64748b', fontSize: '14px' }}>Times</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Host Selection with Search Fix */}
                            <div className="action-form-row" style={{ position: 'relative' }}>
                                <label className="action-form-label">Host</label>
                                <div className="action-input-wrapper" style={{ display: 'flex', alignItems: 'center', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '0 12px', background: '#fff' }}>
                                    <input
                                        type="text"
                                        className="action-input"
                                        style={{ border: 'none', flex: 1 }}
                                        placeholder="Search Host"
                                        value={hostSearch}
                                        onChange={(e) => {
                                            setHostSearch(e.target.value);
                                            fetchMeetingHosts(e.target.value);
                                        }}
                                        onFocus={() => { if (!hostSearch) fetchMeetingHosts('m'); }}
                                    />
                                    <ChevronDown size={16} color="#64748b" />
                                </div>
                                {hostOptions.length > 0 && hostSearch && (
                                    <div className="meeting-dropdown-list">
                                        {hostOptions.map(h => (
                                            <div key={h.EntityID || h.UserId || h.UserID || h.Id} className="meeting-dropdown-item" onClick={() => {
                                                setMeetingForm({ ...meetingForm, HostId: h.EntityID || h.UserId || h.UserID || h.Id });
                                                setHostSearch(h.EntityName || h.UserName || h.Name || h.User_Name || h.User_login || h.Text || "Unknown");
                                                setHostOptions([]);
                                            }}>
                                                {h.EntityName || h.UserName || h.Name || h.User_Name || h.User_login || h.Text}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Add Co-Host with Visibility Fix */}
                            <div className="action-form-row">
                                <label className="checkbox-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: '5px 0' }}>
                                    <input
                                        type="checkbox"
                                        checked={meetingForm.AddCoHost}
                                        onChange={(e) => {
                                            setMeetingForm({ ...meetingForm, AddCoHost: e.target.checked });
                                            if (e.target.checked && coHostOptions.length === 0) fetchMeetingCoHosts('m');
                                        }}
                                    />
                                    <span style={{ fontSize: '13px' }}>Add Co-Host</span>
                                </label>
                            </div>

                            {meetingForm.AddCoHost && (
                                <div className="action-form-row" style={{ position: 'relative' }}>
                                    <div className="action-input-wrapper" style={{ display: 'flex', alignItems: 'center', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '0 12px', background: '#fff' }}>
                                        <input
                                            type="text"
                                            className="action-input"
                                            style={{ border: 'none', flex: 1 }}
                                            placeholder="Search co-host by name, email"
                                            value={coHostSearch}
                                            onChange={(e) => {
                                                setCoHostSearch(e.target.value);
                                                fetchMeetingCoHosts(e.target.value);
                                            }}
                                            onFocus={() => { if (!coHostSearch) fetchMeetingCoHosts('m'); }}
                                        />
                                        <ChevronDown size={16} color="#64748b" />
                                    </div>
                                    {coHostOptions.length > 0 && coHostSearch && (
                                        <div className="meeting-dropdown-list">
                                            {coHostOptions.map(u => (
                                                <div key={u.EntityID || u.UserId || u.UserID || u.Id} className="meeting-dropdown-item" onClick={() => {
                                                    setMeetingForm({ ...meetingForm, CoHostId: u.EntityID || u.UserId || u.UserID || u.Id });
                                                    setCoHostSearch(u.EntityName || u.UserName || u.Name || u.User_Name || u.User_login || u.Text || "Unknown");
                                                    setCoHostOptions([]);
                                                }}>
                                                    {u.EntityName || u.UserName || u.Name || u.User_Name || u.User_login || u.Text}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}


                            {/* Participant(s) Summary - Made Read-only with blocked cursor as requested */}
                            <div className="action-form-row" style={{ marginTop: '20px' }}>
                                <label className="action-form-label" style={{ color: '#1e293b' }}>Participant(s)</label>

                                <div className="icon-input-container" style={{ position: 'relative' }}>
                                    <div className="action-input-wrapper" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '8px',
                                        padding: '0 12px',
                                        background: '#f1f5f9', // Grey background for read-only
                                        cursor: 'not-allowed' // Block cursor interaction
                                    }}>
                                        <input
                                            type="text"
                                            className="action-input"
                                            readOnly
                                            style={{
                                                border: 'none',
                                                flex: 1,
                                                background: 'transparent',
                                                cursor: 'not-allowed',
                                                color: '#334155'
                                            }}
                                            value={meetingForm.Participants.map(p => p.name).join(', ') || 'No participants'}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="action-footer" style={{ borderTop: '1px solid #f1f5f9', padding: '16px 20px', display: 'flex', justifyContent: 'flex-end', gap: '12px', flexWrap: 'wrap' }}>
                        <button
                            className="btn-cancel"
                            style={{ margin: 0, background: '#fff', border: '1px solid #e2e8f0', color: '#64748b', padding: '10px 20px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}
                            onClick={() => setActiveSidebarAction(null)}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn-save"
                            style={{ margin: 0, background: '#10b981', color: '#fff', border: 'none', padding: '10px 25px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}
                            onClick={handleSaveMeeting}
                            disabled={isMeetingSubmitting}
                        >
                            {isMeetingSubmitting ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const renderCentralizedPanel = () => {
        if (centralizedMode === 'sms' || centralizedMode === 'mail' || centralizedMode === 'voice' || centralizedMode === 'appointment' || centralizedMode === 'AddFollowup' || centralizedMode === 'whatsapp') {
            return (
                <div className="sidebar-form-container sidebar-compact-mode">
                    <EnquiryActionOperation
                        entity={{
                            enquiryId: leadId,
                            MobileNo: getEnquiryFieldValue('Mobile'),
                            Email: getEnquiryFieldValue('Email'),
                            PersonName: getEnquiryFieldValue('PersonName') || 'Lead'
                        }}
                        mode={centralizedMode === 'AddFollowup' ? 'followup' : centralizedMode}
                        onBack={() => setActiveSidebarAction(null)}
                        onSuccess={() => {
                            setActiveSidebarAction(null);
                            fetchEnquiryActivities(leadId);
                        }}
                    />
                </div>
            );
        }

        const titleMap = {
            whatsapp: 'Send WhatsApp',
            meeting: 'Schedule Meeting',
        };

        return (
            <div className="sidebar-form-container" style={{ padding: '0', background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="action-card">
                    <div className="action-card-header" style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>{titleMap[centralizedMode]}</h3>
                        <X size={18} style={{ cursor: 'pointer', color: '#64748b' }} onClick={() => setActiveSidebarAction(null)} />
                    </div>
                    <div className="action-card-body" style={{ padding: '20px' }}>

                        {centralizedMode === 'voice' && (
                            <div className="action-form-grid">
                                <div className="action-form-row">
                                    <label className="action-form-label">Select Number</label>
                                    <select value={voiceData.chooseNumbers[0]} onChange={e => setVoiceData({ ...voiceData, chooseNumbers: [e.target.value] })} className="action-select">
                                        {voiceData.chooseNumbers.map(n => <option key={n} value={n}>{n}</option>)}
                                    </select>
                                </div>
                                <div className="action-form-row">
                                    <label className="action-form-label">Route</label>
                                    <select value={voiceData.route} onChange={e => setVoiceData({ ...voiceData, route: e.target.value })} className="action-select">
                                        <option value="trans">Transactional</option>
                                        <option value="promo">Promotional</option>
                                    </select>
                                </div>
                                <div className="action-footer" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', flexWrap: 'wrap' }}>
                                    <button className="btn-save" onClick={handleSendLocalVoice} disabled={isCommLoading} style={{ background: '#10b981', color: '#fff', padding: '10px 25px' }}>
                                        {isCommLoading ? 'INITIATING...' : 'SEND VOICE'}
                                    </button>
                                </div>
                            </div>
                        )}


                        {centralizedMode === 'appointment' && (
                            <div className="action-form-grid">
                                <div className="action-form-row">
                                    <label className="action-form-label">Title <span style={{ color: '#ef4444' }}>*</span></label>
                                    <input type="text" value={appointmentData.title} onChange={e => setAppointmentData({ ...appointmentData, title: e.target.value })} className="action-input" placeholder="Appointment Title" />
                                </div>
                                <div className="action-form-row">
                                    <label className="action-form-label">Location <span style={{ color: '#ef4444' }}>*</span></label>
                                    <input type="text" value={appointmentData.where} onChange={e => setAppointmentData({ ...appointmentData, where: e.target.value })} className="action-input" placeholder="Where?" />
                                </div>
                                <div className="action-form-row">
                                    <label className="action-form-label">Start Date & Time <span style={{ color: '#ef4444' }}>*</span></label>
                                    <div className="action-datetime-group">
                                        <input type="date" value={appointmentData.startDate} onChange={e => setAppointmentData({ ...appointmentData, startDate: e.target.value })} className="action-input" />
                                        <input type="time" value={appointmentData.startTime} onChange={e => setAppointmentData({ ...appointmentData, startTime: e.target.value })} className="action-input" />
                                    </div>
                                </div>
                                <div className="action-form-row">
                                    <label className="action-form-label">Remarks</label>
                                    <textarea value={appointmentData.remarks} onChange={e => setAppointmentData({ ...appointmentData, remarks: e.target.value })} className="action-textarea" placeholder="Remarks..." />
                                </div>
                                <div className="action-footer" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', flexWrap: 'wrap' }}>
                                    <button className="btn-save" onClick={handleSaveLocalAppointment} disabled={isCommLoading} style={{ background: '#10b981', color: '#fff', padding: '10px 25px' }}>
                                        {isCommLoading ? 'SAVING...' : 'SAVE'}
                                    </button>
                                </div>
                            </div>
                        )}

                        {(centralizedMode === 'sms' || centralizedMode === 'mail') && (
                            <EnquiryActionOperation
                                entity={{
                                    enquiryId: leadId,
                                    MobileNo: basicInfo?.mobileno || enquiryDetailData[2]?.Text || '',
                                    Email: basicInfo?.emailid || '',
                                    PersonName: basicInfo?.personname || enquiryDetailData[1]?.Text || 'Lead'
                                }}
                                mode={centralizedMode === 'sms' ? 'sms' : 'mail'}
                                onBack={() => setActiveSidebarAction(null)}
                                onSuccess={() => {
                                    setActiveSidebarAction(null);
                                    fetchEnquiryActivities(leadId);
                                }}
                            />
                        )}

                        {centralizedMode === 'whatsapp' && (
                            <div className="action-form-grid">
                                <div className="action-empty-state" style={{ textAlign: 'center', padding: '40px 0' }}>
                                    <MessageCircle size={48} color="#10b981" style={{ marginBottom: '16px', opacity: 0.5 }} />
                                    <p style={{ color: '#64748b' }}>WhatsApp integration is managed via templates.</p>
                                    <div className="action-footer" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px', flexWrap: 'wrap' }}>
                                        <button className="btn-save" disabled style={{ background: '#94a3b8', color: '#fff', padding: '10px 25px' }}>COMING SOON</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const fetchCallLogs = async () => {
        try {
            setIsLogLoading(true);
            const response = await fetch(Get_call_logs, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: TOKEN, Details: { EntityName: "Enquiry", EntityID: leadId.toString(), Start: "0", Limit: "10" } })
            });
            if (response.ok) {
                const result = await response.json();
                setCallLogs(result.Details || []);
            }
        } catch (error) { console.error("Error fetching call logs:", error); }
        finally { setIsLogLoading(false); }
    };

    const fetchPastMeetings = async () => {
        try {
            setIsLogLoading(true);
            const response = await fetch(Get_Past_meeting_bind, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                    Details: { EntityId: String(leadId), UserId: Number(localStorage.getItem('userId') || '34594') }
                })
            });
            if (response.ok) {
                const result = await response.json();
                const list = result.d || result.Details || [];
                setPastMeetings(list);
            }
        } catch (error) { console.error("Error fetching past meetings:", error); }
        finally { setIsLogLoading(false); }
    };

    const fetchUpcomingMeetings = async () => {
        try {
            setIsLogLoading(true);
            const response = await fetch(Get_Upcoming_meeting_bind, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                    Details: { EntityId: String(leadId), UserId: Number(localStorage.getItem('userId') || '34594') }
                })
            });
            if (response.ok) {
                const result = await response.json();
                const list = result.d || result.Details || [];
                setUpcomingMeetings(list);
            }
        } catch (error) { console.error("Error fetching upcoming meetings:", error); }
        finally { setIsLogLoading(false); }
    };


    const fetchWaChatLogs = async (leadId) => {
        try {
            setIsLogLoading(true);
            const resId = await fetch(For_Wa_Chat_CONID, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ EntityID: leadId.toString(), EntityName: "lead" })
            });
            if (resId.ok) {
                const idResult = await resId.json();
                const conversationId = idResult.d;
                if (conversationId) {
                    const response = await fetch(GetWa_chat, {
                        method: 'POST',
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            Token: TOKEN,
                            Details: {
                                UserId: Number(localStorage.getItem('userId') || '34594'),
                                EntityId: leadId.toString(),
                                EntityName: "Lead",
                                ConversationId: Number(conversationId),
                                LeadActivityId: 0,
                                Direction: "inbound"
                            }
                        })
                    });
                    if (response.ok) {
                        const result = await response.json();
                        let logs = [];
                        if (result.Details) {
                            try { logs = typeof result.Details === 'string' ? JSON.parse(result.Details) : result.Details; } catch (e) { logs = result.Details; }
                        } else if (result.d) {
                            try { logs = typeof result.d === 'string' ? JSON.parse(result.d) : result.d; } catch (e) { logs = result.d; }
                        }
                        setWaChatLogs(Array.isArray(logs) ? logs : []);
                    }
                }
            }
        } catch (error) { console.error("Error fetching waChat logs:", error); }
        finally { setIsLogLoading(false); }
    };

    const fetchPhysicalAppointments = async (id) => {
        try {
            setIsPhysicalApptLoading(true);
            const response = await fetch(Get_Physical_Appointment_List, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { EntityId: Number(id), EntityName: "Enquiry" } })
            });
            if (response.ok) {
                const result = await response.json();
                const list = result.d || result.Details || [];
                setPhysicalAppointments(Array.isArray(list) ? list : []);
            }
        } catch (e) { console.error("Error fetching physical appointments:", e); }
        finally { setIsPhysicalApptLoading(false); }
    };

    const fetchWebforms = async () => {
        try {
            setIsWebformLoading(true);
            const response = await fetch(webformDetails, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { LeadId: parseInt(leadId, 10) } })
            });
            const data = await response.json();
            const result = safeParse(data);
            // Handling result.d or result.Details
            let list = [];
            if (result?.d) {
                try { list = typeof result.d === 'string' ? JSON.parse(result.d) : result.d; } catch (e) { list = result.d; }
            } else if (result?.Details) {
                try { list = typeof result.Details === 'string' ? JSON.parse(result.Details) : result.Details; } catch (e) { list = result.Details; }
            }
            // Sometimes it's wrapped in Table/Table1
            const finalData = list?.Table || list?.Table1 || list || [];
            setWebforms(Array.isArray(finalData) ? finalData : []);
        } catch (e) { console.error("Error fetching webforms:", e); }
        finally { setIsWebformLoading(false); }
    };

    const fetchDocuments = async () => {
        try {
            setIsDocsLoading(true);
            const response = await fetch(For_Document, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, LoggedUserId: localStorage.getItem('userId') || '34594', Details: { LeadId: parseInt(leadId, 10), timeZone: "India Standard Time" } })
            });
            const data = await response.json();
            const list = safeParse(data)?.Details || safeParse(data)?.d || [];
            setDocuments(Array.isArray(list) ? list : []);
        } catch (e) { console.error("Error fetching documents:", e); }
        finally { setIsDocsLoading(false); }
    };



    const fetchScorecardDataForHover = async (id) => {
        if (!id) return;
        try {
            setIsScorecardLoading(true);
            const response = await fetch(SCORECARD_URL, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=UTF-8" },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { EnquiryID: id.toString() } })
            });
            if (response.ok) {
                const result = await response.json();
                if (result.Details || result.d) {
                    setHoverScoreRec(result.Details?.[0] || result.d?.[0] || result.Details || result.d);
                }
            }
        } catch (error) { console.error("Error fetching scorecard data:", error); }
        finally { setIsScorecardLoading(false); }
    };

    const handleScorecardMouseEnter = (e, id) => {
        if (scorecardTimerRef.current) clearTimeout(scorecardTimerRef.current);
        const rect = e.currentTarget.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        setPopupPosition({ top: rect.top + scrollTop, left: rect.left + scrollLeft + (rect.width / 2) });
        scorecardTimerRef.current = setTimeout(() => { setHoveredLeadId(id); fetchScorecardDataForHover(id); }, 400);
    };

    const handleScorecardMouseLeave = () => {
        if (scorecardTimerRef.current) clearTimeout(scorecardTimerRef.current);
        setHoveredLeadId(null); setHoverScoreRec(null);
    };

    // Lazy load tab data
    useEffect(() => {
        if (!leadId) return;
        if (activeTab === 'Activities') fetchEnquiryActivities(leadId);
        else if (activeTab === 'Chat') fetchChatLogs(leadId);
        else if (activeTab === 'Whatsapp Chat Log') fetchWaChatLogs(leadId);
        else if (activeTab === 'Calls') fetchCallLogs(leadId);
        else if (activeTab === 'Meetings') { fetchPastMeetings(leadId); fetchUpcomingMeetings(leadId); }
        else if (activeTab === 'Physical Appointment') fetchPhysicalAppointments(leadId);
        else if (activeTab === 'Webform') fetchWebforms(leadId);
    }, [activeTab, leadId]);


    // Initial load: basic info, scorecard, activities
    const fetchInitialData = async () => {
        if (!leadId) return;
        try {
            setLoading(true);
            const { userId, parentId } = getSession();
            const finalUserId = userId || "34594";
            const finalParentId = parentId || "34594";

            // Unified fetch using GetEnquiryList (as requested: Get_Enquiry_Data)
            const payload = {
                Token: TOKEN,
                Details: {
                    txt_search: "",
                    SearchText: "",
                    TextSearch: "",
                    FilterText: `EnquiryId=${leadId}`,
                    parent_id: Number(finalParentId),
                    ParentId: Number(finalParentId),
                    user_id: Number(finalUserId),
                    UserId: Number(finalUserId),
                    filter_text: `EnquiryId=${leadId}`,
                    order_str: "CreatedDate desc",
                    srno: "1",
                    enno: "20",
                    ue_query: ""
                }
            };

            const [enqRes, scorecardRes] = await Promise.allSettled([
                fetch(Get_Enquiry_Data, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                }),
                fetch(SCORECARD_URL, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json; charset=UTF-8" },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: { EnquiryID: leadId.toString() } })
                }).then(r => r.json()).then(res => ({ d: res.Details || res.d }))
            ]);

            if (enqRes.status === 'fulfilled' && enqRes.value.ok) {
                const data = await enqRes.value.json();
                const rawData = data.Details || data.Details?.data || [];
                const leadData = (Array.isArray(rawData) ? rawData[0] : rawData) || {};

                if (leadData && Object.keys(leadData).length > 0) {
                    // Map basic fields with priority to the provided response structure
                    const rawBasic = {
                        ...leadData,
                        PersonName: leadData.PersonName || leadData.personname || '',
                        CompanyName: leadData.CompanyName || leadData.companyname || '',
                        MobileNo: leadData.MobileNo || leadData.MobileNo3 || leadData.mobileno || '',
                        EmailID: leadData.EmailID || leadData.EmailID3 || leadData.emailid || '',
                        SourceName: leadData.SourceName || leadData.source || '',
                        MediumName: leadData.MediumName || leadData.medium || '',
                        CampaignName: leadData.CampaignName || leadData.campaignname || '',
                        CreatedOn: leadData.CreatedDate || leadData.CreatedOn || leadData.createdon || '',
                        ModifiedOn: leadData.ModifiedOn || leadData.modifiedon || '',
                        LeadNo: leadData.LeadNo || leadData.leadno || leadData.EnquiryId || '',
                        ResidentialAddress: leadData.Residentialaddress || leadData.ResidentialAddress || leadData.resiaddress || '',
                        OfficeAddress: leadData.Officeaddress || leadData.OfficeAddress || leadData.officeaddress || '',
                        City: leadData.City || leadData.CityName || '',
                        State: leadData.State || leadData.StateName || '',
                        Country: leadData.Country || leadData.CountryName || '',
                        Remarks: leadData.Remarks || leadData.Initialremarks || leadData.InitialRemarks || '',
                        CreatedByName: leadData.User_login || leadData.CreatedByName || '',
                        EnquiryId: leadData.EnquiryId || leadId,
                        Latitude: leadData.Latitude || leadData.latitude || '',
                        Longitude: leadData.Longitude || leadData.longitude || '',
                        Where: leadData.Where || leadData.where || ''
                    };
                    const basic = maskObject(rawBasic);
                    setBasicInfo(basic);
                    setEditForm(prev => ({
                        ...prev,
                        PersonName: rawBasic.PersonName,
                        Company: rawBasic.CompanyName,
                        Mobile1: rawBasic.MobileNo,
                        Email1: rawBasic.EmailID,
                        Source: rawBasic.SourceName,
                        Medium: rawBasic.MediumName,
                        Campaign: rawBasic.CampaignName,
                        ResiAddress: rawBasic.ResidentialAddress,
                        OfficeAddress: rawBasic.OfficeAddress,
                        City: rawBasic.City,
                        State: rawBasic.State,
                        Country: rawBasic.Country,
                        Remarks: rawBasic.Remarks
                    }));

                    // Map all keys from response to customFieldsData for dynamic rendering
                    const fieldsMap = {};
                    Object.keys(leadData).forEach(key => {
                        fieldsMap[key] = leadData[key] !== null ? String(leadData[key]) : '';
                    });

                    // Also handle lstCustomField if it exists for legacy compatibility
                    if (leadData.lstCustomField && Array.isArray(leadData.lstCustomField)) {
                        leadData.lstCustomField.forEach(cf => {
                            if (cf.FieldId) {
                                fieldsMap[String(cf.FieldId)] = cf.FieldValue || '';
                            }
                        });
                    }
                    setCustomFieldsData(prev => ({ ...prev, ...fieldsMap }));
                }
            }

            if (scorecardRes.status === 'fulfilled' && scorecardRes.value.ok) {
                const data = await scorecardRes.value.json();
                setScoreCard(data.d || data);
            }

            // Primary data is now from GetEnquiryList, we only need conflicts and labels/types
            await Promise.all([
                fetchCustomDataMore(leadId), // Needed for UI labels and metadata
                fetchLeadConflicts(leadId)
            ]);

        } catch (error) {
            console.error("Error fetching initial lead data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!leadId) return;
        fetchInitialData();
    }, [leadId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openMenuId && !event.target.closest('.meeting-menu-wrapper')) {
                setOpenMenuId(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [openMenuId]);

    const getAvatarStyle = (name) => {
        const palettes = [
            { bg: '#eff6ff', text: '#3b82f6', border: '#dbeafe' }, // Blue
            { bg: '#ecfdf5', text: '#10b981', border: '#d1fae5' }, // Green
            { bg: '#fff1f2', text: '#f43f5e', border: '#ffe4e6' }, // Rose
            { bg: '#fffbeb', text: '#f59e0b', border: '#fef3c7' }, // Amber
            { bg: '#f5f3ff', text: '#8b5cf6', border: '#ede9fe' }, // Violet
            { bg: '#ecfeff', text: '#06b6d4', border: '#cffafe' }  // Cyan
        ];
        const charCode = (name || 'U').charCodeAt(0);
        return palettes[charCode % palettes.length];
    };

    const getInitials = (name) => {
        if (!name) return 'U';
        // List of titles to ignore (case-insensitive and with/without dots)
        const titles = ['mr.', 'mrs.', 'ms.', 'dr.', 'prof.', 'rev.', 'mr', 'mrs', 'ms', 'dr'];
        const parts = name.split(' ').filter(part => {
            if (!part) return false;
            const cleaned = part.toLowerCase().trim();
            return !titles.includes(cleaned);
        });
        if (parts.length === 0) return name.substring(0, 2).toUpperCase();
        return parts.map(n => n[0]).join('').substring(0, 2).toUpperCase();
    };

    const initiateCall = (e, phoneNum) => {
        if (e) e.stopPropagation();

        const rect = e?.currentTarget?.getBoundingClientRect();

        const rawStatus = (enquiryDetailData && enquiryDetailData.length > 0)
            ? (enquiryDetailData[16]?.Text || enquiryDetailData[3]?.Text || enquiryDetailData[15]?.Text || '')
            : (basicInfo?.Isopen || basicInfo?.IsOpen || '');
        const statusText = String(rawStatus).toLowerCase();
        const entityName = (statusText.includes('lead') || statusText === 'true') ? 'Lead' : 'Enquiry';

        setCallWidgetData({
            toMobileNo: phoneNum || basicInfo?.__original?.MobileNo || basicInfo?.MobileNo,
            entityId: leadId,
            entityName: 'enquiry',
            personName: basicInfo?.__original?.PersonName || basicInfo?.PersonName,
            personImage: basicInfo?.ProfileImg,
            triggerRect: rect ? {
                top: rect.top,
                left: rect.left,
                bottom: rect.bottom,
                right: rect.right,
                width: rect.width,
                height: rect.height
            } : null,
            toEmail: basicInfo?.__original?.EmailID || basicInfo?.EmailID,
            extraContactInfo: {
                emails: [
                    basicInfo?.__original?.EmailID || basicInfo?.EmailID,
                    basicInfo?.__original?.EmailID1 || basicInfo?.EmailID1,
                    basicInfo?.__original?.EmailID2 || basicInfo?.EmailID2,
                    basicInfo?.__original?.EmailID3 || basicInfo?.EmailID3
                ].filter(Boolean),
                mobiles: [
                    basicInfo?.__original?.MobileNo || basicInfo?.MobileNo,
                    basicInfo?.__original?.MobileNo1 || basicInfo?.MobileNo1,
                    basicInfo?.__original?.MobileNo2 || basicInfo?.MobileNo2,
                    basicInfo?.__original?.MobileNo3 || basicInfo?.MobileNo3
                ].filter(Boolean)
            }
        });

        setIsCallWidgetOpen(true);
    };

    if (!leadId) return null;
    if (loading) return (
        <div className="lead-details-view open">
            <div className="lead-details-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Loader />
            </div>
        </div>
    );
    const leadRec = basicInfo || {};
    const scoreRec = (Array.isArray(scoreCard) && scoreCard.length > 0 ? scoreCard[0] : (scoreCard?.Table?.[0] || {}));
    const getEnquiryVal = (idx) => enquiryDetailData[idx]?.Text || '';
    const isDateStr = (s) => s && s.includes(':') && /\d/.test(s);
    const isTagStr = (s) => s && s.includes(',') && s.length > 50;

    // Unified dynamic mapping for both Lead and Enquiry
    const isNumeric = (s) => s && /^[0-9+\s()-]+$/.test(s) && s.length > 5;

    let mobileIdx = 2;
    let emailIdx = 3;
    let sourceIdx = 4;
    let dateIdx = 5;
    let nameIdx = 6;

    // Detection: If Index 2 is NOT numeric but Index 3 IS, it's a shifted response (like Vincent)
    if (!isNumeric(getEnquiryVal(2)) && isNumeric(getEnquiryVal(3))) {
        mobileIdx = 3;
        emailIdx = 4;
        sourceIdx = 2; // Source shifted to index 2?
        dateIdx = 5;
        nameIdx = 6;
    }
    // Detection: If Index 4 is Source and 5 is Date (Standard Lead/Enquiry)
    else if (!isDateStr(getEnquiryVal(5)) && isDateStr(getEnquiryVal(6))) {
        sourceIdx = 5;
        dateIdx = 6;
        nameIdx = 7;
    }

    const lead = {
        PersonName: basicInfo.PersonName || '',
        CompanyName: basicInfo.CompanyName || '',
        MobileNo: basicInfo.MobileNo || '',
        MobileNo2: basicInfo.MobileNo2 || '',
        MobileNo3: basicInfo.MobileNo3 || '',
        EmailId: basicInfo.EmailID || '',
        EmailId2: basicInfo.EmailID2 || '',
        EmailId3: basicInfo.EmailID3 || '',
        AssignedTo: basicInfo.AssignedTo || '',
        StateName: basicInfo.State || basicInfo.StateName || '',
        CurrentScore: scoreRec.CurrentScore || basicInfo.CurrentScore || '0',
        CreatedOn: basicInfo.CreatedOn || '',
        LastUpdatedOn: basicInfo.ModifiedOn || '',
        LeadNo: basicInfo.LeadNo || basicInfo.EnquiryId || '',
        CampaignName: basicInfo.CampaignName || '',
        SourceName: basicInfo.SourceName || '',
        MediumName: basicInfo.MediumName || '',
        CreatedByName: basicInfo.CreatedByName || '',
        Remarks: basicInfo.Remarks || '',
        Address: basicInfo.OfficeAddress || basicInfo.ResidentialAddress || '',
        AddNum: basicInfo.MobileNo2 || '',
        AlternatNum: basicInfo.MobileNo3 || '',
        WhatsappNum: basicInfo.MobileNo || '',
        WhatsappRes: basicInfo.whatsaap_response || '',
        ProfileImg: basicInfo.Img_ext || 'ProfileDefault.png',
        Latitude: basicInfo.Latitude || '',
        Longitude: basicInfo.Longitude || '',
        Where: basicInfo.Where || ''
    };

    const isOpenValue = String(basicInfo.Isopen || basicInfo.IsOpen || basicInfo.isopen || isopen || '').toLowerCase();
    const isOpenRecord = isOpenValue === 'open' || isOpenValue === 'true' || isOpenValue === '1' || basicInfo.IsOpen === true || basicInfo.Isopen === true || basicInfo.isopen === true || isopen === true || isopen === 'true';

    const scoreData = scoreCard?.Table1 || [];

    const getUniqueMobiles = () => {
        if (!basicInfo) return [];
        const originalInfo = basicInfo.__original || basicInfo;
        const mobileKeys = ['MobileNo', 'MobileNo1', 'MobileNo2', 'MobileNo3'];

        const unique = [];
        const seenEnds = new Set();

        const sortedKeys = mobileKeys.sort((a, b) => {
            const valA = String(originalInfo[a] || '');
            const valB = String(originalInfo[b] || '');
            return valB.length - valA.length;
        });

        sortedKeys.forEach(key => {
            const origVal = originalInfo[key];
            const displayVal = basicInfo[key];

            if (origVal && origVal !== 'N/A' && origVal !== '0') {
                const digits = String(origVal).replace(/\D/g, '');
                const end10 = digits.length >= 10 ? digits.slice(-10) : digits;

                if (!seenEnds.has(end10) && end10.length > 0 && displayVal) {
                    seenEnds.add(end10);
                    unique.push(String(displayVal).trim());
                }
            }
        });
        return unique;
    };

    const getUniqueEmails = () => {
        if (!basicInfo) return [];
        const originalInfo = basicInfo.__original || basicInfo;
        const emailKeys = ['EmailId', 'EmailId1', 'EmailId2', 'EmailId3', 'EmailID', 'EmailID1', 'EmailID2', 'EmailID3'];

        const unique = [];
        const seen = new Set();

        emailKeys.forEach(key => {
            const origVal = originalInfo[key];
            const displayVal = basicInfo[key];

            if (origVal && origVal !== 'N/A' && origVal !== '0') {
                const lower = String(origVal).toLowerCase().trim();
                if (!seen.has(lower) && lower.length > 0 && displayVal) {
                    seen.add(lower);
                    unique.push(String(displayVal).trim());
                }
            }
        });
        return unique;
    };

    const uniqueMobiles = getUniqueMobiles();
    const uniqueEmails = getUniqueEmails();

    return (
        <div className="lead-details-view" id="enquiry-lead-details">
            <div className="lead-details-header">
                <button className="back-to-list-btn" onClick={onBack}>
                    <X size={18} style={{ color: '#00a6e6' }} />
                    <span>Back to Enquiry</span>
                </button>
            </div>

            <div className="lead-details-content-wrapper">
                <div className="lead-details-main-content">
                    <div className="details-section basic-details">
                        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>{isEditing ? 'Edit Basic Details' : 'Basic Details'}</span>
                            <div className="header-actions" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                {isEditing ? (
                                    <>
                                        <div
                                            onClick={handleCancelEdit}
                                            style={{ backgroundColor: '#fef2f2', color: '#ef4444', padding: '4px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <X size={18} />
                                        </div>
                                        <button
                                            onClick={handleUpdateEdit}
                                            style={{ backgroundColor: '#82c91e', color: '#fff', border: 'none', padding: '6px 16px', borderRadius: '4px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                                        >
                                            Update
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        {crmOperationPerms?.Edit !== false && (
                                            <div
                                                className="icon-btn-circle"
                                                style={{ backgroundColor: '#f0fdf4', color: '#16a34a', padding: '4px', borderRadius: '4px', cursor: 'pointer' }}
                                                onClick={handleEnterEdit}
                                            >
                                                <Pencil size={18} />
                                            </div>
                                        )}
                                        {crmOperationPerms?.Delete !== false && (
                                            <div
                                                className="icon-btn-circle"
                                                style={{ backgroundColor: '#fef2f2', color: '#ef4444', padding: '4px', borderRadius: '4px', cursor: 'pointer' }}
                                                onClick={() => setShowDeleteConfirm(true)}
                                            >
                                                <Trash2 size={18} />
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="section-body">
                            <div className="lead-overview">
                                <div
                                    className="lead-avatar-big"
                                    onMouseEnter={(e) => handleScorecardMouseEnter(e, leadId)}
                                    onMouseLeave={handleScorecardMouseLeave}
                                    style={{ cursor: 'pointer', position: 'relative' }}
                                >
                                    <div
                                        className="avatar-circle rounded-full flex items-center justify-center"
                                        style={{
                                            backgroundColor: getAvatarStyle(lead.PersonName).bg,
                                            color: getAvatarStyle(lead.PersonName).text,
                                            border: `2px solid ${getAvatarStyle(lead.PersonName).border}`,
                                            width: '52px',
                                            height: '52px',
                                            minWidth: '52px',
                                            minHeight: '52px',
                                            borderRadius: '50%',
                                            overflow: 'hidden',
                                            flexShrink: 0,
                                        }}
                                    >
                                        {getInitials(lead.PersonName)}
                                        {isEditing && (
                                            <div className="avatar-edit-overlay" style={{ position: 'absolute', bottom: 0, right: 0, backgroundColor: '#c5d0e6', borderRadius: '50%', padding: '4px', cursor: 'pointer' }}>
                                                <X size={12} style={{ color: '#ef4444' }} onClick={() => setProfileFile(null)} />
                                            </div>
                                        )}
                                    </div>

                                    {/* Score Badge - Repositioned to top-left and resized */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-10px',
                                            left: '-10px',
                                            backgroundColor: '#3b82f6',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '22px',
                                            height: '22px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '10px',
                                            fontWeight: 'bold',
                                            border: '2px solid #fff',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            zIndex: 5
                                        }}
                                    >
                                        {Math.floor(Number(lead.CurrentScore || 0))}
                                    </div>
                                </div>
                                {isEditing && (
                                    <div className="profile-upload-actions" style={{ marginLeft: '15px' }}>
                                        <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            id="profile-upload"
                                            onChange={(e) => setProfileFile(e.target.files[0])}
                                        />
                                        <label htmlFor="profile-upload" className="choose-file-btn" style={{ fontSize: '12px', color: '#3b82f6', cursor: 'pointer', border: '1px solid #3b82f6', padding: '2px 8px', borderRadius: '4px', display: 'block', marginBottom: '4px' }}>
                                            Choose File
                                        </label>
                                        <p style={{ fontSize: '10px', color: '#64748b' }}>No file chosen</p>
                                        <p style={{ fontSize: '10px', color: '#16a34a', marginTop: '4px' }}>(jpg, png, bmp & gif images max size 1mb)</p>
                                        <button className="save-avatar-btn" style={{ backgroundColor: '#82c91e', color: '#fff', border: 'none', padding: '4px 12px', borderRadius: '15px', fontSize: '12px', cursor: 'pointer', marginTop: '8px' }}>Save</button>
                                    </div>
                                )}
                                <div className="lead-info-main" style={{ flex: 1 }}>
                                    {isEditing ? (
                                        <div className="edit-fields-grid" style={{ display: 'grid', gap: '10px', minWidth: 0 }}>
                                            <div className="edit-field">
                                                <label style={{ fontSize: '12px', color: '#64748b', display: 'block' }}>Name</label>
                                                <input
                                                    type="text"
                                                    className="edit-input"
                                                    value={editForm.PersonName}
                                                    onChange={(e) => setEditForm({ ...editForm, PersonName: e.target.value })}
                                                    style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                                />
                                            </div>
                                            <div className="edit-field">
                                                <label style={{ fontSize: '12px', color: '#64748b', display: 'block' }}>Company</label>
                                                <input
                                                    type="text"
                                                    className="edit-input"
                                                    placeholder="Company name"
                                                    value={editForm.Company}
                                                    onChange={(e) => setEditForm({ ...editForm, Company: e.target.value })}
                                                    style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                                />
                                            </div>
                                            {/* Mobile Fields List */}
                                            <div className="edit-field">
                                                <label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '4px' }}>Mobile Numbers</label>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', overflow: 'hidden' }}>
                                                    {mobiles.map((m, idx) => (
                                                        <div key={idx} style={{ position: 'relative' }}>
                                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                                <div
                                                                    onClick={() => toggleMobileDropdown(idx)}
                                                                    style={{
                                                                        padding: '6px',
                                                                        border: '1px solid #e2e8f0',
                                                                        borderRadius: '4px',
                                                                        background: '#f8fafc',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        gap: '4px',
                                                                        minWidth: '85px',
                                                                        justifyContent: 'space-between'
                                                                    }}
                                                                >
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                        <img src={m.flag} alt="flag" style={{ width: '18px', height: '12px', objectFit: 'cover', borderRadius: '1px' }} />
                                                                        <span style={{ fontSize: '12px', fontWeight: '500', color: '#334155' }}>{m.dialCode}</span>
                                                                    </div>
                                                                    <span style={{ fontSize: '10px', color: '#94a3b8' }}>▼</span>
                                                                </div>

                                                                <input
                                                                    type="text"
                                                                    className="edit-input"
                                                                    placeholder={`Mobile ${idx + 1}`}
                                                                    value={m.number}
                                                                    onChange={(e) => updateMobile(idx, 'number', e.target.value.replace(/\D/g, ''))}
                                                                    style={{ flex: 1, padding: '6px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                                                />

                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                    {idx > 0 && (
                                                                        <Trash2
                                                                            size={14}
                                                                            onClick={() => removeMobileField(idx)}
                                                                            style={{ color: '#ef4444', cursor: 'pointer', padding: '2px' }}
                                                                        />
                                                                    )}
                                                                    {idx === mobiles.length - 1 && mobiles.length < 3 && (
                                                                        <Plus
                                                                            size={16}
                                                                            onClick={addMobileField}
                                                                            style={{ color: '#3b82f6', cursor: 'pointer', background: '#eff6ff', borderRadius: '50%', padding: '2px' }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Searchable Dial Code Dropdown */}
                                                            {m.showDropdown && (
                                                                <div className="dial-code-dropdown" style={{
                                                                    position: 'absolute',
                                                                    top: '100%',
                                                                    left: 0,
                                                                    zIndex: 1000,
                                                                    background: '#fff',
                                                                    border: '1px solid #e2e8f0',
                                                                    borderRadius: '6px',
                                                                    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
                                                                    marginTop: '4px',
                                                                    maxHeight: '250px',
                                                                    overflowY: 'auto',
                                                                    width: '280px'
                                                                }}>
                                                                    <div style={{ position: 'sticky', top: 0, background: '#fff', padding: '8px', borderBottom: '1px solid #f1f5f9' }}>
                                                                        <div style={{ position: 'relative' }}>
                                                                            <Search size={14} style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Search country..."
                                                                                className="dial-search-input"
                                                                                value={dialSearchTerm}
                                                                                autoFocus
                                                                                style={{ width: '100%', padding: '6px 10px 6px 28px', fontSize: '12px', border: '1px solid #e2e8f0', borderRadius: '4px', outline: 'none' }}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                                onChange={(e) => setDialSearchTerm(e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {dynamicCountries
                                                                        .filter(c =>
                                                                            c.name.toLowerCase().includes(dialSearchTerm.toLowerCase()) ||
                                                                            c.dialCode.includes(dialSearchTerm)
                                                                        )
                                                                        .map((c, i) => (
                                                                            <div
                                                                                key={i}
                                                                                onClick={() => {
                                                                                    updateMobile(idx, 'dialCode', c.dialCode);
                                                                                    updateMobile(idx, 'flag', c.flag);
                                                                                    toggleMobileDropdown(idx, false);
                                                                                    setDialSearchTerm('');
                                                                                }}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '10px',
                                                                                    padding: '10px 12px',
                                                                                    cursor: 'pointer',
                                                                                    borderBottom: '1px solid #f8fafc',
                                                                                    transition: 'background 0.2s'
                                                                                }}
                                                                                onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                                                                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                                                            >
                                                                                <img src={c.flag} alt={c.name} style={{ width: '20px', height: '14px', objectFit: 'cover', borderRadius: '1px' }} />
                                                                                <span style={{ fontSize: '13px', flex: 1, color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}</span>
                                                                                <span style={{ fontSize: '12px', color: '#64748b', fontWeight: '600', minWidth: '45px', textAlign: 'right' }}>{c.dialCode}</span>
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Email Fields List */}
                                            <div className="edit-field">
                                                <label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '4px' }}>Email Addresses</label>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', overflow: 'hidden' }}>
                                                    {emails.map((email, idx) => (
                                                        <div key={idx} style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                            <input
                                                                type="text"
                                                                className="edit-input"
                                                                placeholder={`Email ${idx + 1}`}
                                                                value={email}
                                                                onChange={(e) => updateEmail(idx, e.target.value)}
                                                                style={{ flex: 1, padding: '6px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                                            />
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                {idx > 0 && (
                                                                    <Trash2
                                                                        size={14}
                                                                        onClick={() => removeEmailField(idx)}
                                                                        style={{ color: '#ef4444', cursor: 'pointer', padding: '2px' }}
                                                                    />
                                                                )}
                                                                {idx === emails.length - 1 && emails.length < 3 && (
                                                                    <Plus
                                                                        size={16}
                                                                        onClick={addEmailField}
                                                                        style={{ color: '#3b82f6', cursor: 'pointer', background: '#eff6ff', borderRadius: '50%', padding: '2px' }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="edit-field">
                                                <label style={{ fontSize: '12px', color: '#64748b', display: 'block' }}>Country</label>
                                                <select
                                                    className="edit-select"
                                                    value={editForm.CountryId}
                                                    onChange={handleCountryChange}
                                                    style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                                >
                                                    <option value="">{countries.length > 0 ? 'Select Country' : 'Loading...'}</option>
                                                    {countries.map((c, i) => (
                                                        <option key={i} value={c.Id}>{c.Value}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                                <div className="edit-field">
                                                    <label style={{ fontSize: '12px', color: '#64748b', display: 'block' }}>State</label>
                                                    <select
                                                        className="edit-select"
                                                        value={editForm.StateId}
                                                        onChange={handleStateChange}
                                                        disabled={!editForm.CountryId || isLocationLoading}
                                                        style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px', background: !editForm.CountryId ? '#f1f5f9' : '#fff' }}
                                                    >
                                                        <option value="">{isLocationLoading ? 'Loading...' : 'Select State'}</option>
                                                        {statesList.map((s, i) => (
                                                            <option key={i} value={s.Id}>{s.Value}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="edit-field">
                                                    <label style={{ fontSize: '12px', color: '#64748b', display: 'block' }}>City</label>
                                                    <select
                                                        className="edit-select"
                                                        value={editForm.CityId}
                                                        onChange={handleCityChange}
                                                        disabled={!editForm.StateId || isLocationLoading}
                                                        style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px', background: !editForm.StateId ? '#f1f5f9' : '#fff' }}
                                                    >
                                                        <option value="">{isLocationLoading ? 'Loading...' : 'Select City'}</option>
                                                        {citiesList.map((c, i) => (
                                                            <option key={i} value={c.Id}>{c.Value}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {lead.AssignedTo && (
                                                <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{ fontSize: '12px', color: '#64748b', fontWeight: '600' }}>Assigned To:</span>
                                                    <span style={{ fontSize: '13px', color: '#1e293b', fontWeight: '500' }}>{lead.AssignedTo}</span>
                                                </div>
                                            )}
                                            <h3 className="lead-name-text" style={{ fontSize: '18px', fontWeight: '700', color: '#1e293b', marginBottom: '4px' }}>{lead.PersonName}</h3>
                                            {lead.LeadNo && (
                                                <div style={{ marginBottom: '12px' }}>
                                                    <span style={{ backgroundColor: '#22c55e', color: '#fff', borderRadius: '4px', padding: '2px 10px', fontSize: '12px', fontWeight: '700' }}>
                                                        {lead.LeadNo}
                                                    </span>
                                                </div>
                                            )}
                                            <div className="lead-contact-info" style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                                {/* Mobile Numbers De-duplication */}
                                                {uniqueMobiles.map((num, idx) => (
                                                    <span key={`mob-${idx}`} className="contact-item" onClick={(e) => initiateCall(e, num)} style={{ cursor: 'pointer', color: '#3b82f6', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <Phone size={14} style={idx > 0 ? { color: '#10b981' } : {}} /> {num}
                                                    </span>
                                                ))}

                                                {/* Email Addresses De-duplication */}
                                                {uniqueEmails.map((email, idx) => (
                                                    <span key={`email-${idx}`} className="contact-item" style={{ color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <Mail size={14} style={{ color: '#f97316' }} /> {email}
                                                    </span>
                                                ))}
                                                {lead.StateName && lead.StateName !== 'N/A' && lead.StateName !== '0' && (
                                                    <span className="contact-item" style={{ color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <MapPin size={14} style={{ color: '#10b981' }} /> {lead.StateName}
                                                    </span>
                                                )}
                                                {lead.CompanyName && lead.CompanyName !== 'N/A' && lead.CompanyName !== '0' && (
                                                    <span className="contact-item" style={{ color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <LayoutGrid size={14} style={{ color: '#8b5cf6' }} /> {lead.CompanyName}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="details-section shadow-sm" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="section-header" style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '12px 20px', fontSize: '13px', fontWeight: '700', color: '#475569' }}>Other Details</div>
                        <div className="section-body" style={{ padding: '0px' }}>
                            {!isEditing ? (
                                <div className="read-only-details" style={{ padding: '20px 25px' }}>
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                                        gap: '12px 40px',
                                        fontSize: '13px'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Source :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.SourceName || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Campaign :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.CampaignName || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Created On :</span>
                                            <span style={{ color: '#4b5563' }}>{formatDisplayDate(basicInfo.CreatedOn)}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Medium :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.MediumName || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Created By :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.CreatedByName || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Resi. Address :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.ResidentialAddress || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Office Address :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.OfficeAddress || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Remarks :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.Remarks || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Where :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.Where || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Latitude :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.Latitude || '-'}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontWeight: '700', color: '#1f2937', minWidth: '110px' }}>Longitude :</span>
                                            <span style={{ color: '#4b5563' }}>{basicInfo.Longitude || '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="edit-details-form" style={{ padding: '20px 25px' }}>
                                    <div className="other-details-summary-grid" style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                        gap: '20px',
                                        fontSize: '13px'
                                    }}>
                                        <div className="field-box">
                                            <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Source</label>
                                            <select
                                                className="edit-select"
                                                value={editForm.Source}
                                                onChange={(e) => setEditForm({ ...editForm, Source: e.target.value })}
                                                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                            >
                                                <option value="">Select Source</option>
                                                {sourceOptions.map((opt, i) => (
                                                    <option key={i} value={opt.Code || opt.Value || opt.SrcmedCampID || opt.Id}>{opt.Text || opt.Name || opt.SrcmedCampName}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="field-box">
                                            <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Medium</label>
                                            <select
                                                className="edit-select"
                                                value={editForm.Medium}
                                                onChange={(e) => setEditForm({ ...editForm, Medium: e.target.value })}
                                                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                            >
                                                <option value="">Select Medium</option>
                                                {mediumOptions.map((opt, i) => (
                                                    <option key={i} value={opt.Code || opt.Value || opt.SrcmedCampID || opt.Id}>{opt.Text || opt.Name || opt.SrcmedCampName}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="field-box" style={{ gridColumn: 'span 2' }}>
                                            <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Campaign</label>
                                            <select
                                                className="edit-select"
                                                value={editForm.Campaign}
                                                onChange={(e) => setEditForm({ ...editForm, Campaign: e.target.value })}
                                                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                            >
                                                <option value="">Select Campaign</option>
                                                {campaignOptions.map((opt, i) => (
                                                    <option key={i} value={opt.Code || opt.Value || opt.SrcmedCampID || opt.Id}>{opt.Text || opt.Name || opt.SrcmedCampName}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px', gridColumn: 'span 2' }}>
                                            <div className="field-box">
                                                <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Resi. Address</label>
                                                <div style={{ position: 'relative' }}>
                                                    <textarea
                                                        className="edit-textarea"
                                                        placeholder="Address"
                                                        value={editForm.ResiAddress}
                                                        onChange={(e) => setEditForm({ ...editForm, ResiAddress: e.target.value })}
                                                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px', minHeight: '80px', resize: 'vertical' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="field-box">
                                                <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Office Address</label>
                                                <div style={{ position: 'relative' }}>
                                                    <textarea
                                                        className="edit-textarea"
                                                        placeholder="Address"
                                                        value={editForm.OfficeAddress}
                                                        onChange={(e) => setEditForm({ ...editForm, OfficeAddress: e.target.value })}
                                                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px', minHeight: '80px', resize: 'vertical' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field-box" style={{ gridColumn: 'span 2' }}>
                                            <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Remark</label>
                                            <div style={{ position: 'relative' }}>
                                                <textarea
                                                    className="edit-textarea"
                                                    placeholder="remark"
                                                    value={editForm.Remarks}
                                                    onChange={(e) => setEditForm({ ...editForm, Remarks: e.target.value })}
                                                    style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px', minHeight: '60px', resize: 'vertical' }}
                                                />
                                            </div>
                                        </div>

                                        <div className="field-box" style={{ gridColumn: 'span 2' }}>
                                            <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Pin code</label>
                                            <input
                                                type="text"
                                                className="edit-input"
                                                placeholder="0"
                                                value={editForm.PinCode || '0'}
                                                onChange={(e) => setEditForm({ ...editForm, PinCode: e.target.value })}
                                                style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', fontSize: '13px' }}
                                            />
                                        </div>
                                        <div className="field-box" style={{ gridColumn: 'span 2' }}>
                                            <label style={{ color: '#64748b', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Enquiry Tags</label>
                                            <div
                                                className="tags-input-container"
                                                style={{ border: '1px solid #e2e8f0', borderRadius: '4px', padding: '6px', minHeight: '38px', display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center', cursor: 'text', background: '#fff' }}
                                                onClick={() => tagInputRef.current?.focus()}
                                            >
                                                {(editForm.EnquiryTags ? String(editForm.EnquiryTags).split(',').filter(t => t.trim()) : []).map((tag, idx) => (
                                                    <div key={idx} style={{ background: '#f3f4f6', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <span style={{ color: '#4b5563' }}>{tag}</span>
                                                        <X
                                                            size={12}
                                                            style={{ cursor: 'pointer', color: '#9ca3af' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const tags = String(editForm.EnquiryTags || '').split(',').filter(t => t.trim());
                                                                tags.splice(idx, 1);
                                                                setEditForm({ ...editForm, EnquiryTags: tags.join(',') });
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                                <input
                                                    ref={tagInputRef}
                                                    type="text"
                                                    placeholder={(editForm.EnquiryTags || "").length === 0 ? "Search tags" : ""}
                                                    value={tagInput}
                                                    onChange={(e) => setTagInput(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
                                                            e.preventDefault();
                                                            const val = tagInput.trim();
                                                            if (val) {
                                                                const currentTags = editForm.EnquiryTags ? String(editForm.EnquiryTags).split(',').map(t => t.trim()).filter(Boolean) : [];
                                                                if (!currentTags.includes(val)) {
                                                                    const newTags = [...currentTags, val].join(',');
                                                                    setEditForm({ ...editForm, EnquiryTags: newTags });
                                                                }
                                                                setTagInput('');
                                                            }
                                                        } else if (e.key === 'Backspace' && !tagInput && editForm.EnquiryTags) {
                                                            const tags = String(editForm.EnquiryTags || '').split(',').filter(t => t.trim());
                                                            tags.pop();
                                                            setEditForm({ ...editForm, EnquiryTags: tags.join(',') });
                                                        }
                                                    }}
                                                    onPaste={(e) => {
                                                        e.preventDefault();
                                                        const pasteData = e.clipboardData.getData('text');
                                                        const pastedTags = pasteData.split(/[,\n]/).map(t => t.trim()).filter(Boolean);
                                                        if (pastedTags.length > 0) {
                                                            const currentTags = editForm.EnquiryTags ? String(editForm.EnquiryTags).split(',').map(t => t.trim()).filter(Boolean) : [];
                                                            const newTagsSet = new Set([...currentTags, ...pastedTags]);
                                                            setEditForm({ ...editForm, EnquiryTags: Array.from(newTagsSet).join(',') });
                                                            setTagInput('');
                                                        }
                                                    }}
                                                    style={{ border: 'none', outline: 'none', flex: 1, minWidth: '100px', fontSize: '13px', background: 'transparent' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div style={{ textAlign: 'right', marginTop: '10px', paddingRight: '25px', paddingBottom: '10px' }}>
                            <span
                                onClick={() => {
                                    if (isEditing) {
                                        setShowMoreDetails(!showMoreDetails);
                                    } else {
                                        setIsFullDetailsOpen(true);
                                    }
                                }}
                                style={{ cursor: 'pointer', color: '#0ea5e9', fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}
                            >
                                {isEditing ? (showMoreDetails ? 'Less..' : 'View More') : 'View More'}
                                {!isEditing && <ChevronRight size={14} />}
                            </span>
                        </div>
                        {showMoreDetails && isEditing && (
                            <div style={{ marginTop: '0px', padding: '0 25px 25px 25px' }}>
                                <div className="expanded-other-details" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                    {customFieldsList.map((item, idx) => renderCustomField(item, idx, true))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="details-section">
                        <div className="details-subheader-v2" style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '0',
                            borderBottom: 'none',
                            gap: '10px'
                        }}>
                            <div className="tabs-container" style={{ borderBottom: 'none', margin: 0, flex: 1, minWidth: '0px', padding: '0' }}>
                                <div className="tabs-list">
                                    {['Activities', 'Calls', 'Whatsapp Chat Log', 'Meetings', 'Physical Appointment', 'Chat', 'Webform'].map(tab => (
                                        <button key={tab} className={`tab-btn ${activeTab === tab ? 'active' : ''}`} onClick={() => setActiveTab(tab)}>{tab}</button>
                                    ))}
                                </div>
                            </div>

                        </div>
                        <div className="tabs-content" style={{ background: '#fff', padding: 0, margin: 0, border: 'none', overflowY: 'auto' }}>
                            {activeTab === 'Activities' && (
                                <div className="activities-tab-content">
                                    <div className="activity-header-sticky" style={{ borderRadius: 0, boxShadow: 'none', top: 0, zIndex: 100, background: '#fff' }}>
                                        <span className="header-title">Enquiry Activities</span>
                                        <span className="activity-count">{activities.length} Events Found</span>
                                    </div>
                                    <div className="activities-timeline-v2">
                                        <div className="timeline-trail-v2"></div>
                                        {isLogLoading ? (
                                            <div className="tab-loader">Loading activities...</div>
                                        ) : (() => {
                                            if (!Array.isArray(activities) || activities.length === 0) {
                                                return (
                                                    <div className="activities-empty">
                                                        No recent activities found.
                                                    </div>
                                                );
                                            }
                                            const filteredActivities = activities.filter(act => {
                                                if (!activitySearchTerm) return true;
                                                const term = activitySearchTerm.toLowerCase();
                                                return (
                                                    (act.EventName || '').toLowerCase().includes(term) ||
                                                    (act.EventDescription || '').toLowerCase().includes(term) ||
                                                    (act.EventDate || '').toLowerCase().includes(term)
                                                );
                                            });

                                            if (filteredActivities.length === 0) {
                                                return (
                                                    <div className="activities-empty">
                                                        No activities matching your search.
                                                    </div>
                                                );
                                            }

                                            return filteredActivities.map((act, idx) => {
                                                const isLeft = idx % 2 === 0;
                                                const lower = (act.EventName || '').toLowerCase();
                                                let icon = <GitBranch />;
                                                let iconClass = 'icon-default';

                                                if (lower.includes('whatsapp')) { icon = <MessageCircle />; iconClass = 'icon-whatsapp'; }
                                                else if (lower.includes('voice') || lower.includes('call')) { icon = <Phone />; iconClass = 'icon-voice'; }
                                                else if (lower.includes('sms')) { icon = <MessageSquare />; iconClass = 'icon-sms'; }
                                                else if (lower.includes('meeting')) { icon = <Calendar />; iconClass = 'icon-meeting'; }

                                                return (
                                                    <div key={idx} className={`timeline-item-v2 ${isLeft ? 'item-left' : 'item-right'}`}>
                                                        <div className="timeline-center-node">
                                                            <span className="node-time-text">Recent</span>
                                                        </div>
                                                        <div className="timeline-branch"></div>
                                                        <div className="timeline-card-v2">
                                                            <div className="timeline-card-header-v2">
                                                                <div className="title-with-icon">
                                                                    <div className={`timeline-card-icon-v2 ${iconClass}`}>
                                                                        {icon}
                                                                    </div>
                                                                    <h4 className="timeline-event-title-v2">{act.EventName}</h4>
                                                                </div>
                                                            </div>
                                                            <div className="timeline-card-body-v2">
                                                                <p className="timeline-desc-v2">{act.EventDescription}</p>
                                                                <div className="timeline-timestamp-v2">{formatActivityDate(act.EventDate)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            });
                                        })()}
                                    </div>
                                </div>
                            )}
                            {activeTab === 'Calls' && (
                                <div className="modern-tab-section">
                                    <div className="activity-header-sticky">
                                        <span className="header-title">Call History</span>
                                        <span className="activity-count">{callLogs.length} Records Found</span>
                                    </div>
                                    <div className="logs-list-v2" style={{ padding: '20px' }}>
                                        {isLogLoading ? (
                                            <div className="tab-loader">Loading logs...</div>
                                        ) : callLogs.length > 0 ? (
                                            callLogs.map((c, i) => (
                                                <div key={i} className="modern-record-card">
                                                    <div className="record-header-v2">
                                                        <div className="record-type-pill call">Call Record</div>
                                                        <div className="timeline-timestamp-v2">{c.CallDate}</div>
                                                    </div>
                                                    <div className="record-body-v2">
                                                        <div className="record-info-item">
                                                            <label>Duration</label>
                                                            <span>{c.Duration || 'N/A'}</span>
                                                        </div>
                                                        <div className="record-info-item">
                                                            <label>Result</label>
                                                            <span>{c.CallResult || 'N/A'}</span>
                                                        </div>
                                                        <div className="record-info-item">
                                                            <label>Agent</label>
                                                            <span>{c.AgentName || 'System'}</span>
                                                        </div>
                                                    </div>
                                                    {c.RecordingUrl && (
                                                        <div className="record-player-v2">
                                                            <audio controls src={c.RecordingUrl} />
                                                        </div>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="activities-empty">No call logs found.</div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {activeTab === 'Whatsapp Chat Log' && (
                                <div className="modern-tab-section">
                                    <div className="activity-header-sticky">
                                        <span className="header-title">WhatsApp Chat Log</span>
                                        <span className="activity-count">{waChatLogs.length} Messages</span>
                                    </div>
                                    <div className="logs-list-v2">
                                        {isLogLoading ? (
                                            <div className="tab-loader">Loading logs...</div>
                                        ) : waChatLogs.length > 0 ? waChatLogs.map((w, i) => (
                                            <div key={i} className="modern-record-card" style={{ padding: '15px', borderLeft: '4px solid #10b981' }}>
                                                <div className="record-header-v2" style={{ marginBottom: '10px' }}>
                                                    <div className="record-type-pill" style={{ background: '#dcfce7', color: '#166534' }}>Incoming</div>
                                                    <div className="timeline-timestamp-v2">{w.MessageDate}</div>
                                                </div>
                                                <div className="log-msg" style={{ fontSize: '14px', color: '#1e293b', lineHeight: '1.5' }}>{w.Message}</div>
                                            </div>
                                        )) : (
                                            <div className="activities-empty">No logs found.</div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {activeTab === 'Meetings' && (
                                <div className="meetings-tab-container">
                                    <div className="tab-sub-navigation">
                                        <button
                                            className={`sub-tab-btn ${meetingSubTab === 'Upcoming' ? 'active' : ''}`}
                                            onClick={() => setMeetingSubTab('Upcoming')}
                                        >
                                            Current/Upcoming
                                        </button>
                                        <button
                                            className={`sub-tab-btn ${meetingSubTab === 'Past' ? 'active' : ''}`}
                                            onClick={() => setMeetingSubTab('Past')}
                                        >
                                            Past
                                        </button>
                                    </div>

                                    <div className="meeting-list-content">
                                        {isLogLoading ? (
                                            <div className="no-data-msg">Loading meetings...</div>
                                        ) : (
                                            <>
                                                {meetingSubTab === 'Upcoming' ? (
                                                    <div className="meeting-cards-grid">
                                                        {upcomingMeetings.length > 0 ? upcomingMeetings.map((meet, idx) => (
                                                            <div key={meet.MeetID || idx} className="meeting-modern-card">
                                                                <div className="meeting-card-main">
                                                                    <div className="meeting-card-left">
                                                                        <div className="meeting-avatar">
                                                                            {getAvatarContent(meet.Meetname, '')}
                                                                        </div>
                                                                        <div className="meeting-primary-info">
                                                                            <h4 className="meeting-title">{meet.Meetname || 'Untitled Meeting'}</h4>
                                                                            <span className="meeting-host-email">{meet.Host || 'No host info'}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="meeting-card-middle">
                                                                        <div className="meeting-meta-row">
                                                                            <Calendar size={14} />
                                                                            <span>{meet.MeetStartDate} {meet.MeetStartTime}</span>
                                                                        </div>
                                                                        <div className="meeting-meta-row">
                                                                            <Clock size={14} />
                                                                            <span>Duration: {meet.Duration} mins</span>
                                                                        </div>
                                                                        {meet.StartInMinutes && (
                                                                            <div className="meeting-time-badge">
                                                                                Started In {Math.floor(meet.StartInMinutes / 60)} Hours {meet.StartInMinutes % 60} mins
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="meeting-card-right">
                                                                        <div className="meeting-status-group">
                                                                            <label className="meeting-switch">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={meet.Isactive === "True" || meet.Isactive === true}
                                                                                    readOnly
                                                                                />
                                                                                <span className="meeting-slider"></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="meeting-action-btns">
                                                                            <button
                                                                                className="meeting-btn-start"
                                                                                onClick={() => meet.JoinLink && window.open(meet.JoinLink, '_blank')}
                                                                                disabled={!meet.JoinLink}
                                                                            >
                                                                                Start
                                                                            </button>
                                                                            <div className="meeting-menu-wrapper">
                                                                                <button
                                                                                    className="meeting-btn-more"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setOpenMenuId(openMenuId === meet.MeetID ? null : meet.MeetID);
                                                                                    }}
                                                                                >
                                                                                    <MoreHorizontal size={18} />
                                                                                </button>
                                                                                {openMenuId === meet.MeetID && (
                                                                                    <div className="meeting-dropdown-menu">
                                                                                        <div className="menu-arrow"></div>
                                                                                        <button className="menu-item">
                                                                                            <Copy size={14} />
                                                                                            <span>Duplicate</span>
                                                                                        </button>
                                                                                        <button className="menu-item">
                                                                                            <Pencil size={14} />
                                                                                            <span>Edit meeting</span>
                                                                                        </button>
                                                                                        <button className="menu-item">
                                                                                            <RotateCcw size={14} />
                                                                                            <span>Reschedule</span>
                                                                                        </button>
                                                                                        <button className="menu-item">
                                                                                            <Trash2 size={14} />
                                                                                            <span>Cancel</span>
                                                                                        </button>
                                                                                        <button className="menu-item">
                                                                                            <Link size={14} />
                                                                                            <span>Copy Link</span>
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )) : <div className="no-data-msg">No upcoming meetings scheduled</div>}
                                                    </div>
                                                ) : (
                                                    <div className="meeting-cards-grid">
                                                        {pastMeetings.length > 0 ? pastMeetings.map((meet, idx) => (
                                                            <div key={meet.MeetID || idx} className="meeting-modern-card past-meeting">
                                                                <div className="meeting-card-main">
                                                                    <div className="meeting-card-left">
                                                                        <div className="meeting-avatar past">
                                                                            <Video size={20} color="#94a3b8" />
                                                                        </div>
                                                                        <div className="meeting-primary-info">
                                                                            <h4 className="meeting-title">{meet.Meetname || 'Past Meeting'}</h4>
                                                                            <span className="meeting-host-email">{meet.MeetStartDate} | {meet.MeetOutcome || 'No outcome'}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="meeting-card-right">
                                                                        <button
                                                                            className="meeting-btn-recording"
                                                                            onClick={() => meet.JoinLink && window.open(meet.JoinLink, '_blank')}
                                                                        >
                                                                            View Recording
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )) : <div className="no-data-msg">No past meetings found</div>}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                            {activeTab === 'Physical Appointment' && (
                                <div className="modern-tab-section">
                                    <div className="activity-header-sticky">
                                        <span className="header-title">Physical Appointments</span>
                                        <span className="activity-count">{physicalAppointments.length} Records Found</span>
                                    </div>
                                    <div className="tab-content-inner">
                                        {isPhysicalApptLoading ? (
                                            <div className="tab-loader">Loading appointments...</div>
                                        ) : (
                                            <table className="followup-modern-table">
                                                <thead>
                                                    <tr>
                                                        <th>Details</th>
                                                        <th>Owner Detail</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {physicalAppointments.length > 0 ? physicalAppointments.map((appt, idx) => (
                                                        <tr key={idx}>
                                                            <td style={{ fontWeight: 700 }}>{appt.Details || appt.Subject || appt.EventDescription || 'No Details'}</td>
                                                            <td>{appt.OwnerDetail || appt.PersonName || appt.CreatedBy || 'N/A'}</td>
                                                            <td>
                                                                <span className="record-type-pill" style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '4px', fontSize: '11px' }}>
                                                                    {appt.Status || appt.EventName || 'N/A'}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="3" style={{ textAlign: 'center', color: '#94a3b8', padding: '20px' }}>No physical appointments found.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            )}
                            {activeTab === 'Chat' && (
                                <div className="modern-tab-section">
                                    <div className="activity-header-sticky">
                                        <span className="header-title">Chat History</span>
                                        <span className="activity-count">{chatLogs.length} Messages</span>
                                    </div>
                                    <div className="logs-list-v2 tab-content-inner">
                                        {isLogLoading ? (
                                            <div className="tab-loader">Loading logs...</div>
                                        ) : chatLogs.length > 0 ? chatLogs.map((c, i) => (
                                            <div key={i} className="modern-record-card" style={{ padding: '15px' }}>
                                                <div className="record-header-v2" style={{ marginBottom: '10px' }}>
                                                    <div className="record-type-pill" style={{ background: '#f1f5f9', color: '#475569' }}>Agent: {c.AgentName || 'N/A'}</div>
                                                    <div className="timeline-timestamp-v2">{c.ChatDate}</div>
                                                </div>
                                                <div className="log-msg" style={{ fontSize: '14px', color: '#1e293b', lineHeight: '1.5' }}>{c.Message}</div>
                                            </div>
                                        )) : (
                                            <div className="activities-empty">No chat logs found.</div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {activeTab === 'Webform' && (
                                <div className="modern-tab-section">
                                    <div className="activity-header-sticky">
                                        <span className="header-title">Webform Submissions</span>
                                        <span className="activity-count">{webforms.length} Entries Found</span>
                                    </div>
                                    <div className="tab-content-inner">
                                        {isWebformLoading ? (
                                            <div className="tab-loader">Loading webforms...</div>
                                        ) : (
                                            <table className="followup-modern-table">
                                                <thead>
                                                    <tr>
                                                        <th>Form Name</th>
                                                        <th>Entry Date</th>
                                                        <th>Remarks</th>
                                                        <th>Form Data</th>
                                                        <th>Agent</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {webforms.length > 0 ? webforms.map((wf, idx) => (
                                                        <tr key={idx}>
                                                            <td style={{ fontWeight: 700 }}>{wf.FormName || wf.Subject || ''}</td>
                                                            <td className="timeline-timestamp-v2">{wf.EntryDate || wf.CreatedOn || ''}</td>
                                                            <td>{wf.Remarks || ''}</td>
                                                            <td style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {wf.FormData || (wf.Data ? JSON.stringify(wf.Data) : '')}
                                                            </td>
                                                            <td>{wf.Agent || wf.CreatedByName || ''}</td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="5" style={{ textAlign: 'center', color: '#94a3b8', padding: '20px' }}>No webform submissions found.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="lead-details-sidebar">
                    {activeSidebarAction === 'Centralized' ? (
                        renderCentralizedPanel()
                    ) : activeSidebarAction === 'CreateMeeting' ? (
                        renderCreateMeetingPanel()

                    ) : (
                        <>
                            {(() => {
                                const conflictCount = conflictLeads.length;
                                return crmOperationPerms?.MergeLead !== false ? (
                                    <button
                                        className="sidebar-action-btn"
                                        onClick={handleOpenMergeUI}
                                        style={{ backgroundColor: conflictCount > 0 ? '#fff7ed' : 'transparent', border: conflictCount > 0 ? '1px solid #fed7aa' : '1px solid #e2e8f0' }}
                                    >
                                        <GitBranch size={16} className="sidebar-icon" style={{ color: '#d97706' }} />
                                        Add or Merge lead {conflictCount > 0 && <span style={{ marginLeft: '4px', backgroundColor: '#f97316', color: 'white', padding: '1px 6px', borderRadius: '10px', fontSize: '10px' }}>{conflictCount}</span>}
                                    </button>
                                ) : null;
                            })()}
                            {crmOperationPerms?.SendSms !== false && <button className="sidebar-action-btn" onClick={() => handleSidebarActionClick('sms')}><MessageSquare size={16} className="sidebar-icon" /> SMS</button>}
                            {crmOperationPerms?.SendMail !== false && <button className="sidebar-action-btn" onClick={() => handleSidebarActionClick('mail')}><Mail size={16} className="sidebar-icon" /> Mail</button>}
                            {isOpenRecord && crmOperationPerms?.SendWhatsapp !== false && (
                                <button className="sidebar-action-btn" onClick={() => handleSidebarActionClick('whatsapp')}><MessageCircle size={16} className="sidebar-icon" style={{ color: '#25D366' }} /> WhatsApp</button>
                            )}
                            {crmOperationPerms?.SendVoice !== false && <button className="sidebar-action-btn" onClick={() => handleSidebarActionClick('voice')}><Mic size={16} className="sidebar-icon" /> Send Voice</button>}
                            {crmOperationPerms?.AddAppointment !== false && <button className="sidebar-action-btn" onClick={() => handleSidebarActionClick('meeting')}><Users size={16} className="sidebar-icon" /> Create Meeting</button>}
                            {crmOperationPerms?.AddAppointment !== false && <button className="sidebar-action-btn" onClick={() => handleSidebarActionClick('appointment')}><UserPlus size={16} className="sidebar-icon" /> Add Physical Appointment</button>}
                        </>
                    )}

                </div>
            </div>

            {hoveredLeadId && (
                <div className="scorecard-hover-popup" style={{ position: 'absolute', top: `${popupPosition.top}px`, left: `${popupPosition.left}px`, transform: 'translate(-50%, -100%)', zIndex: 10000, pointerEvents: 'none' }}>
                    <div className="scorecard-glass-card">
                        {isScorecardLoading ? (
                            <div className="scorecard-loading-state"><div className="scorecard-spinner"></div><span>Loading details...</span></div>
                        ) : hoverScoreRec ? (
                            <div className="scorecard-content">
                                <div className="scorecard-header">
                                    <h4 className="scorecard-person-name">{hoverScoreRec.PersonName || 'Unknown Lead'}</h4>
                                    <p className="scorecard-company-name">{hoverScoreRec.CompanyName || 'No Company'}</p>
                                </div>
                                <div className="scorecard-lead-since">Lead since {hoverScoreRec.CreatedOn || ''}</div>
                                <div className="scorecard-main-content">
                                    <div className="scorecard-circle-badge"><span className="score-value">{hoverScoreRec.CurrentScore || '0'}</span></div>
                                    <div className="scorecard-factors-list">
                                        {hoverScoreRec.Top3ScoringFactors ? String(hoverScoreRec.Top3ScoringFactors).split('#').filter(f => f.trim()).map((factor, i) => (
                                            <div key={i} className="scorecard-factor-item">
                                                <span className="scorecard-factor-icon" style={{ color: String(hoverScoreRec.Top3_ProfileLoss).split('#')[i] === 'Green_Up' ? '#27ae60' : '#ef4444' }}>
                                                    {String(hoverScoreRec.Top3_ProfileLoss).split('#')[i] === 'Green_Up' ? '▲' : '▼'}
                                                </span>
                                                <span>{factor}</span>
                                            </div>
                                        )) : <div className="scorecard-empty-state">No factors</div>}
                                    </div>
                                </div>
                            </div>
                        ) : <div className="scorecard-empty-state">No data available</div>}
                    </div>
                </div>
            )}
            {isMergeUIOpen && (
                <div className="merge-v3-overlay">
                    <div className="merge-v3-container">
                        <div className="merge-v3-header">
                            <div className="merge-v3-header-left">
                                <button className="merge-v3-back-btn" onClick={() => setIsMergeUIOpen(false)}>
                                    <ChevronLeft size={20} />
                                </button>
                                <h2 className="merge-v3-title">{mergeStep === 'merge' ? 'Merge Enquiry to Lead' : 'Add Follow up'}</h2>
                            </div>
                            <div className="merge-v3-header-right">
                                {/* Controls moved to grid for better alignment */}
                            </div>
                        </div>

                        {mergeStep === 'merge' && (
                            <div className="merge-v3-header-grid">
                                <div className="merge-v3-header-slot"></div>
                                <div className="merge-v3-header-slot middle">
                                    <div className="merge-v3-enquiry-badge-column">
                                        Enquiry ID. <span className="id-pill">{basicInfo?.EnquiryId || leadId}</span>
                                    </div>
                                    <select
                                        className="merge-v3-lead-select-column"
                                        value={selectedConflictId}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setSelectedConflictId(val);
                                            if (val) fetchLeadCustomData(val);

                                            const selections = {};
                                            MERGE_FIELDS.forEach(f => selections[f.key] = 'enquiry');
                                            setMergeFieldSelections(selections);
                                        }}
                                    >
                                        {conflictLeads.length > 0 ? (
                                            conflictLeads.map(l => (
                                                <option key={l.Value} value={l.Value}>{l.Text}</option>
                                            ))
                                        ) : (
                                            <option value="">No Conflicts Found</option>
                                        )}
                                    </select>
                                </div>
                                <div className="merge-v3-header-slot"></div>
                            </div>
                        )}

                        <div className="merge-v3-body">
                            {mergeStep === 'merge' ? (
                                <div className="merge-v3-columns-grid">
                                    {/* Enquiry Column */}
                                    <div className="merge-v3-column column-enquiry">
                                        <div className="merge-v3-column-top-profile">
                                            <div className="merge-v3-profile-photo text-avatar">
                                                {getAvatarContent(getEnquiryFieldValue('PersonName'), getEnquiryFieldValue('MobileNo'))}
                                            </div>
                                            <div className="merge-v3-column-label" onClick={() => handleSelectAll('enquiry')}>
                                                <input type="radio" checked={Object.values(mergeFieldSelections).every(s => s === 'enquiry')} readOnly />
                                                <span>Enquiry Details</span>
                                            </div>
                                        </div>
                                        <div className="merge-v3-column-content">
                                            <div className="merge-v3-fields-list">
                                                {MERGE_FIELDS.map(f => {
                                                    const val = getEnquiryFieldValue(f.key);
                                                    const isActive = mergeFieldSelections[f.key] === 'enquiry';
                                                    return (
                                                        <div
                                                            key={f.key}
                                                            className={`merge-v3-field-row ${isActive ? 'active' : ''}`}
                                                            onClick={() => handleMergeFieldSelect(f.key, 'enquiry', val === '-' ? '' : val)}
                                                        >
                                                            <div className="merge-v3-radio-box">
                                                                <input
                                                                    type="radio"
                                                                    name={`merge_${f.key}`}
                                                                    checked={isActive}
                                                                    onChange={() => { }}
                                                                    className="red-radio"
                                                                />
                                                            </div>
                                                            <div className="merge-v3-field-info">
                                                                <span className="merge-v3-field-label">{f.label}</span>
                                                                <span className="merge-v3-field-value">{val}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Conflict/Lead Column */}
                                    <div className="merge-v3-column column-lead">
                                        <div className="merge-v3-column-top-profile">
                                            <div className="merge-v3-profile-photo text-avatar">
                                                {getAvatarContent(selectedMergeLead?.PersonName, selectedMergeLead?.Mobile)}
                                            </div>
                                            <div className="merge-v3-column-label" onClick={() => handleSelectAll('lead')}>
                                                <input type="radio" checked={Object.values(mergeFieldSelections).every(s => s === 'lead')} readOnly className="red-header-radio" />
                                                <span>Lead Details</span>
                                            </div>
                                            {selectedMergeLead && <div className="merge-v3-assigned-to">Assigned To: {selectedMergeLead.AssignedTo || ''}</div>}
                                        </div>
                                        <div className="merge-v3-column-content">
                                            <div className="merge-v3-fields-list">
                                                {MERGE_FIELDS.map(f => {
                                                    const val = selectedMergeLead?.[f.key] || '-';
                                                    const isActive = mergeFieldSelections[f.key] === 'lead';
                                                    return (
                                                        <div
                                                            key={f.key}
                                                            className={`merge-v3-field-row ${isActive ? 'active' : ''}`}
                                                            onClick={() => handleMergeFieldSelect(f.key, 'lead', val === '-' ? '' : val)}
                                                        >
                                                            <div className="merge-v3-radio-box">
                                                                <input
                                                                    type="radio"
                                                                    name={`merge_${f.key}`}
                                                                    checked={isActive}
                                                                    onChange={() => { }}
                                                                />
                                                            </div>
                                                            <div className="merge-v3-field-info">
                                                                <span className="merge-v3-field-label">{f.label}</span>
                                                                <span className="merge-v3-field-value">{val}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Result/Merge Column */}
                                    <div className="merge-v3-column column-merge">
                                        <div className="merge-v3-column-top-profile">
                                            <div className="merge-v3-profile-photo result text-avatar">
                                                {getAvatarContent(mergeForm.PersonName, mergeForm.Mobile)}
                                            </div>
                                            <div className="merge-v3-column-label no-ptr">
                                                <span>Merge Details</span>
                                            </div>
                                        </div>
                                        <div className="merge-v3-column-content">
                                            <div className="merge-v3-fields-list">
                                                {MERGE_FIELDS.map(f => (
                                                    <div key={f.key} className="merge-v3-field-row result">
                                                        <div className="merge-v3-field-info result-field-info">
                                                            <input
                                                                type="text"
                                                                className="merge-v3-result-input"
                                                                placeholder={f.label}
                                                                value={mergeForm[f.key] || ''}
                                                                onChange={(e) => setMergeForm({ ...mergeForm, [f.key]: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="merge-v3-followup-form-container">
                                    <div className="merge-v3-followup-summary-card">
                                        <div className="summary-left">
                                            <div className="summary-avatar text-avatar">
                                                {getAvatarContent(mergeForm.PersonName, mergeForm.Mobile)}
                                            </div>
                                        </div>
                                        <div className="summary-right">
                                            <h4 className="summary-name">{mergeForm.PersonName || 'No Name'}</h4>
                                            <div className="summary-details">
                                                <div className="summary-detail-item"><Phone size={14} /> {mergeForm.Mobile || 'No Mobile'}</div>
                                                <div className="summary-detail-item"><Mail size={14} /> {mergeForm.Email || 'No Email'}</div>
                                                <div className="summary-detail-item"><MapPin size={14} /> {mergeForm.City || '-'}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="merge-v3-followup-form-body">
                                        <div className="followup-header-row">
                                            <h3 className="followup-form-title">Add Follow up</h3>
                                            {basicInfo?.EnquiryId && (
                                                <div className="followup-enquiry-id">
                                                    ID: {basicInfo.EnquiryId}
                                                </div>
                                            )}
                                        </div>

                                        <div className="followup-grid">
                                            <div className="followup-field-row">
                                                <label>Follow up Status</label>
                                                <div className="field-input">
                                                    <select
                                                        value={localFollowupData.Status}
                                                        onChange={(e) => setLocalFollowupData({ ...localFollowupData, Status: e.target.value })}
                                                    >
                                                        {followupStatuses.map(s => (
                                                            <option key={s.Value} value={s.Value}>{s.Text}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {!isNegativeStatus() && (
                                                <>
                                                    <div className="followup-field-row">
                                                        <label>Assign To</label>
                                                        <div className="field-input">
                                                            <select
                                                                value={localFollowupData.AssignedTo}
                                                                onChange={(e) => setLocalFollowupData({ ...localFollowupData, AssignedTo: e.target.value })}
                                                            >
                                                                {assignedToOptions.map(u => (
                                                                    <option key={u.Value} value={u.Value}>{u.Text}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="followup-field-row">
                                                        <label>Next Status Date</label>
                                                        <div className="field-input icon-input premium-date-wrapper" style={{ position: 'relative' }}>
                                                            <Calendar size={16} className="input-icon-left" style={{ cursor: 'pointer' }} onClick={() => followupDateRef.current?.showPicker()} />
                                                            <input
                                                                type="text"
                                                                value={formatDisplayDate(localFollowupData.Date)}
                                                                placeholder="DD-MMM-YYYY"
                                                                onClick={() => followupDateRef.current?.showPicker()}
                                                                readOnly
                                                                style={{ cursor: 'pointer', paddingLeft: '45px' }}
                                                            />
                                                            <input
                                                                ref={followupDateRef}
                                                                type="date"
                                                                style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', bottom: 0, left: 0, width: '100%' }}
                                                                value={localFollowupData.Date}
                                                                onChange={(e) => setLocalFollowupData({ ...localFollowupData, Date: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="followup-field-row">
                                                        <label>Time</label>
                                                        <div className="field-input icon-input">
                                                            <Clock size={16} className="input-icon" />
                                                            <input
                                                                type="time"
                                                                value={localFollowupData.Time}
                                                                onChange={(e) => setLocalFollowupData({ ...localFollowupData, Time: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="followup-field-row">
                                                        <label>Choose Products</label>
                                                        <div className="field-input products-input">
                                                            <div className="products-chips">
                                                                {selectedLocalProducts.map(p => (
                                                                    <span key={p.Value} className="product-chip">
                                                                        {p.Text}
                                                                        <button onClick={() => handleRemoveProduct(p.Value)}><X size={12} /></button>
                                                                    </span>
                                                                ))}
                                                            </div>
                                                            <input
                                                                type="text"
                                                                placeholder="Enter product"
                                                                value={productSearchTerm}
                                                                onChange={(e) => handleProductSearch(e.target.value)}
                                                            />
                                                            {showProductDropdown && suggestedProducts.length > 0 && (
                                                                <div className="products-dropdown">
                                                                    {suggestedProducts.map(p => (
                                                                        <div key={p.Value} className="product-option" onClick={() => handleProductSelect(p)}>
                                                                            {p.Text}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            <div className="followup-field-row">
                                                <label>Remarks</label>
                                                <div className="field-input">
                                                    <textarea
                                                        placeholder="Enter followup remarks..."
                                                        value={localFollowupData.Remarks}
                                                        onChange={(e) => setLocalFollowupData({ ...localFollowupData, Remarks: e.target.value })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="followup-field-row">
                                                <label>Followup Type</label>
                                                <div className="field-input checkbox-input">
                                                    <input
                                                        type="checkbox"
                                                        id="reassign-chk-merge"
                                                        checked={localFollowupData.IsReAssign}
                                                        onChange={(e) => setLocalFollowupData({ ...localFollowupData, IsReAssign: e.target.checked })}
                                                    />
                                                    <label htmlFor="reassign-chk-merge">Re-Assign</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="merge-v3-footer">
                            <button
                                className="merge-v3-cancel-btn"
                                onClick={() => {
                                    if (mergeStep === 'followup') {
                                        setMergeStep('merge');
                                    } else {
                                        setIsMergeUIOpen(false);
                                    }
                                }}
                                disabled={isMerging}
                            >
                                {mergeStep === 'followup' ? 'Back' : 'Cancel'}
                            </button>
                            <div className="merge-v3-footer-actions">
                                {mergeStep === 'merge' ? (
                                    <>
                                        <button
                                            className="merge-v3-submit-btn"
                                            onClick={() => handleMergeToLead(false)}
                                            disabled={isMerging}
                                            style={{ width: '100%' }}
                                        >
                                            {isMerging ? 'Merging...' : 'Merge to Lead'}
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        className="merge-v3-submit-btn"
                                        onClick={handleSaveMergeFollowup}
                                        disabled={isMerging}
                                    >
                                        {isMerging ? 'Saving...' : 'Save'}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isScheduleCallOpen && (
                <Enquiryoperations
                    isOpen={isScheduleCallOpen}
                    onClose={() => setIsScheduleCallOpen(false)}
                    enquiryId={leadId}
                    Token={TOKEN}
                    LoggedUserId={getSession()?.userId}
                    SERVICE_AZURE_URL={SERVICE_AZURE_URL}
                    Get_Call_Schedule_Action={Get_Call_Schedule_Action}
                    Get_Mobile_Number={Get_Mobile_Number}
                />
            )}

            {/* Delete Confirmation Modal */}
            <DeleteConfirmModal
                show={showDeleteConfirm}
                onConfirm={handleDelete}
                onCancel={() => setShowDeleteConfirm(false)}
            />

            {/* Full Details Modal */}
            {isFullDetailsOpen && (
                <div className="custom-details-modal-overlay">
                    <div className="custom-details-modal-container" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                        <div className="custom-modal-header">
                            <div className="custom-modal-header-left">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '12px' }}>
                                    <h3 className="custom-modal-title">Enquiry Details</h3>
                                    <button className="custom-modal-close-btn" onClick={() => setIsFullDetailsOpen(false)} style={{ margin: 0, position: 'static' }}>
                                        <X size={20} />
                                    </button>
                                </div>
                                <div className="modal-profile-header" style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <div className="modal-avatar" style={{ position: 'relative' }}>
                                            <div className="avatar-initials">{getInitials(lead.PersonName)}</div>
                                            {/* Score Badge in Modal */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-4px',
                                                    left: '-4px',
                                                    backgroundColor: '#3b82f6',
                                                    color: '#fff',
                                                    borderRadius: '50%',
                                                    width: '18px',
                                                    height: '18px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '9px',
                                                    fontWeight: 'bold',
                                                    border: '1.5px solid #fff',
                                                    zIndex: 2
                                                }}
                                            >
                                                {lead.CurrentScore || '0'}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                            <div className="modal-lead-name-text">{lead.PersonName}</div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span className="lead-no-badge-modern-v2" style={{ backgroundColor: '#22c55e', color: '#fff', borderRadius: '4px', padding: '1px 8px', fontSize: '11px', fontWeight: '700' }}>
                                                    {lead.LeadNo}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="custom-modal-body" style={{ overflowY: 'auto', flex: 1 }}>
                            <h4 className="modal-inner-heading">Basic Information</h4>
                            <div className="dynamic-details-grid-columns" style={{ marginBottom: '30px' }}>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Mobile :</div><div className="field-value" style={{ color: '#0f172a' }}>{uniqueMobiles.length > 0 ? uniqueMobiles.join(', ') : '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Email :</div><div className="field-value" style={{ color: '#0f172a' }}>{uniqueEmails.length > 0 ? uniqueEmails.join(', ') : '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Country :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.Country || basicInfo.Country || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>State :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.State || basicInfo.State || lead.StateName || basicInfo.StateName || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>City :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.City || basicInfo.City || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Source :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.SourceName || basicInfo.SourceName || lead.Source || basicInfo.Source || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Medium :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.MediumName || basicInfo.MediumName || lead.Medium || basicInfo.Medium || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Campaign :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.CampaignName || basicInfo.CampaignName || lead.Campaign || basicInfo.Campaign || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Created On :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.CreatedDate || basicInfo.CreatedDate || lead.CreatedOn || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Created By :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.CreatedByName || basicInfo.CreatedByName || lead.CreatedBy || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Last Updated :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.LastUpdatedOn || basicInfo.LastUpdatedOn || '-'}</div></div>
                            </div>

                            <h4 className="modal-inner-heading">Other Details</h4>
                            <div className="dynamic-details-grid-columns">
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Resi. Address :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.ResidentialAddress || basicInfo.ResidentialAddress || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Office Address :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.OfficeAddress || basicInfo.OfficeAddress || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Remarks :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.Remarks || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Where :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.Where || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Latitude :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.Latitude || '-'}</div></div>
                                <div className="field-row-modern"><div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>Longitude :</div><div className="field-value" style={{ color: '#0f172a' }}>{lead.Longitude || '-'}</div></div>

                                {customFieldsList.length > 0 ? (
                                    customFieldsList.map((item, idx) => {
                                        let val = customFieldsData[item.key] || basicInfo[item.key] || '';
                                        if (!val || val === "N/A" || val === "0") {
                                            const label = item.label || '';
                                            const possibleKeys = [label, label.replace(/\s+/g, '_'), label.replace(/\s+/g, '')];
                                            for (const pk of possibleKeys) {
                                                if (basicInfo[pk] && basicInfo[pk] !== "N/A" && basicInfo[pk] !== "0") {
                                                    val = basicInfo[pk];
                                                    break;
                                                }
                                            }
                                        }

                                        let displayValue = val;
                                        if (item.type === 'checkbox field' || item.key === '11919') {
                                            displayValue = (val === "1" || val === "true" || val === true) ? "Yes" : "No";
                                        } else if (item.type === 'date' && val) {
                                            displayValue = formatDisplayDate(val);
                                        }

                                        return (
                                            <div key={idx} className="field-row-modern">
                                                <div className="field-label" style={{ color: '#1e293b', background: '#f8fafc' }}>{item.label} :</div>
                                                <div className="field-value" style={{ color: '#0f172a' }}>{displayValue && displayValue !== '-' && displayValue !== '0' ? displayValue : ''}</div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div style={{ gridColumn: 'span 2', textAlign: 'center', padding: '20px', color: '#94a3b8', fontSize: '13px' }}>
                                        No other details available
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Alert
                show={alert.show}
                type={alert.type}
                title={alert.title}
                message={alert.message}
                onConfirm={() => setAlert({ ...alert, show: false })}
            />
            {isCallWidgetOpen && callWidgetData && createPortal(
                <CallWidget
                    show={isCallWidgetOpen}
                    onClose={() => {
                        setIsCallWidgetOpen(false);
                        setCallWidgetData(null);
                    }}
                    {...callWidgetData}
                />,
                document.body
            )}
        </div>
    );
};

const DeleteConfirmModal = ({ show, onConfirm, onCancel }) => {
    if (!show) return null;
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, backdropFilter: 'blur(4px)' }}>
            <div style={{ backgroundColor: '#fff', padding: '40px 30px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)' }}>
                <div style={{ width: '80px', height: '80px', borderRadius: '50%', border: '4px solid #fef2f2', backgroundColor: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ef4444', margin: '0 auto 24px' }}>
                    <Trash2 size={40} />
                </div>
                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#334155', marginBottom: '12px' }}>Delete Lead?</h2>
                <p style={{ color: '#64748b', marginBottom: '30px', fontSize: '15px' }}>Are you sure you want to delete this lead? This action cannot be undone.</p>
                <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                    <button
                        onClick={onCancel}
                        style={{ backgroundColor: '#f1f5f9', color: '#64748b', border: 'none', padding: '12px 30px', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        style={{ backgroundColor: '#ef4444', color: '#fff', border: 'none', padding: '12px 30px', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.4)' }}
                    >
                        Yes, Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export { LeadDetails };
export default LeadDetails;


